import {emptySplitApi as api} from './emptyApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        requeueJob: build.query<RequeueJobApiResponse, RequeueJobApiArg>({
            query: (queryArg) => ({
                url: `/api/admin/requeuejob`,
                params: {
                    queuedDataKey: queryArg.queuedDataKey,
                    process: queryArg.process,
                },
            }),
        }),
        getAppDefaults: build.query<
            GetAppDefaultsApiResponse,
            GetAppDefaultsApiArg
        >({
            query: () => ({url: `/api/admin/appdefault`}),
        }),
        getAppDefaultsQuery: build.query<
            GetAppDefaultsQueryApiResponse,
            GetAppDefaultsQueryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/admin/appdefaultquery`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        putAppDefaults: build.mutation<
            PutAppDefaultsApiResponse,
            PutAppDefaultsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/admin/appdefault/${queryArg.parmId}`,
                method: 'PUT',
                body: queryArg.appDefaultVm,
            }),
        }),
        putSecureDefaults: build.mutation<
            PutSecureDefaultsApiResponse,
            PutSecureDefaultsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/admin/securedefault/${queryArg.parmId}`,
                method: 'PUT',
                body: queryArg.secureDefaultVm,
            }),
        }),
        getSecureDefaultsQuery: build.query<
            GetSecureDefaultsQueryApiResponse,
            GetSecureDefaultsQueryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/admin/securedefaultquery`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getWebDefaults: build.query<
            GetWebDefaultsApiResponse,
            GetWebDefaultsApiArg
        >({
            query: () => ({url: `/api/admin/webdefault`}),
        }),
        getInvoicesApprovalPopulationData: build.query<
            GetInvoicesApprovalPopulationDataApiResponse,
            GetInvoicesApprovalPopulationDataApiArg
        >({
            query: () => ({url: `/api/approveinvoices`}),
        }),
        getInvoicesNeedingApproval: build.mutation<
            GetInvoicesNeedingApprovalApiResponse,
            GetInvoicesNeedingApprovalApiArg
        >({
            query: (queryArg) => ({
                url: `/api/approveinvoices/search`,
                method: 'POST',
                body: queryArg.invoiceApprovalOptionsVm,
            }),
        }),
        getMinimalInvoiceDetail: build.query<
            GetMinimalInvoiceDetailApiResponse,
            GetMinimalInvoiceDetailApiArg
        >({
            query: (queryArg) => ({
                url: `/api/approveinvoices/invoicedetail/${queryArg.id}`,
            }),
        }),
        approveInvoices: build.mutation<
            ApproveInvoicesApiResponse,
            ApproveInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/approveinvoices/approve`,
                method: 'POST',
                body: queryArg.approveInvoicesRequestVm,
            }),
        }),
        saveCurrentInvoiceState: build.mutation<
            SaveCurrentInvoiceStateApiResponse,
            SaveCurrentInvoiceStateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/approveinvoices/save`,
                method: 'POST',
                body: queryArg.approveInvoicesRequestVm,
            }),
        }),
        postApiApproveinvoicesFrominvoiceidxs: build.mutation<
            PostApiApproveinvoicesFrominvoiceidxsApiResponse,
            PostApiApproveinvoicesFrominvoiceidxsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/approveinvoices/frominvoiceidxs`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getAllAscChargeCodes: build.query<
            GetAllAscChargeCodesApiResponse,
            GetAllAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascchargecode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createAscChargeCodes: build.mutation<
            CreateAscChargeCodesApiResponse,
            CreateAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascchargecode`,
                method: 'POST',
                body: queryArg.ascChargeCodeVm,
            }),
        }),
        modifyAscChargeCodes: build.mutation<
            ModifyAscChargeCodesApiResponse,
            ModifyAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascchargecode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.ascChargeCodeVm,
            }),
        }),
        deleteAscChargeCodes: build.mutation<
            DeleteAscChargeCodesApiResponse,
            DeleteAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascchargecode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getInvoiceChargeTypes: build.query<
            GetInvoiceChargeTypesApiResponse,
            GetInvoiceChargeTypesApiArg
        >({
            query: () => ({url: `/api/ascchargecode/chargetypes`}),
        }),
        getAllAscRefCodes: build.query<
            GetAllAscRefCodesApiResponse,
            GetAllAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascrefcode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createAscRefCodes: build.mutation<
            CreateAscRefCodesApiResponse,
            CreateAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascrefcode`,
                method: 'POST',
                body: queryArg.ascReferenceCodeVm,
            }),
        }),
        modifyAscRefCodes: build.mutation<
            ModifyAscRefCodesApiResponse,
            ModifyAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascrefcode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.ascReferenceCodeVm,
            }),
        }),
        deleteAscRefCodes: build.mutation<
            DeleteAscRefCodesApiResponse,
            DeleteAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ascrefcode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getGenMiles: build.mutation<GetGenMilesApiResponse, GetGenMilesApiArg>({
            query: (queryArg) => ({
                url: `/api/audit/auditmiles`,
                method: 'POST',
                body: queryArg.auditMilesRequestVm,
            }),
        }),
        login: build.mutation<LoginApiResponse, LoginApiArg>({
            query: (queryArg) => ({
                url: `/api/authentication`,
                method: 'POST',
                body: queryArg.loginVm,
            }),
        }),
        refreshToken: build.query<RefreshTokenApiResponse, RefreshTokenApiArg>({
            query: () => ({url: `/api/authentication`}),
        }),
        loginWithPermissions: build.mutation<
            LoginWithPermissionsApiResponse,
            LoginWithPermissionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/authentication/withpermissions`,
                method: 'POST',
                body: queryArg.loginVm,
            }),
        }),
        refreshWithPermissions: build.query<
            RefreshWithPermissionsApiResponse,
            RefreshWithPermissionsApiArg
        >({
            query: () => ({url: `/api/authentication/withpermissions`}),
        }),
        logOut: build.query<LogOutApiResponse, LogOutApiArg>({
            query: () => ({url: `/api/authentication/logout`}),
        }),
        getMyUser: build.query<GetMyUserApiResponse, GetMyUserApiArg>({
            query: () => ({url: `/api/authentication/getmyuser`}),
        }),
        getAllBankAccounts: build.query<
            GetAllBankAccountsApiResponse,
            GetAllBankAccountsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/bankaccount`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        updateBankAccount: build.mutation<
            UpdateBankAccountApiResponse,
            UpdateBankAccountApiArg
        >({
            query: (queryArg) => ({
                url: `/api/bankaccount`,
                method: 'PUT',
                body: queryArg.bankAccountChangeVm,
            }),
        }),
        getBillToById: build.query<
            GetBillToByIdApiResponse,
            GetBillToByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/billto/${queryArg.id}`}),
        }),
        getDataEntryAscRefCodes: build.query<
            GetDataEntryAscRefCodesApiResponse,
            GetDataEntryAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/${queryArg.id}/dataentryascrefcodes/${queryArg.carrierId}`,
            }),
        }),
        getAllBillTo: build.query<GetAllBillToApiResponse, GetAllBillToApiArg>({
            query: () => ({url: `/api/billto`}),
        }),
        getBillToForDisplay: build.query<
            GetBillToForDisplayApiResponse,
            GetBillToForDisplayApiArg
        >({
            query: () => ({url: `/api/billto/dropdown`}),
        }),
        getUserCustomers: build.query<
            GetUserCustomersApiResponse,
            GetUserCustomersApiArg
        >({
            query: () => ({url: `/api/billto/user`}),
        }),
        getCentralSaltBillTos: build.query<
            GetCentralSaltBillTosApiResponse,
            GetCentralSaltBillTosApiArg
        >({
            query: () => ({url: `/api/billto/centralsaltdropdown`}),
        }),
        getAllBillTosForDisplay: build.query<
            GetAllBillTosForDisplayApiResponse,
            GetAllBillTosForDisplayApiArg
        >({
            query: () => ({url: `/api/billto/alldropdown`}),
        }),
        getActiveBillTosForDisplay: build.query<
            GetActiveBillTosForDisplayApiResponse,
            GetActiveBillTosForDisplayApiArg
        >({
            query: () => ({url: `/api/billto/activedropdown`}),
        }),
        getCustomerById: build.query<
            GetCustomerByIdApiResponse,
            GetCustomerByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin/${queryArg.customerId}`,
            }),
        }),
        modifyCustomers: build.mutation<
            ModifyCustomersApiResponse,
            ModifyCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin/${queryArg.customerId}`,
                method: 'PUT',
                body: queryArg.billToVm,
            }),
        }),
        deleteCustomers: build.mutation<
            DeleteCustomersApiResponse,
            DeleteCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin/${queryArg.customerId}`,
                method: 'DELETE',
            }),
        }),
        getAllCustomers: build.query<
            GetAllCustomersApiResponse,
            GetAllCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCustomers: build.mutation<
            CreateCustomersApiResponse,
            CreateCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin`,
                method: 'POST',
                body: queryArg.billToVm,
            }),
        }),
        getParentCustomers: build.query<
            GetParentCustomersApiResponse,
            GetParentCustomersApiArg
        >({
            query: () => ({url: `/api/billto/parent`}),
        }),
        activateCustomers: build.mutation<
            ActivateCustomersApiResponse,
            ActivateCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billto/admin/${queryArg.customerId}/active`,
                method: 'PUT',
                body: queryArg.billToActiveVm,
            }),
        }),
        getFeeInvoiceData: build.query<
            GetFeeInvoiceDataApiResponse,
            GetFeeInvoiceDataApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtofeeinvoice/${queryArg.customerId}`,
            }),
        }),
        setFeeInvoiceData: build.mutation<
            SetFeeInvoiceDataApiResponse,
            SetFeeInvoiceDataApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtofeeinvoice`,
                method: 'PUT',
                body: queryArg.billToFeeInvoiceVm,
            }),
        }),
        getModeDefaultsByCustomer: build.query<
            GetModeDefaultsByCustomerApiResponse,
            GetModeDefaultsByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtomodedefault/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createBillToModeDefault: build.mutation<
            CreateBillToModeDefaultApiResponse,
            CreateBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtomodedefault`,
                method: 'POST',
                body: queryArg.billToModeDefaultVm,
            }),
        }),
        modifyBillToModeDefault: build.mutation<
            ModifyBillToModeDefaultApiResponse,
            ModifyBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtomodedefault/${queryArg.defaultId}`,
                method: 'PUT',
                body: queryArg.billToModeDefaultVm,
            }),
        }),
        deleteBillToModeDefault: build.mutation<
            DeleteBillToModeDefaultApiResponse,
            DeleteBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/billtomodedefault/${queryArg.defaultId}`,
                method: 'DELETE',
            }),
        }),
        getGlRules: build.query<GetGlRulesApiResponse, GetGlRulesApiArg>({
            query: (queryArg) => ({
                url: `/api/btaccountrules/${queryArg.customerId}`,
            }),
        }),
        getGlCodingPreview: build.query<
            GetGlCodingPreviewApiResponse,
            GetGlCodingPreviewApiArg
        >({
            query: (queryArg) => ({
                url: `/api/btaccountrules/preview/${queryArg.customerId}/${queryArg.createDate}`,
            }),
        }),
        getGlOverwritePreview: build.query<
            GetGlOverwritePreviewApiResponse,
            GetGlOverwritePreviewApiArg
        >({
            query: (queryArg) => ({
                url: `/api/btaccountrules/preview/${queryArg.customerId}/${queryArg.fromDate}/${queryArg.toDate}`,
            }),
        }),
        saveGlRules: build.mutation<SaveGlRulesApiResponse, SaveGlRulesApiArg>({
            query: (queryArg) => ({
                url: `/api/btaccountrules`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        glCodingBatch: build.mutation<
            GlCodingBatchApiResponse,
            GlCodingBatchApiArg
        >({
            query: (queryArg) => ({
                url: `/api/btaccountrules/coding`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        glCodingQueue: build.mutation<
            GlCodingQueueApiResponse,
            GlCodingQueueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/btaccountrules/queue`,
                method: 'POST',
                body: queryArg.btCodingQueueVm,
            }),
        }),
        getBillToMapsByCarrier: build.query<
            GetBillToMapsByCarrierApiResponse,
            GetBillToMapsByCarrierApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrbtmap/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierBtMap: build.mutation<
            CreateCarrierBtMapApiResponse,
            CreateCarrierBtMapApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrbtmap`,
                method: 'POST',
                body: queryArg.carrBtMapVm,
            }),
        }),
        deleteCarrierBtMap: build.mutation<
            DeleteCarrierBtMapApiResponse,
            DeleteCarrierBtMapApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrbtmap/${queryArg.carrId}/${queryArg.carrAcct}/${queryArg.btId}`,
                method: 'DELETE',
            }),
        }),
        getVoidableChecks: build.mutation<
            GetVoidableChecksApiResponse,
            GetVoidableChecksApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrcheck/tovoid`,
                method: 'POST',
                body: queryArg.checkInfoSearchVm,
            }),
        }),
        voidChecks: build.mutation<VoidChecksApiResponse, VoidChecksApiArg>({
            query: (queryArg) => ({
                url: `/api/carrcheck/void`,
                method: 'POST',
                body: queryArg.body,
                params: {reason: queryArg.reason},
            }),
        }),
        getAllRemits: build.query<GetAllRemitsApiResponse, GetAllRemitsApiArg>({
            query: () => ({url: `/api/carrcheck/remits`}),
        }),
        makeRemits: build.mutation<MakeRemitsApiResponse, MakeRemitsApiArg>({
            query: (queryArg) => ({
                url: `/api/carrcheck/remits`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getRemitsForChecks: build.query<
            GetRemitsForChecksApiResponse,
            GetRemitsForChecksApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrcheck/remits/${queryArg.checkNums}`,
            }),
        }),
        getRemitKeys: build.query<GetRemitKeysApiResponse, GetRemitKeysApiArg>({
            query: () => ({url: `/api/carrcheck/remitkeys`}),
        }),
        getRemitsForKey: build.query<
            GetRemitsForKeyApiResponse,
            GetRemitsForKeyApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrcheck/remitkey/${queryArg.remitKey}`,
            }),
        }),
        getCarrierEdiMasterById: build.query<
            GetCarrierEdiMasterByIdApiResponse,
            GetCarrierEdiMasterByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carredimaster/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierEdiMaster: build.mutation<
            CreateCarrierEdiMasterApiResponse,
            CreateCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carredimaster`,
                method: 'POST',
                body: queryArg.carrEdiMasterVm,
            }),
        }),
        modifyCarrierEdiMaster: build.mutation<
            ModifyCarrierEdiMasterApiResponse,
            ModifyCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carredimaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
                method: 'PUT',
                body: queryArg.carrEdiMasterVm,
            }),
        }),
        deleteCarrierEdiMaster: build.mutation<
            DeleteCarrierEdiMasterApiResponse,
            DeleteCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carredimaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
                method: 'DELETE',
            }),
        }),
        getAllCarrierFamilies: build.query<
            GetAllCarrierFamiliesApiResponse,
            GetAllCarrierFamiliesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrfam`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getCarriersForDropdown: build.query<
            GetCarriersForDropdownApiResponse,
            GetCarriersForDropdownApiArg
        >({
            query: () => ({url: `/api/carrier`}),
        }),
        getActiveCarriersForDropdown: build.query<
            GetActiveCarriersForDropdownApiResponse,
            GetActiveCarriersForDropdownApiArg
        >({
            query: () => ({url: `/api/carrier/activedropdown`}),
        }),
        getPermissionedCarriersForDropdown: build.query<
            GetPermissionedCarriersForDropdownApiResponse,
            GetPermissionedCarriersForDropdownApiArg
        >({
            query: () => ({url: `/api/carrier/userdropdown`}),
        }),
        getByScac: build.query<GetByScacApiResponse, GetByScacApiArg>({
            query: (queryArg) => ({url: `/api/carrier/scac/${queryArg.scac}`}),
        }),
        getCarrierChargeCodeMapping: build.query<
            GetCarrierChargeCodeMappingApiResponse,
            GetCarrierChargeCodeMappingApiArg
        >({
            query: () => ({url: `/api/carrier/chargecodemapping`}),
        }),
        getCarrierChargeCodeMappingById: build.query<
            GetCarrierChargeCodeMappingByIdApiResponse,
            GetCarrierChargeCodeMappingByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemapping`,
            }),
        }),
        addNewCarrierChargeCodeMapping: build.mutation<
            AddNewCarrierChargeCodeMappingApiResponse,
            AddNewCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemapping`,
                method: 'POST',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        updateCarrierChargeCodeMapping: build.mutation<
            UpdateCarrierChargeCodeMappingApiResponse,
            UpdateCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemapping`,
                method: 'PUT',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        deletCarrierChargeCodeMapping: build.mutation<
            DeletCarrierChargeCodeMappingApiResponse,
            DeletCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemapping`,
                method: 'DELETE',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        getCarrierChargeCodeMappingOverrides: build.query<
            GetCarrierChargeCodeMappingOverridesApiResponse,
            GetCarrierChargeCodeMappingOverridesApiArg
        >({
            query: () => ({url: `/api/carrier/chargecodemappingoverrides`}),
        }),
        getCarrierChargeCodeMappingOverrideByCarrierId: build.query<
            GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse,
            GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides`,
            }),
        }),
        addNewCarrierChargeCodeMappingOverride: build.mutation<
            AddNewCarrierChargeCodeMappingOverrideApiResponse,
            AddNewCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'POST',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        updateCarrierChargeCodeMappingOverride: build.mutation<
            UpdateCarrierChargeCodeMappingOverrideApiResponse,
            UpdateCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'PUT',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        deleteCarrierChargeCodeMappingOverride: build.mutation<
            DeleteCarrierChargeCodeMappingOverrideApiResponse,
            DeleteCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'DELETE',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        getCarrierById: build.query<
            GetCarrierByIdApiResponse,
            GetCarrierByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/carrier/${queryArg.carrierId}`}),
        }),
        getAllCarriers: build.query<
            GetAllCarriersApiResponse,
            GetAllCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/admin`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarriers: build.mutation<
            CreateCarriersApiResponse,
            CreateCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/admin`,
                method: 'POST',
                body: queryArg.carrierVm,
            }),
        }),
        modifyCarriers: build.mutation<
            ModifyCarriersApiResponse,
            ModifyCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/admin/${queryArg.carrierId}`,
                method: 'PUT',
                body: queryArg.carrierVm,
            }),
        }),
        deleteCarriers: build.mutation<
            DeleteCarriersApiResponse,
            DeleteCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/admin/${queryArg.carrierId}`,
                method: 'DELETE',
            }),
        }),
        activateCarriers: build.mutation<
            ActivateCarriersApiResponse,
            ActivateCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/admin/${queryArg.carrierId}/active`,
                method: 'PUT',
                body: queryArg.carrierActiveVm,
            }),
        }),
        getModeOverrides: build.query<
            GetModeOverridesApiResponse,
            GetModeOverridesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/getmodeoverrides`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getSpecificModeOverride: build.query<
            GetSpecificModeOverrideApiResponse,
            GetSpecificModeOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/getspecificmodeoverride/${queryArg.carrierId}/${queryArg.btid}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        deleteModeOverride: build.mutation<
            DeleteModeOverrideApiResponse,
            DeleteModeOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/deletemodeoverride/${queryArg.carrierId}/${queryArg.btid}`,
                method: 'DELETE',
            }),
        }),
        updateModeOverride: build.mutation<
            UpdateModeOverrideApiResponse,
            UpdateModeOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/updatemodeoverride`,
                method: 'PUT',
                body: queryArg.billToCarrierModeOverrideVm,
            }),
        }),
        addModeOverride: build.mutation<
            AddModeOverrideApiResponse,
            AddModeOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrier/addmodeoverride`,
                method: 'PUT',
                body: queryArg.billToCarrierModeOverrideVm,
            }),
        }),
        AddModeType: build.mutation<
            AddModeTypeApiResponse,
            AddModeTypeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/codemaster/AddMode`,
                method: 'POST',
                body: queryArg.codeMasterVm,
            }),
        }),
        getAllCarrierContacts: build.query<
            GetAllCarrierContactsApiResponse,
            GetAllCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriercontact`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierContacts: build.mutation<
            CreateCarrierContactsApiResponse,
            CreateCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriercontact`,
                method: 'POST',
                body: queryArg.carrierContactVm,
            }),
        }),
        getCarrierContactById: build.query<
            GetCarrierContactByIdApiResponse,
            GetCarrierContactByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriercontact/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        modifyCarrierContacts: build.mutation<
            ModifyCarrierContactsApiResponse,
            ModifyCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriercontact/${queryArg.contactId}`,
                method: 'PUT',
                body: queryArg.carrierContactVm,
            }),
        }),
        deleteCarrierContacts: build.mutation<
            DeleteCarrierContactsApiResponse,
            DeleteCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriercontact/${queryArg.contactId}`,
                method: 'DELETE',
            }),
        }),
        getCarrierModeMapsById: build.query<
            GetCarrierModeMapsByIdApiResponse,
            GetCarrierModeMapsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriermodemap/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierModeMaps: build.mutation<
            CreateCarrierModeMapsApiResponse,
            CreateCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriermodemap`,
                method: 'POST',
                body: queryArg.carrierModeMapVm,
            }),
        }),
        modifyCarrierModeMaps: build.mutation<
            ModifyCarrierModeMapsApiResponse,
            ModifyCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriermodemap/${queryArg.mapId}`,
                method: 'PUT',
                body: queryArg.carrierModeMapVm,
            }),
        }),
        deleteCarrierModeMaps: build.mutation<
            DeleteCarrierModeMapsApiResponse,
            DeleteCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carriermodemap/${queryArg.mapId}`,
                method: 'DELETE',
            }),
        }),
        getPayMethodsForCarrier: build.query<
            GetPayMethodsForCarrierApiResponse,
            GetPayMethodsForCarrierApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrierpaymentremit/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierPayRemit: build.mutation<
            CreateCarrierPayRemitApiResponse,
            CreateCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrierpaymentremit`,
                method: 'POST',
                body: queryArg.carrierPaymentRemitVm,
            }),
        }),
        modifyCarrierPayRemit: build.mutation<
            ModifyCarrierPayRemitApiResponse,
            ModifyCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrierpaymentremit/${queryArg.remitInfoId}`,
                method: 'PUT',
                body: queryArg.carrierPaymentRemitVm,
            }),
        }),
        deleteCarrierPayRemit: build.mutation<
            DeleteCarrierPayRemitApiResponse,
            DeleteCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrierpaymentremit/${queryArg.remitInfoId}`,
                method: 'DELETE',
            }),
        }),
        getCarrierRemitMethods: build.query<
            GetCarrierRemitMethodsApiResponse,
            GetCarrierRemitMethodsApiArg
        >({
            query: () => ({url: `/api/carrierpaymentremit/remitmethods`}),
        }),
        getCarrierRemitDeliveryMethods: build.query<
            GetCarrierRemitDeliveryMethodsApiResponse,
            GetCarrierRemitDeliveryMethodsApiArg
        >({
            query: () => ({
                url: `/api/carrierpaymentremit/remitdeliverymethods`,
            }),
        }),
        getCarrierRemitFormats: build.query<
            GetCarrierRemitFormatsApiResponse,
            GetCarrierRemitFormatsApiArg
        >({
            query: () => ({url: `/api/carrierpaymentremit/remitformats`}),
        }),
        getAchSecCodes: build.query<
            GetAchSecCodesApiResponse,
            GetAchSecCodesApiArg
        >({
            query: () => ({url: `/api/carrierpaymentremit/achseccodes`}),
        }),
        getCarrierInvoiceById: build.query<
            GetCarrierInvoiceByIdApiResponse,
            GetCarrierInvoiceByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/carrinv/${queryArg.id}`}),
        }),
        deleteInvoice: build.mutation<
            DeleteInvoiceApiResponse,
            DeleteInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}`,
                method: 'DELETE',
            }),
        }),
        getCarrInvByInvNum: build.query<
            GetCarrInvByInvNumApiResponse,
            GetCarrInvByInvNumApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.recType}/${queryArg.carrId}/${queryArg.invNum}`,
            }),
        }),
        getInvoiceSummary: build.query<
            GetInvoiceSummaryApiResponse,
            GetInvoiceSummaryApiArg
        >({
            query: (queryArg) => ({url: `/api/carrinv/${queryArg.id}/summary`}),
        }),
        getInvoiceLineSummary: build.query<
            GetInvoiceLineSummaryApiResponse,
            GetInvoiceLineSummaryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/linesummary`,
            }),
        }),
        getInvoiceChargeDetails: build.query<
            GetInvoiceChargeDetailsApiResponse,
            GetInvoiceChargeDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/chargedetails`,
            }),
        }),
        getInvoiceLineChargeDetails: build.query<
            GetInvoiceLineChargeDetailsApiResponse,
            GetInvoiceLineChargeDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/linechargedetails`,
            }),
        }),
        getBundleInfo: build.query<
            GetBundleInfoApiResponse,
            GetBundleInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/bundleinfo/${queryArg.bundleId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getAllInvoiceRevs: build.query<
            GetAllInvoiceRevsApiResponse,
            GetAllInvoiceRevsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/getallrevs/${queryArg.recType}/${queryArg.carrierId}/${queryArg.invoiceNum}`,
            }),
        }),
        create: build.mutation<CreateApiResponse, CreateApiArg>({
            query: (queryArg) => ({
                url: `/api/carrinv`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        createWebInvoice: build.mutation<
            CreateWebInvoiceApiResponse,
            CreateWebInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/webinvoice`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        updateWebInvoice: build.mutation<
            UpdateWebInvoiceApiResponse,
            UpdateWebInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/webinvoice`,
                method: 'PUT',
                body: queryArg.carrInvVm,
                params: {comment: queryArg.comment},
            }),
        }),
        initiateMultiPartInvoiceCreation: build.mutation<
            InitiateMultiPartInvoiceCreationApiResponse,
            InitiateMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/initiatemultipartinvoicecreation`,
                method: 'POST',
                body: queryArg.initiateMultiPartInvoiceCreationRequest,
            }),
        }),
        multiPartInvoiceCreation: build.mutation<
            MultiPartInvoiceCreationApiResponse,
            MultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/multipartinvoicecreation`,
                method: 'POST',
                body: queryArg.invoicePartRequest,
            }),
        }),
        completeMultiPartInvoiceCreation: build.mutation<
            CompleteMultiPartInvoiceCreationApiResponse,
            CompleteMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/completemultipartinvoicecreation`,
                method: 'POST',
                body: queryArg.completeMultiPartInvoiceCreationRequest,
            }),
        }),
        abortMultiPartInvoiceCreation: build.mutation<
            AbortMultiPartInvoiceCreationApiResponse,
            AbortMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/abortmultipartinvoicecreation`,
                method: 'POST',
                body: queryArg.abortMultiPartInvoiceCreationRequest,
            }),
        }),
        createQueued: build.mutation<
            CreateQueuedApiResponse,
            CreateQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/queued`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        postApiCarrinvCheckqueuedinvoicecreationstate: build.mutation<
            PostApiCarrinvCheckqueuedinvoicecreationstateApiResponse,
            PostApiCarrinvCheckqueuedinvoicecreationstateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/checkqueuedinvoicecreationstate`,
                method: 'POST',
                body: queryArg.invoiceCreationStatusRequest,
            }),
        }),
        reAudit: build.mutation<ReAuditApiResponse, ReAuditApiArg>({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/reaudit`,
                method: 'POST',
            }),
        }),
        testAudit: build.mutation<TestAuditApiResponse, TestAuditApiArg>({
            query: (queryArg) => ({
                url: `/api/carrinv/testaudit`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        deleteShipment: build.mutation<
            DeleteShipmentApiResponse,
            DeleteShipmentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/shipment/${queryArg.id}`,
                method: 'DELETE',
            }),
        }),
        makeInvoiceMemo: build.mutation<
            MakeInvoiceMemoApiResponse,
            MakeInvoiceMemoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/memo`,
                method: 'POST',
                params: {id: queryArg.id, comment: queryArg.comment},
            }),
        }),
        makeInvoiceReal: build.mutation<
            MakeInvoiceRealApiResponse,
            MakeInvoiceRealApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/real`,
                method: 'POST',
                params: {id: queryArg.id, comment: queryArg.comment},
            }),
        }),
        reassignInvoiceCustomer: build.mutation<
            ReassignInvoiceCustomerApiResponse,
            ReassignInvoiceCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/changecustomer`,
                method: 'POST',
                body: queryArg.carrInvCustChangeVm,
            }),
        }),
        reassignInvoiceNumber: build.mutation<
            ReassignInvoiceNumberApiResponse,
            ReassignInvoiceNumberApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/changenumber`,
                method: 'POST',
                body: queryArg.carrInvNumberChangeVm,
            }),
        }),
        validateCoding: build.mutation<
            ValidateCodingApiResponse,
            ValidateCodingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/validatecoding`,
                method: 'POST',
                params: {
                    isSave: queryArg.isSave,
                    isFromApp: queryArg.isFromApp,
                },
            }),
        }),
        validateLineCoding: build.mutation<
            ValidateLineCodingApiResponse,
            ValidateLineCodingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/validatecoding/${queryArg.lineIdx}`,
                method: 'POST',
                params: {
                    isSave: queryArg.isSave,
                    isFromApp: queryArg.isFromApp,
                },
            }),
        }),
        createBillingInvoice: build.mutation<
            CreateBillingInvoiceApiResponse,
            CreateBillingInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/createbillinginvoice`,
                method: 'POST',
                params: {
                    handledInvoiceException: queryArg.handledInvoiceException,
                    createPdf: queryArg.createPdf,
                    createDupeIfExists: queryArg.createDupeIfExists,
                },
            }),
        }),
        createBillingInvoiceQueued: build.mutation<
            CreateBillingInvoiceQueuedApiResponse,
            CreateBillingInvoiceQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/createbillinginvoice/queued`,
                method: 'POST',
                params: {
                    handledInvoiceException: queryArg.handledInvoiceException,
                    createPdf: queryArg.createPdf,
                },
            }),
        }),
        createPdfInvoice: build.mutation<
            CreatePdfInvoiceApiResponse,
            CreatePdfInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/createpdfinvoice`,
                method: 'POST',
            }),
        }),
        createPdfInvoiceQueued: build.mutation<
            CreatePdfInvoiceQueuedApiResponse,
            CreatePdfInvoiceQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/createpdfinvoice/queued`,
                method: 'POST',
            }),
        }),
        regeneratePdfInvoice: build.mutation<
            RegeneratePdfInvoiceApiResponse,
            RegeneratePdfInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/regeneratepdfinvoice/queued`,
                method: 'POST',
            }),
        }),
        getImagesForInvoice: build.query<
            GetImagesForInvoiceApiResponse,
            GetImagesForInvoiceApiArg
        >({
            query: (queryArg) => ({url: `/api/carrinv/${queryArg.id}/images`}),
        }),
        addImage: build.mutation<AddImageApiResponse, AddImageApiArg>({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/images`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        clearCachedImagesForInvoice: build.mutation<
            ClearCachedImagesForInvoiceApiResponse,
            ClearCachedImagesForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/images/clearcachedimages`,
                method: 'POST',
            }),
        }),
        getImageWithData: build.query<
            GetImageWithDataApiResponse,
            GetImageWithDataApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}`,
            }),
        }),
        getImageWithDataFromObject: build.mutation<
            GetImageWithDataFromObjectApiResponse,
            GetImageWithDataFromObjectApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}/obj`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        getInvoiceEdi: build.query<
            GetInvoiceEdiApiResponse,
            GetInvoiceEdiApiArg
        >({
            query: (queryArg) => ({url: `/api/carrinv/${queryArg.id}/edi`}),
        }),
        carrInvDisconnectImage: build.mutation<
            CarrInvDisconnectImageApiResponse,
            CarrInvDisconnectImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/images/${queryArg.imageId}/disconnect`,
                method: 'PUT',
            }),
        }),
        whatIfChargeCodesForNewBillto: build.query<
            WhatIfChargeCodesForNewBilltoApiResponse,
            WhatIfChargeCodesForNewBilltoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/${queryArg.id}/chargecodewhatif/${queryArg.newBillToId}`,
            }),
        }),
        getInvoicesForBatching: build.query<
            GetInvoicesForBatchingApiResponse,
            GetInvoicesForBatchingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrinv/receivables/${queryArg.searchDate}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getAllCarrServices: build.query<
            GetAllCarrServicesApiResponse,
            GetAllCarrServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrservices`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierServices: build.mutation<
            CreateCarrierServicesApiResponse,
            CreateCarrierServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrservices`,
                method: 'POST',
                body: queryArg.carrServicesVm,
            }),
        }),
        getCarrierServicesById: build.query<
            GetCarrierServicesByIdApiResponse,
            GetCarrierServicesByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrservices/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        modifyCarrierService: build.mutation<
            ModifyCarrierServiceApiResponse,
            ModifyCarrierServiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrservices/${queryArg.carrierId}/${queryArg.svcCode}`,
                method: 'PUT',
                body: queryArg.carrServicesVm,
            }),
        }),
        deleteCarrierServices: build.mutation<
            DeleteCarrierServicesApiResponse,
            DeleteCarrierServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/carrservices/${queryArg.carrierId}/${queryArg.svcCode}`,
                method: 'DELETE',
            }),
        }),
        getAllowedCarrSvcAuditFns: build.query<
            GetAllowedCarrSvcAuditFnsApiResponse,
            GetAllowedCarrSvcAuditFnsApiArg
        >({
            query: () => ({url: `/api/carrservices/functions`}),
        }),
        getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/centralsalt/${queryArg.customerId}/${queryArg.carrierId}/${queryArg.ticketNum}`,
            }),
        }),
        makeCSaltInvoice: build.mutation<
            MakeCSaltInvoiceApiResponse,
            MakeCSaltInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/centralsalt`,
                method: 'POST',
                body: queryArg.centralSaltVm,
            }),
        }),
        getRegisterFbOs: build.query<
            GetRegisterFbOsApiResponse,
            GetRegisterFbOsApiArg
        >({
            query: () => ({url: `/api/checkregister/fbo`}),
        }),
        getRegisterInfo: build.mutation<
            GetRegisterInfoApiResponse,
            GetRegisterInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/checkregister`,
                method: 'POST',
                body: queryArg.checkRegisterRequestVm,
            }),
        }),
        getAllCmContracts: build.query<
            GetAllCmContractsApiResponse,
            GetAllCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/cmcontract`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCmContracts: build.mutation<
            CreateCmContractsApiResponse,
            CreateCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/cmcontract`,
                method: 'POST',
                body: queryArg.cmContractVm,
            }),
        }),
        modifyCmContracts: build.mutation<
            ModifyCmContractsApiResponse,
            ModifyCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/cmcontract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
                method: 'PUT',
                body: queryArg.cmContractVm,
            }),
        }),
        deleteCmContracts: build.mutation<
            DeleteCmContractsApiResponse,
            DeleteCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/cmcontract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
                method: 'DELETE',
            }),
        }),
        getAllMasterCodes: build.query<
            GetAllMasterCodesApiResponse,
            GetAllMasterCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/codemaster`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getMasterCodesForElement: build.query<
            GetMasterCodesForElementApiResponse,
            GetMasterCodesForElementApiArg
        >({
            query: (queryArg) => ({
                url: `/api/codemaster/${queryArg.element}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        modifyMasterCodes: build.mutation<
            ModifyMasterCodesApiResponse,
            ModifyMasterCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/codemaster/${queryArg.element}/${queryArg.code}`,
                method: 'PUT',
                body: queryArg.codeMasterVm,
            }),
        }),
        getMasterCodeFilters: build.query<
            GetMasterCodeFiltersApiResponse,
            GetMasterCodeFiltersApiArg
        >({
            query: () => ({url: `/api/codemaster/filters`}),
        }),
        getActiveCurrencyCodes: build.query<
            GetActiveCurrencyCodesApiResponse,
            GetActiveCurrencyCodesApiArg
        >({
            query: () => ({url: `/api/codemaster/currencycodes`}),
        }),
        getAuditFailCodes: build.query<
            GetAuditFailCodesApiResponse,
            GetAuditFailCodesApiArg
        >({
            query: () => ({url: `/api/codemaster/auditfailcodes`}),
        }),
        getPreReqStatuses: build.query<
            GetPreReqStatusesApiResponse,
            GetPreReqStatusesApiArg
        >({
            query: () => ({url: `/api/codemaster/prereqstatuses`}),
        }),
        getCustomerContactsById: build.query<
            GetCustomerContactsByIdApiResponse,
            GetCustomerContactsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/contact/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCustomerContacts: build.mutation<
            CreateCustomerContactsApiResponse,
            CreateCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/contact`,
                method: 'POST',
                body: queryArg.contactsVm,
            }),
        }),
        modifyCustomerContacts: build.mutation<
            ModifyCustomerContactsApiResponse,
            ModifyCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/contact/${queryArg.contactId}`,
                method: 'PUT',
                body: queryArg.contactsVm,
            }),
        }),
        deleteCustomerContacts: build.mutation<
            DeleteCustomerContactsApiResponse,
            DeleteCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/contact/${queryArg.contactId}`,
                method: 'DELETE',
            }),
        }),
        getAllCurrencies: build.query<
            GetAllCurrenciesApiResponse,
            GetAllCurrenciesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/currencies`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getRefDefs: build.query<GetRefDefsApiResponse, GetRefDefsApiArg>({
            query: (queryArg) => ({
                url: `/api/customerdataentry/${queryArg.customerId}/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getCustomerRefDefs: build.query<
            GetCustomerRefDefsApiResponse,
            GetCustomerRefDefsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerdataentry/${queryArg.customerId}`,
            }),
        }),
        getRefDefsForInvoice: build.query<
            GetRefDefsForInvoiceApiResponse,
            GetRefDefsForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerdataentry/invoice/${queryArg.customerId}/${queryArg.carrierId}`,
            }),
        }),
        createRefDef: build.mutation<
            CreateRefDefApiResponse,
            CreateRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerdataentry`,
                method: 'POST',
                body: queryArg.customerDataEntryVm,
            }),
        }),
        modifyRefDef: build.mutation<
            ModifyRefDefApiResponse,
            ModifyRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerdataentry/${queryArg.defId}`,
                method: 'PUT',
                body: queryArg.customerDataEntryVm,
            }),
        }),
        deleteRefDef: build.mutation<
            DeleteRefDefApiResponse,
            DeleteRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerdataentry/${queryArg.defId}`,
                method: 'DELETE',
            }),
        }),
        createAndPrepBatches: build.mutation<
            CreateAndPrepBatchesApiResponse,
            CreateAndPrepBatchesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerinvoice/createandprepbatches`,
                method: 'POST',
                body: queryArg.createReceivableBatchesForCustomersVm,
            }),
        }),
        getChildBatches: build.query<
            GetChildBatchesApiResponse,
            GetChildBatchesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerinvoice/childbatches/${queryArg.customer}/${queryArg.reqDate}`,
            }),
        }),
        createAndPrepBatchesFromInvoices: build.mutation<
            CreateAndPrepBatchesFromInvoicesApiResponse,
            CreateAndPrepBatchesFromInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/customerinvoice/createandprepbatchesfrominvoices`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getAgedReceivables: build.query<
            GetAgedReceivablesApiResponse,
            GetAgedReceivablesApiArg
        >({
            query: () => ({url: `/api/customerinvoice/agedreceivables`}),
        }),
        getList: build.query<GetListApiResponse, GetListApiArg>({
            query: () => ({url: `/api/custpay`}),
        }),
        upsert: build.mutation<UpsertApiResponse, UpsertApiArg>({
            query: (queryArg) => ({
                url: `/api/custpay`,
                method: 'POST',
                body: queryArg.custPaySetupVm,
            }),
        }),
        getCustPayByBillToIdById: build.query<
            GetCustPayByBillToIdByIdApiResponse,
            GetCustPayByBillToIdByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/custpay/btid/${queryArg.id}`}),
        }),
        getCustPaySetupById: build.query<
            GetCustPaySetupByIdApiResponse,
            GetCustPaySetupByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/custpay/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCustPaySetup: build.mutation<
            CreateCustPaySetupApiResponse,
            CreateCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/custpay/${queryArg.customerId}`,
                method: 'POST',
                body: queryArg.custPaySetupVm,
            }),
        }),
        modifyCustPaySetup: build.mutation<
            ModifyCustPaySetupApiResponse,
            ModifyCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/custpay/${queryArg.setupId}`,
                method: 'PUT',
                body: queryArg.custPaySetupVm,
            }),
        }),
        deleteCustPaySetup: build.mutation<
            DeleteCustPaySetupApiResponse,
            DeleteCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/custpay/${queryArg.setupId}`,
                method: 'DELETE',
            }),
        }),
        getShipmentCountByStatus: build.query<
            GetShipmentCountByStatusApiResponse,
            GetShipmentCountByStatusApiArg
        >({
            query: () => ({url: `/api/dashboard/shipmentcountbystatus`}),
        }),
        getAgedInvoiceSummary: build.query<
            GetAgedInvoiceSummaryApiResponse,
            GetAgedInvoiceSummaryApiArg
        >({
            query: () => ({url: `/api/dashboard/agedinvoicesummary`}),
        }),
        getDataEntryAdminInfoByCustomer: build.query<
            GetDataEntryAdminInfoByCustomerApiResponse,
            GetDataEntryAdminInfoByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataentryadmin/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getDataEntryAdminInfoForInvoice: build.query<
            GetDataEntryAdminInfoForInvoiceApiResponse,
            GetDataEntryAdminInfoForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        modifyDataEntryAdminInfo: build.mutation<
            ModifyDataEntryAdminInfoApiResponse,
            ModifyDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
                method: 'PUT',
                body: queryArg.deAdminVm,
            }),
        }),
        deleteDataEntryAdminInfo: build.mutation<
            DeleteDataEntryAdminInfoApiResponse,
            DeleteDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataentryadmin/${queryArg.customerId}/${queryArg.carrierId}`,
                method: 'DELETE',
            }),
        }),
        createDataEntryAdminInfo: build.mutation<
            CreateDataEntryAdminInfoApiResponse,
            CreateDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataentryadmin`,
                method: 'POST',
                body: queryArg.deAdminVm,
            }),
        }),
        invoiceResearchExport: build.mutation<
            InvoiceResearchExportApiResponse,
            InvoiceResearchExportApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataexport/invoiceresearchexport`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
                params: {
                    userJobName: queryArg.userJobName,
                    fileFormat: queryArg.fileFormat,
                },
            }),
        }),
        getDataExports: build.query<
            GetDataExportsApiResponse,
            GetDataExportsApiArg
        >({
            query: () => ({url: `/api/dataexport`}),
        }),
        deleteExport: build.mutation<
            DeleteExportApiResponse,
            DeleteExportApiArg
        >({
            query: (queryArg) => ({
                url: `/api/dataexport/${queryArg.id}`,
                method: 'DELETE',
            }),
        }),
        sendMailWithOutAttachments: build.mutation<
            SendMailWithOutAttachmentsApiResponse,
            SendMailWithOutAttachmentsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/email`,
                method: 'POST',
                body: queryArg.emailVm,
            }),
        }),
        getActiveEquipsForDropdown: build.query<
            GetActiveEquipsForDropdownApiResponse,
            GetActiveEquipsForDropdownApiArg
        >({
            query: () => ({url: `/api/equipment/dropdown`}),
        }),
        getInvoiceHistory: build.query<
            GetInvoiceHistoryApiResponse,
            GetInvoiceHistoryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/history/${queryArg.customerId}/${queryArg.startDate}/${queryArg.endDate}`,
            }),
        }),
        getInvoiceRange: build.mutation<
            GetInvoiceRangeApiResponse,
            GetInvoiceRangeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/range`,
                method: 'POST',
                body: queryArg.custFeesRangeRequestVm,
            }),
        }),
        getInvoiceHistoryDetails: build.query<
            GetInvoiceHistoryDetailsApiResponse,
            GetInvoiceHistoryDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/details/${queryArg.customerId}/${queryArg.invoiceId}`,
            }),
        }),
        getInvoiceRangeDetails: build.query<
            GetInvoiceRangeDetailsApiResponse,
            GetInvoiceRangeDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/rangedetails/${queryArg.customerId}/${queryArg.invoiceId}`,
            }),
        }),
        generateInvoiceDetailReport: build.query<
            GenerateInvoiceDetailReportApiResponse,
            GenerateInvoiceDetailReportApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/report/${queryArg.customerId}/${queryArg.invoiceId}`,
            }),
        }),
        deleteFeesInvoice: build.mutation<
            DeleteFeesInvoiceApiResponse,
            DeleteFeesInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/${queryArg.invoiceId}`,
                method: 'DELETE',
            }),
        }),
        renameFeesInvoice: build.mutation<
            RenameFeesInvoiceApiResponse,
            RenameFeesInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/rename`,
                method: 'POST',
                body: queryArg.custFeesChangeInvNumVm,
            }),
        }),
        importInvoices: build.mutation<
            ImportInvoicesApiResponse,
            ImportInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/import`,
                method: 'POST',
                body: queryArg.custFeesImportRequestVm,
            }),
        }),
        getImportDates: build.query<
            GetImportDatesApiResponse,
            GetImportDatesApiArg
        >({
            query: () => ({url: `/api/feesappinvoice/importdates`}),
        }),
        getImportReportsForDate: build.query<
            GetImportReportsForDateApiResponse,
            GetImportReportsForDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappinvoice/importfiles/${queryArg.importDate}`,
            }),
        }),
        getTermsCustomers: build.query<
            GetTermsCustomersApiResponse,
            GetTermsCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappmakeinvoice/customers/${queryArg.isPayToTerms}`,
            }),
        }),
        testNonPayInvoices: build.mutation<
            TestNonPayInvoicesApiResponse,
            TestNonPayInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappmakeinvoice/nonpay/test`,
                method: 'POST',
                body: queryArg.custFeesMakeInvoiceRequestVm,
            }),
        }),
        makeNonPayInvoices: build.mutation<
            MakeNonPayInvoicesApiResponse,
            MakeNonPayInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappmakeinvoice/nonpay/make`,
                method: 'POST',
                body: queryArg.custFeesMakeInvoiceRequestVm,
            }),
        }),
        testPayInvoices: build.mutation<
            TestPayInvoicesApiResponse,
            TestPayInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappmakeinvoice/pay/test`,
                method: 'POST',
                body: queryArg.custFeesMakeInvoiceRequestVm,
            }),
        }),
        makePayInvoices: build.mutation<
            MakePayInvoicesApiResponse,
            MakePayInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesappmakeinvoice/pay/make`,
                method: 'POST',
                body: queryArg.custFeesMakeInvoiceRequestVm,
            }),
        }),
        getCompareRules: build.query<
            GetCompareRulesApiResponse,
            GetCompareRulesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules/compare/${queryArg.customerId}`,
            }),
        }),
        convertFeesAppRule: build.mutation<
            ConvertFeesAppRuleApiResponse,
            ConvertFeesAppRuleApiArg
        >({
            query: () => ({url: `/api/feesapprules/convert`, method: 'POST'}),
        }),
        getCustomerRules: build.query<
            GetCustomerRulesApiResponse,
            GetCustomerRulesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules/customer/${queryArg.customerId}`,
            }),
        }),
        getRuleData: build.query<GetRuleDataApiResponse, GetRuleDataApiArg>({
            query: (queryArg) => ({
                url: `/api/feesapprules/${queryArg.ruleId}`,
            }),
        }),
        deleteFeesRule: build.mutation<
            DeleteFeesRuleApiResponse,
            DeleteFeesRuleApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules/${queryArg.ruleId}`,
                method: 'DELETE',
            }),
        }),
        createFeesRule: build.mutation<
            CreateFeesRuleApiResponse,
            CreateFeesRuleApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules`,
                method: 'POST',
                body: queryArg.custFeesRuleInfoVm,
            }),
        }),
        updateFeesRule: build.mutation<
            UpdateFeesRuleApiResponse,
            UpdateFeesRuleApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules`,
                method: 'PUT',
                body: queryArg.custFeesRuleInfoVm,
            }),
        }),
        setFeesRuleDetail: build.mutation<
            SetFeesRuleDetailApiResponse,
            SetFeesRuleDetailApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules/details`,
                method: 'POST',
                body: queryArg.custFeesRuleTypeDetailsVm,
            }),
        }),
        getRuleTypes: build.query<GetRuleTypesApiResponse, GetRuleTypesApiArg>({
            query: () => ({url: `/api/feesapprules/ruletypes`}),
        }),
        getBillPerTypes: build.query<
            GetBillPerTypesApiResponse,
            GetBillPerTypesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/feesapprules/billpertypes/${queryArg.periodic}`,
            }),
        }),
        getIntDomTypes: build.query<
            GetIntDomTypesApiResponse,
            GetIntDomTypesApiArg
        >({
            query: () => ({url: `/api/feesapprules/intdomtypes`}),
        }),
        bulkCoding: build.mutation<BulkCodingApiResponse, BulkCodingApiArg>({
            query: (queryArg) => ({
                url: `/api/glcoding/bulk`,
                method: 'POST',
                body: queryArg.glBulkCodingRequest,
            }),
        }),
        getGlCodeForInvoice: build.mutation<
            GetGlCodeForInvoiceApiResponse,
            GetGlCodeForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/glcoding/invoice`,
                method: 'POST',
                body: queryArg.glCodingRequest,
            }),
        }),
        postHopkinsDepartment: build.mutation<
            PostHopkinsDepartmentApiResponse,
            PostHopkinsDepartmentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/glcoding/determinehopkinsdepartment`,
                method: 'POST',
                body: queryArg.hopkinsDepartmentVm,
            }),
        }),
        getHealthCheck: build.query<
            GetHealthCheckApiResponse,
            GetHealthCheckApiArg
        >({
            query: () => ({url: `/health/check`}),
        }),
        get: build.query<GetApiResponse, GetApiArg>({
            query: () => ({url: `/`}),
        }),
        getImage: build.query<GetImageApiResponse, GetImageApiArg>({
            query: (queryArg) => ({url: `/api/images/${queryArg.imageId}`}),
        }),
        deleteImage: build.mutation<DeleteImageApiResponse, DeleteImageApiArg>({
            query: (queryArg) => ({
                url: `/api/images/${queryArg.imageId}`,
                method: 'DELETE',
            }),
        }),
        deleteMultipleImages: build.mutation<
            DeleteMultipleImagesApiResponse,
            DeleteMultipleImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/deleteimages`,
                method: 'PUT',
                body: queryArg.body,
            }),
        }),
        disconnectImage: build.mutation<
            DisconnectImageApiResponse,
            DisconnectImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/${queryArg.imageId}/disconnect`,
                method: 'PUT',
            }),
        }),
        disconnectMultipleImages: build.mutation<
            DisconnectMultipleImagesApiResponse,
            DisconnectMultipleImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/disconnectimages`,
                method: 'PUT',
                body: queryArg.body,
            }),
        }),
        getDisconnectedImages: build.query<
            GetDisconnectedImagesApiResponse,
            GetDisconnectedImagesApiArg
        >({
            query: () => ({url: `/api/images/disconnectedimages`}),
        }),
        uploadDisconnectedImage: build.mutation<
            UploadDisconnectedImageApiResponse,
            UploadDisconnectedImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/disconnectedimages`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        getDisconnectedImagesQueryable: build.query<
            GetDisconnectedImagesQueryableApiResponse,
            GetDisconnectedImagesQueryableApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/disconnectedimagesqueryable`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getQueues: build.query<GetQueuesApiResponse, GetQueuesApiArg>({
            query: () => ({url: `/api/images/queues`}),
        }),
        getQueueImages: build.query<
            GetQueueImagesApiResponse,
            GetQueueImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/queueimages/${queryArg.queue}`,
            }),
        }),
        indexImage: build.mutation<IndexImageApiResponse, IndexImageApiArg>({
            query: (queryArg) => ({
                url: `/api/images/${queryArg.queue}/indeximage`,
                method: 'POST',
                body: queryArg.carrInvImages,
            }),
        }),
        addImageToQueue: build.mutation<
            AddImageToQueueApiResponse,
            AddImageToQueueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/${queryArg.queue}/addimage`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        addScannedImage: build.mutation<
            AddScannedImageApiResponse,
            AddScannedImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/addscan`,
                method: 'PUT',
                body: queryArg.carrInvImageScanVm,
            }),
        }),
        getScannedImages: build.query<
            GetScannedImagesApiResponse,
            GetScannedImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/scans`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        deleteScannedImages: build.mutation<
            DeleteScannedImagesApiResponse,
            DeleteScannedImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/scans`,
                method: 'DELETE',
                body: queryArg.body,
            }),
        }),
        getScannedImageCustomers: build.query<
            GetScannedImageCustomersApiResponse,
            GetScannedImageCustomersApiArg
        >({
            query: () => ({url: `/api/images/scancusts`}),
        }),
        updateScannedImages: build.mutation<
            UpdateScannedImagesApiResponse,
            UpdateScannedImagesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/updatescans`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getAllowedImageTypes: build.query<
            GetAllowedImageTypesApiResponse,
            GetAllowedImageTypesApiArg
        >({
            query: () => ({url: `/api/images/types`}),
        }),
        deleteUnindexedImage: build.mutation<
            DeleteUnindexedImageApiResponse,
            DeleteUnindexedImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/deleteunindexed/${queryArg.queue}/${queryArg.image}`,
                method: 'DELETE',
            }),
        }),
        customerImageExtract: build.mutation<
            CustomerImageExtractApiResponse,
            CustomerImageExtractApiArg
        >({
            query: (queryArg) => ({
                url: `/api/images/extract`,
                method: 'POST',
                body: queryArg.custImageExtractVm,
            }),
        }),
        releaseInvoice: build.mutation<
            ReleaseInvoiceApiResponse,
            ReleaseInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/release`,
                method: 'PATCH',
            }),
        }),
        getBasicInvInfo: build.query<
            GetBasicInvInfoApiResponse,
            GetBasicInvInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/basicinfo`,
            }),
        }),
        getDetailedCharges: build.query<
            GetDetailedChargesApiResponse,
            GetDetailedChargesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/detailedcharges`,
            }),
        }),
        getReferences: build.query<
            GetReferencesApiResponse,
            GetReferencesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/references`,
            }),
        }),
        updateReferences: build.mutation<
            UpdateReferencesApiResponse,
            UpdateReferencesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/references`,
                method: 'PUT',
                body: queryArg.referenceListVm,
            }),
        }),
        getImages: build.query<GetImagesApiResponse, GetImagesApiArg>({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/images`,
            }),
        }),
        updateComment: build.mutation<
            UpdateCommentApiResponse,
            UpdateCommentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceedit/${queryArg['type']}/${queryArg.id}/comments`,
                method: 'PATCH',
                body: queryArg.invoiceComment,
            }),
        }),
        getPurgableInvoiceList: build.query<
            GetPurgableInvoiceListApiResponse,
            GetPurgableInvoiceListApiArg
        >({
            query: () => ({url: `/api/invoicemaintenance/purgefiles`}),
        }),
        unbatchReceivableBatches: build.mutation<
            UnbatchReceivableBatchesApiResponse,
            UnbatchReceivableBatchesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoicemaintenance/unbatch/${queryArg.batchId}`,
                method: 'POST',
            }),
        }),
        unapproveApprovedBatches: build.mutation<
            UnapproveApprovedBatchesApiResponse,
            UnapproveApprovedBatchesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoicemaintenance/unapprove/${queryArg.batchId}/${queryArg.unapproveAll}`,
                method: 'POST',
            }),
        }),
        purgeInvoice: build.mutation<
            PurgeInvoiceApiResponse,
            PurgeInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoicemaintenance/purge`,
                method: 'POST',
                body: queryArg.invoicePurgeRequestVm,
            }),
        }),
        purgeInvoicesFromFile: build.mutation<
            PurgeInvoicesFromFileApiResponse,
            PurgeInvoicesFromFileApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoicemaintenance/purgefile/${queryArg.fileName}`,
                method: 'POST',
            }),
        }),
        getInvoiceResearchPopulationData: build.query<
            GetInvoiceResearchPopulationDataApiResponse,
            GetInvoiceResearchPopulationDataApiArg
        >({
            query: () => ({url: `/api/invoiceresearch`}),
        }),
        searchInvoices: build.mutation<
            SearchInvoicesApiResponse,
            SearchInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceresearch`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
            }),
        }),
        reactDataTableServerSideProcessing: build.mutation<
            ReactDataTableServerSideProcessingApiResponse,
            ReactDataTableServerSideProcessingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/invoiceresearch/reactdatatable`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
            }),
        }),
        getMakeRealWorkaroundInvoices: build.query<
            GetMakeRealWorkaroundInvoicesApiResponse,
            GetMakeRealWorkaroundInvoicesApiArg
        >({
            query: () => ({url: `/api/itadmin/makereal`}),
        }),
        postMakeRealWorkaroundInvoices: build.mutation<
            PostMakeRealWorkaroundInvoicesApiResponse,
            PostMakeRealWorkaroundInvoicesApiArg
        >({
            query: () => ({url: `/api/itadmin/makereal`, method: 'POST'}),
        }),
        getStatusesForExceptions: build.query<
            GetStatusesForExceptionsApiResponse,
            GetStatusesForExceptionsApiArg
        >({
            query: () => ({url: `/api/manageauditexception/getauditstatuses`}),
        }),
        getExceptionsForGrid: build.query<
            GetExceptionsForGridApiResponse,
            GetExceptionsForGridApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        saveCurrentRemarks: build.mutation<
            SaveCurrentRemarksApiResponse,
            SaveCurrentRemarksApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/saveremarks`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsEntered: build.mutation<
            AcceptAsEnteredApiResponse,
            AcceptAsEnteredApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/acceptasentered`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsAudited: build.mutation<
            AcceptAsAuditedApiResponse,
            AcceptAsAuditedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/acceptasaudited`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsAdjusted: build.mutation<
            AcceptAsAdjustedApiResponse,
            AcceptAsAdjustedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/acceptasadjusted`,
                method: 'POST',
                body: queryArg.exceptionManagerAcceptAsAdjustedVm,
            }),
        }),
        refuseInvoice: build.mutation<
            RefuseInvoiceApiResponse,
            RefuseInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/refuseinvoice`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        exceptionManagerDelete: build.mutation<
            ExceptionManagerDeleteApiResponse,
            ExceptionManagerDeleteApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/deleteinvoice`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        declineServiceFail: build.mutation<
            DeclineServiceFailApiResponse,
            DeclineServiceFailApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/declineservicefail`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        approveServiceFail: build.mutation<
            ApproveServiceFailApiResponse,
            ApproveServiceFailApiArg
        >({
            query: (queryArg) => ({
                url: `/api/manageauditexception/approveservicefail`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        massRefSearch: build.mutation<
            MassRefSearchApiResponse,
            MassRefSearchApiArg
        >({
            query: (queryArg) => ({
                url: `/api/massupdate/search`,
                method: 'POST',
                body: queryArg.updateSearchParams,
            }),
        }),
        massRefUpdate: build.mutation<
            MassRefUpdateApiResponse,
            MassRefUpdateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/massupdate`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getCentralSaltTickets: build.query<
            GetCentralSaltTicketsApiResponse,
            GetCentralSaltTicketsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/matchpay/centralsalt`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        updateCentralSaltTicket: build.mutation<
            UpdateCentralSaltTicketApiResponse,
            UpdateCentralSaltTicketApiArg
        >({
            query: (queryArg) => ({
                url: `/api/matchpay/centralsalt`,
                method: 'PUT',
                body: queryArg.centralSaltMatchVm,
            }),
        }),
        getHarcrosTickets: build.query<
            GetHarcrosTicketsApiResponse,
            GetHarcrosTicketsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/matchpay/harcros`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getAvailableAuditFailStatuses: build.query<
            GetAvailableAuditFailStatusesApiResponse,
            GetAvailableAuditFailStatusesApiArg
        >({
            query: () => ({url: `/api/metainformation/status/auditfail`}),
        }),
        getCarrierChargeCodeSources: build.query<
            GetCarrierChargeCodeSourcesApiResponse,
            GetCarrierChargeCodeSourcesApiArg
        >({
            query: () => ({
                url: `/api/metainformation/carrierchargecodesource`,
            }),
        }),
        getCustomerDataEntryCodesForUser: build.query<
            GetCustomerDataEntryCodesForUserApiResponse,
            GetCustomerDataEntryCodesForUserApiArg
        >({
            query: () => ({url: `/api/metainformation/customerdataentrycodes`}),
        }),
        getCustomerDataEntryCodes: build.query<
            GetCustomerDataEntryCodesApiResponse,
            GetCustomerDataEntryCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/metainformation/customerdataentrycodes/${queryArg.billToId}`,
            }),
        }),
        getIa360ReportingLink: build.query<
            GetIa360ReportingLinkApiResponse,
            GetIa360ReportingLinkApiArg
        >({
            query: (queryArg) => ({
                url: `/api/metainformation/ia360reportinglink`,
                params: {
                    carrierId: queryArg.carrierId,
                    invoiceNum: queryArg.invoiceNum,
                },
            }),
        }),
        getInvoiceStatusCodes: build.query<
            GetInvoiceStatusCodesApiResponse,
            GetInvoiceStatusCodesApiArg
        >({
            query: () => ({url: `/api/metainformation/invoicestatuscodes`}),
        }),
        getEntryMethods: build.query<
            GetEntryMethodsApiResponse,
            GetEntryMethodsApiArg
        >({
            query: () => ({url: `/api/metainformation/entrymethods`}),
        }),
        getActivityCodes: build.query<
            GetActivityCodesApiResponse,
            GetActivityCodesApiArg
        >({
            query: () => ({url: `/api/metainformation/activitycodes`}),
        }),
        getInvoiceTypeList: build.query<
            GetInvoiceTypeListApiResponse,
            GetInvoiceTypeListApiArg
        >({
            query: () => ({url: `/api/metainformation/invoicetypes`}),
        }),
        getIbobsList: build.query<GetIbobsListApiResponse, GetIbobsListApiArg>({
            query: () => ({url: `/api/metainformation/ib-obs`}),
        }),
        getReportNameList: build.query<
            GetReportNameListApiResponse,
            GetReportNameListApiArg
        >({
            query: () => ({url: `/api/metainformation/reportnames`}),
        }),
        getQueueIsActive: build.query<
            GetQueueIsActiveApiResponse,
            GetQueueIsActiveApiArg
        >({
            query: (queryArg) => ({
                url: `/api/metainformation/queue/${queryArg.queue}`,
            }),
        }),
        getAscRefCodes: build.query<
            GetAscRefCodesApiResponse,
            GetAscRefCodesApiArg
        >({
            query: () => ({url: `/api/metainformation/ascrefcodes`}),
        }),
        getAscChargeCodes: build.query<
            GetAscChargeCodesApiResponse,
            GetAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/metainformation/ascchargecodes`,
                params: {sorted: queryArg.sorted},
            }),
        }),
        getTransportModes: build.query<
            GetTransportModesApiResponse,
            GetTransportModesApiArg
        >({
            query: () => ({url: `/api/metainformation/modes`}),
        }),
        getParties: build.query<GetPartiesApiResponse, GetPartiesApiArg>({
            query: (queryArg) => ({
                url: `/api/party/${queryArg.customerId}/${queryArg.partyType}/${queryArg.zipSearch}`,
            }),
        }),
        getUnMadeAchPayments: build.query<
            GetUnMadeAchPaymentsApiResponse,
            GetUnMadeAchPaymentsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablebatch/ach`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        generateAcHes: build.mutation<
            GenerateAcHesApiResponse,
            GenerateAcHesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablebatch/ach`,
                method: 'POST',
                body: queryArg.body,
                params: {procDate: queryArg.procDate},
            }),
        }),
        getAchDates: build.query<GetAchDatesApiResponse, GetAchDatesApiArg>({
            query: () => ({url: `/api/payablebatch/achdates`}),
        }),
        getAchFilesForDate: build.query<
            GetAchFilesForDateApiResponse,
            GetAchFilesForDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablebatch/files/${queryArg.procDate}`,
            }),
        }),
        getCarrierPayableExceptionsById: build.query<
            GetCarrierPayableExceptionsByIdApiResponse,
            GetCarrierPayableExceptionsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablesexceptions/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createCarrierPayException: build.mutation<
            CreateCarrierPayExceptionApiResponse,
            CreateCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablesexceptions`,
                method: 'POST',
                body: queryArg.payablesExceptionsVm,
            }),
        }),
        modifyCarrierPayException: build.mutation<
            ModifyCarrierPayExceptionApiResponse,
            ModifyCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablesexceptions/${queryArg.exceptionId}`,
                method: 'PUT',
                body: queryArg.payablesExceptionsVm,
            }),
        }),
        deleteCarrierPayException: build.mutation<
            DeleteCarrierPayExceptionApiResponse,
            DeleteCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/payablesexceptions/${queryArg.exceptionId}`,
                method: 'DELETE',
            }),
        }),
        getAllPayDayStarts: build.query<
            GetAllPayDayStartsApiResponse,
            GetAllPayDayStartsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/paydaysstart`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getPermittedValsByCustomer: build.query<
            GetPermittedValsByCustomerApiResponse,
            GetPermittedValsByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/permittedvalues/${queryArg.customerId}/${queryArg.carrierId}/${queryArg.code}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        getInvoicePermittedValues: build.query<
            GetInvoicePermittedValuesApiResponse,
            GetInvoicePermittedValuesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/permittedvalues/invoice/${queryArg.customerId}/${queryArg.carrierId}`,
            }),
        }),
        createPermittedValue: build.mutation<
            CreatePermittedValueApiResponse,
            CreatePermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/permittedvalues`,
                method: 'POST',
                body: queryArg.permittedValuesVm,
            }),
        }),
        modifyPermittedValue: build.mutation<
            ModifyPermittedValueApiResponse,
            ModifyPermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/permittedvalues/${queryArg.valId}`,
                method: 'PUT',
                body: queryArg.permittedValuesVm,
            }),
        }),
        deletePermittedValue: build.mutation<
            DeletePermittedValueApiResponse,
            DeletePermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/permittedvalues/${queryArg.valId}`,
                method: 'DELETE',
            }),
        }),
        getPostalCodes: build.query<
            GetPostalCodesApiResponse,
            GetPostalCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/postalcode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createPostalCode: build.mutation<
            CreatePostalCodeApiResponse,
            CreatePostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/postalcode`,
                method: 'POST',
                body: queryArg.postalCodeVm,
            }),
        }),
        modifyPostalCode: build.mutation<
            ModifyPostalCodeApiResponse,
            ModifyPostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/postalcode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.postalCodeVm,
            }),
        }),
        deletePostalCode: build.mutation<
            DeletePostalCodeApiResponse,
            DeletePostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/postalcode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getAllChecks: build.query<GetAllChecksApiResponse, GetAllChecksApiArg>({
            query: (queryArg) => ({
                url: `/api/printchecks/${queryArg.acctNum}`,
            }),
        }),
        getChecksForDate: build.query<
            GetChecksForDateApiResponse,
            GetChecksForDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/printchecks/${queryArg.acctNum}/${queryArg.searchDate}`,
            }),
        }),
        getReprintChecksForDate: build.query<
            GetReprintChecksForDateApiResponse,
            GetReprintChecksForDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/printchecks/reprint/${queryArg.acctNum}/${queryArg.payDate}`,
            }),
        }),
        makeNewBatches: build.mutation<
            MakeNewBatchesApiResponse,
            MakeNewBatchesApiArg
        >({
            query: () => ({
                url: `/api/printchecks/makebatches`,
                method: 'POST',
            }),
        }),
        printChecks: build.mutation<PrintChecksApiResponse, PrintChecksApiArg>({
            query: (queryArg) => ({
                url: `/api/printchecks/print`,
                method: 'POST',
                body: queryArg.printCheckRequestVm,
            }),
        }),
        reprintChecks: build.mutation<
            ReprintChecksApiResponse,
            ReprintChecksApiArg
        >({
            query: (queryArg) => ({
                url: `/api/printchecks/reprint`,
                method: 'POST',
                body: queryArg.reprintCheckRequestVm,
            }),
        }),
        getCheckDates: build.query<
            GetCheckDatesApiResponse,
            GetCheckDatesApiArg
        >({
            query: () => ({url: `/api/printchecks/checkdates`}),
        }),
        getPrintedChecksForDate: build.query<
            GetPrintedChecksForDateApiResponse,
            GetPrintedChecksForDateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/printchecks/checks/${queryArg.checkDate}`,
            }),
        }),
        getReceipts: build.query<GetReceiptsApiResponse, GetReceiptsApiArg>({
            query: (queryArg) => ({
                url: `/api/receipts/${queryArg.customerId}/${queryArg.startDate}/${queryArg.endDate}`,
            }),
        }),
        mergeReceipts: build.mutation<
            MergeReceiptsApiResponse,
            MergeReceiptsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receipts/merge`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getApprovedInvoices: build.query<
            GetApprovedInvoicesApiResponse,
            GetApprovedInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds/${queryArg.customerId}`,
            }),
        }),
        getUnappliedCash: build.query<
            GetUnappliedCashApiResponse,
            GetUnappliedCashApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds/unapplied/${queryArg.customerId}`,
            }),
        }),
        receiveFunds: build.mutation<
            ReceiveFundsApiResponse,
            ReceiveFundsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds`,
                method: 'POST',
                body: queryArg.receiveFundsVm,
            }),
        }),
        useUnappliedCash: build.mutation<
            UseUnappliedCashApiResponse,
            UseUnappliedCashApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds/receiveunapplied`,
                method: 'POST',
                body: queryArg.useUnappliedCashVm,
            }),
        }),
        depositFunds: build.mutation<
            DepositFundsApiResponse,
            DepositFundsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds/deposit`,
                method: 'POST',
                body: queryArg.depositFundsVm,
            }),
        }),
        createCredit: build.mutation<
            CreateCreditApiResponse,
            CreateCreditApiArg
        >({
            query: (queryArg) => ({
                url: `/api/receivefunds/credit`,
                method: 'POST',
                body: queryArg.receiveCreditVm,
            }),
        }),
        getApiReporting: build.query<
            GetApiReportingApiResponse,
            GetApiReportingApiArg
        >({
            query: () => ({url: `/api/reporting`}),
        }),
        getBookmarksForUser: build.query<
            GetBookmarksForUserApiResponse,
            GetBookmarksForUserApiArg
        >({
            query: () => ({url: `/api/reporting/bookmark`}),
        }),
        createBookmark: build.mutation<
            CreateBookmarkApiResponse,
            CreateBookmarkApiArg
        >({
            query: (queryArg) => ({
                url: `/api/reporting/bookmark`,
                method: 'POST',
                body: queryArg.createReportBookmarkVm,
            }),
        }),
        deleteBookmark: build.mutation<
            DeleteBookmarkApiResponse,
            DeleteBookmarkApiArg
        >({
            query: (queryArg) => ({
                url: `/api/reporting/bookmark/${queryArg.id}`,
                method: 'DELETE',
            }),
        }),
        getStates: build.query<GetStatesApiResponse, GetStatesApiArg>({
            query: (queryArg) => ({
                url: `/api/states`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createStates: build.mutation<
            CreateStatesApiResponse,
            CreateStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/states`,
                method: 'POST',
                body: queryArg.statesVm,
            }),
        }),
        modifyStates: build.mutation<
            ModifyStatesApiResponse,
            ModifyStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/states/${queryArg.stateId}`,
                method: 'PUT',
                body: queryArg.statesVm,
            }),
        }),
        deleteStates: build.mutation<
            DeleteStatesApiResponse,
            DeleteStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/states/${queryArg.stateId}`,
                method: 'DELETE',
            }),
        }),
        getTimecardForUserId: build.query<
            GetTimecardForUserIdApiResponse,
            GetTimecardForUserIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/timecard`,
                params: {userId: queryArg.userId, date: queryArg.date},
            }),
        }),
        addTimeCard: build.mutation<AddTimeCardApiResponse, AddTimeCardApiArg>({
            query: (queryArg) => ({
                url: `/api/timecard`,
                method: 'POST',
                body: queryArg.userTimeCardVm,
            }),
        }),
        deleteTimeCard: build.mutation<
            DeleteTimeCardApiResponse,
            DeleteTimeCardApiArg
        >({
            query: (queryArg) => ({url: `/${queryArg.id}`, method: 'DELETE'}),
        }),
        getUserBillToInfoByCustomer: build.query<
            GetUserBillToInfoByCustomerApiResponse,
            GetUserBillToInfoByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userbillto/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                    $count: queryArg.$count,
                },
            }),
        }),
        createUserBillToInfo: build.mutation<
            CreateUserBillToInfoApiResponse,
            CreateUserBillToInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userbillto`,
                method: 'POST',
                body: queryArg.userBillToVm,
            }),
        }),
        deleteUserBillToInfo: build.mutation<
            DeleteUserBillToInfoApiResponse,
            DeleteUserBillToInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userbillto/${queryArg.customerId}/${queryArg.userId}`,
                method: 'DELETE',
            }),
        }),
        getMyConfig: build.query<GetMyConfigApiResponse, GetMyConfigApiArg>({
            query: () => ({url: `/api/userconfig`}),
        }),
        saveMyConfig: build.mutation<
            SaveMyConfigApiResponse,
            SaveMyConfigApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userconfig`,
                method: 'PUT',
                body: queryArg.userConfigurationVm,
            }),
        }),
        getUserConfiguration: build.query<
            GetUserConfigurationApiResponse,
            GetUserConfigurationApiArg
        >({
            query: (queryArg) => ({url: `/api/userconfig/${queryArg.userId}`}),
        }),
        saveUserConfig: build.mutation<
            SaveUserConfigApiResponse,
            SaveUserConfigApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userconfig/${queryArg.userId}`,
                method: 'PUT',
                body: queryArg.userConfigurationVm,
            }),
        }),
        getRoleAuths: build.query<GetRoleAuthsApiResponse, GetRoleAuthsApiArg>({
            query: (queryArg) => ({url: `/api/userrole/${queryArg.role}`}),
        }),
        createNewRole: build.mutation<
            CreateNewRoleApiResponse,
            CreateNewRoleApiArg
        >({
            query: (queryArg) => ({
                url: `/api/userrole`,
                method: 'POST',
                body: queryArg.userRoleDefinitionVm,
            }),
        }),
        updateRole: build.mutation<UpdateRoleApiResponse, UpdateRoleApiArg>({
            query: (queryArg) => ({
                url: `/api/userrole`,
                method: 'PUT',
                body: queryArg.functionalAuthVm,
            }),
        }),
        copyRole: build.mutation<CopyRoleApiResponse, CopyRoleApiArg>({
            query: (queryArg) => ({
                url: `/api/userrole/copy`,
                method: 'POST',
                body: queryArg.userRoleDefinitionVm,
                params: {copyRole: queryArg.copyRole},
            }),
        }),
        getAllUsers: build.query<GetAllUsersApiResponse, GetAllUsersApiArg>({
            query: () => ({url: `/api/users`}),
        }),
        updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
            query: (queryArg) => ({
                url: `/api/users`,
                method: 'PUT',
                body: queryArg.userAdminVm,
            }),
        }),
        getFullUserList: build.query<
            GetFullUserListApiResponse,
            GetFullUserListApiArg
        >({
            query: () => ({url: `/api/users/admin`}),
        }),
        getUserAdminInfo: build.query<
            GetUserAdminInfoApiResponse,
            GetUserAdminInfoApiArg
        >({
            query: (queryArg) => ({url: `/api/users/admin/${queryArg.userId}`}),
        }),
        getKnownCompanies: build.query<
            GetKnownCompaniesApiResponse,
            GetKnownCompaniesApiArg
        >({
            query: () => ({url: `/api/users/companies`}),
        }),
        addUser: build.mutation<AddUserApiResponse, AddUserApiArg>({
            query: (queryArg) => ({
                url: `/api/users/${queryArg.userId}`,
                method: 'POST',
            }),
        }),
        changePassword: build.mutation<
            ChangePasswordApiResponse,
            ChangePasswordApiArg
        >({
            query: (queryArg) => ({
                url: `/api/users/password`,
                method: 'POST',
                body: queryArg.userAdminPasswordVm,
            }),
        }),
        suspendUser: build.mutation<SuspendUserApiResponse, SuspendUserApiArg>({
            query: (queryArg) => ({
                url: `/api/users/suspend`,
                method: 'POST',
                body: queryArg.userAdminSuspendVm,
            }),
        }),
        getTimeCardUsers: build.query<
            GetTimeCardUsersApiResponse,
            GetTimeCardUsersApiArg
        >({
            query: () => ({url: `/api/users/timecardusers`}),
        }),
        getUserSessionsForUser: build.query<
            GetUserSessionsForUserApiResponse,
            GetUserSessionsForUserApiArg
        >({
            query: (queryArg) => ({
                url: `/api/users/sessions/${queryArg.userId}`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getMyUserSessions: build.query<
            GetMyUserSessionsApiResponse,
            GetMyUserSessionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/users/sessions`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getCarrInvStatsForUser: build.query<
            GetCarrInvStatsForUserApiResponse,
            GetCarrInvStatsForUserApiArg
        >({
            query: (queryArg) => ({
                url: `/api/users/carrinvstats/${queryArg.userId}`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getMyCarrInvStats: build.query<
            GetMyCarrInvStatsApiResponse,
            GetMyCarrInvStatsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/users/carrinvstats`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
    }),
    overrideExisting: false,
});
export {injectedRtkApi as paylogikApi};
export type RequeueJobApiResponse = unknown;
export type RequeueJobApiArg = {
    queuedDataKey?: string;
    process?: string;
};
export type GetAppDefaultsApiResponse =
    /** status 200 Success */ AppDefaultVm[];
export type GetAppDefaultsApiArg = void;
export type GetAppDefaultsQueryApiResponse =
    /** status 200 Success */ AppDefaultVm[];
export type GetAppDefaultsQueryApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type PutAppDefaultsApiResponse = unknown;
export type PutAppDefaultsApiArg = {
    /** ID of the AppDefault to update */
    parmId: string;
    /** AppDefaultVm object of the new AppDefault settings */
    appDefaultVm: AppDefaultVm;
};
export type PutSecureDefaultsApiResponse = unknown;
export type PutSecureDefaultsApiArg = {
    /** ID of the SecureDefault to update */
    parmId: string;
    /** SecureDefaultVm object of the new SecureDefault settings */
    secureDefaultVm: SecureDefaultVm;
};
export type GetSecureDefaultsQueryApiResponse =
    /** status 200 Success */ SecureDefaultVm[];
export type GetSecureDefaultsQueryApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetWebDefaultsApiResponse =
    /** status 200 Success */ AppDefaultVm[];
export type GetWebDefaultsApiArg = void;
export type GetInvoicesApprovalPopulationDataApiResponse =
    /** status 200 Success */ InvoiceApprovalOptionsVm;
export type GetInvoicesApprovalPopulationDataApiArg = void;
export type GetInvoicesNeedingApprovalApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type GetInvoicesNeedingApprovalApiArg = {
    invoiceApprovalOptionsVm: InvoiceApprovalOptionsVm;
};
export type GetMinimalInvoiceDetailApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetMinimalInvoiceDetailApiArg = {
    id: number;
};
export type ApproveInvoicesApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type ApproveInvoicesApiArg = {
    approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type SaveCurrentInvoiceStateApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type SaveCurrentInvoiceStateApiArg = {
    approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type PostApiApproveinvoicesFrominvoiceidxsApiResponse = unknown;
export type PostApiApproveinvoicesFrominvoiceidxsApiArg = {
    body: number[];
};
export type GetAllAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm[];
export type GetAllAscChargeCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm;
export type CreateAscChargeCodesApiArg = {
    /** AscChargeCodeVm object for the charge code to add */
    ascChargeCodeVm: AscChargeCodeVm;
};
export type ModifyAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm;
export type ModifyAscChargeCodesApiArg = {
    /** ID of the charge code to update */
    codeId: string;
    /** AscChargeCodeVm object for the code to update */
    ascChargeCodeVm: AscChargeCodeVm;
};
export type DeleteAscChargeCodesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteAscChargeCodesApiArg = {
    /** ID of the charge code to remove */
    codeId: string;
};
export type GetInvoiceChargeTypesApiResponse =
    /** status 200 Success */ InvoiceChargeTypeVm[];
export type GetInvoiceChargeTypesApiArg = void;
export type GetAllAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm[];
export type GetAllAscRefCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm;
export type CreateAscRefCodesApiArg = {
    /** AscReferenceCodeVm object for the ref code to add */
    ascReferenceCodeVm: AscReferenceCodeVm;
};
export type ModifyAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm;
export type ModifyAscRefCodesApiArg = {
    /** ID of the ref code to update */
    codeId: string;
    /** AscReferenceCodeVm object for the state to update */
    ascReferenceCodeVm: AscReferenceCodeVm;
};
export type DeleteAscRefCodesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteAscRefCodesApiArg = {
    /** ID of the ref code to remove */
    codeId: string;
};
export type GetGenMilesApiResponse = /** status 200 Success */ number;
export type GetGenMilesApiArg = {
    auditMilesRequestVm: AuditMilesRequestVm;
};
export type LoginApiResponse = /** status 200 Success */ string;
export type LoginApiArg = {
    loginVm: LoginVm;
};
export type RefreshTokenApiResponse = /** status 200 Success */ string;
export type RefreshTokenApiArg = void;
export type LoginWithPermissionsApiResponse =
    /** status 200 Success */ LoginResponseVm;
export type LoginWithPermissionsApiArg = {
    loginVm: LoginVm;
};
export type RefreshWithPermissionsApiResponse =
    /** status 200 Success */ LoginResponseVm;
export type RefreshWithPermissionsApiArg = void;
export type LogOutApiResponse = unknown;
export type LogOutApiArg = void;
export type GetMyUserApiResponse = /** status 200 Success */ UserVm;
export type GetMyUserApiArg = void;
export type GetAllBankAccountsApiResponse =
    /** status 200 Success */ BankAccountVm[];
export type GetAllBankAccountsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type UpdateBankAccountApiResponse = /** status 200 Success */ undefined;
export type UpdateBankAccountApiArg = {
    /** BankAccountChangeVm object for the updated Bank Account */
    bankAccountChangeVm: BankAccountChangeVm;
};
export type GetBillToByIdApiResponse = /** status 200 Success */ BillToVm;
export type GetBillToByIdApiArg = {
    id: string;
};
export type GetDataEntryAscRefCodesApiResponse =
    /** status 200 Success */ CustomerDataEntryVm[];
export type GetDataEntryAscRefCodesApiArg = {
    id: string;
    carrierId: string;
};
export type GetAllBillToApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetAllBillToApiArg = void;
export type GetBillToForDisplayApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetBillToForDisplayApiArg = void;
export type GetUserCustomersApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetUserCustomersApiArg = void;
export type GetCentralSaltBillTosApiResponse =
    /** status 200 Success */ BillToMatchTableVm[];
export type GetCentralSaltBillTosApiArg = void;
export type GetAllBillTosForDisplayApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetAllBillTosForDisplayApiArg = void;
export type GetActiveBillTosForDisplayApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetActiveBillTosForDisplayApiArg = void;
export type GetCustomerByIdApiResponse = /** status 200 Success */ BillToVm;
export type GetCustomerByIdApiArg = {
    /** ID of the customer to load info on */
    customerId: string;
};
export type ModifyCustomersApiResponse = /** status 200 Success */ BillToVm;
export type ModifyCustomersApiArg = {
    /** ID of the customer to update */
    customerId: string;
    /** BillToVm object for the customer to update */
    billToVm: BillToVm;
};
export type DeleteCustomersApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustomersApiArg = {
    /** ID of the customer to remove */
    customerId: string;
};
export type GetAllCustomersApiResponse = /** status 200 Success */ BillToVm[];
export type GetAllCustomersApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCustomersApiResponse = /** status 200 Success */ BillToVm;
export type CreateCustomersApiArg = {
    /** BillToVm object for the customer to add */
    billToVm: BillToVm;
};
export type GetParentCustomersApiResponse =
    /** status 200 Success */ BillToVm[];
export type GetParentCustomersApiArg = void;
export type ActivateCustomersApiResponse = /** status 200 Success */
    | BillToVm
    | /** status 204 Update completed */ undefined;
export type ActivateCustomersApiArg = {
    /** ID of the customer to update */
    customerId: string;
    /** BillToActiveVm object for the customer to update */
    billToActiveVm: BillToActiveVm;
};
export type GetFeeInvoiceDataApiResponse =
    /** status 200 Success */ BillToFeeInvoiceVm;
export type GetFeeInvoiceDataApiArg = {
    /** ID of the customer to find fee invoice setup for */
    customerId: string;
};
export type SetFeeInvoiceDataApiResponse =
    /** status 200 Success */ BillToFeeInvoiceVm;
export type SetFeeInvoiceDataApiArg = {
    /** BillToFeeInvoiceVm object for the fee invoice setup */
    billToFeeInvoiceVm: BillToFeeInvoiceVm;
};
export type GetModeDefaultsByCustomerApiResponse =
    /** status 200 Success */ BillToModeDefaultVm[];
export type GetModeDefaultsByCustomerApiArg = {
    /** ID of the customer to load mode default info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateBillToModeDefaultApiResponse =
    /** status 200 Success */ BillToModeDefaultVm;
export type CreateBillToModeDefaultApiArg = {
    /** BillToModeDefaultVm object for the default mode to add */
    billToModeDefaultVm: BillToModeDefaultVm;
};
export type ModifyBillToModeDefaultApiResponse =
    /** status 200 Success */ BillToModeDefaultVm;
export type ModifyBillToModeDefaultApiArg = {
    /** GUID of the customer mode default to update */
    defaultId: string;
    /** BillToModeDefaultVm object for the default to update */
    billToModeDefaultVm: BillToModeDefaultVm;
};
export type DeleteBillToModeDefaultApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteBillToModeDefaultApiArg = {
    /** ID of the default to remove */
    defaultId: string;
};
export type GetGlRulesApiResponse =
    /** status 200 Success */ BtAccountRulesVm[];
export type GetGlRulesApiArg = {
    /** The ID of the customer to check for rules */
    customerId: string;
};
export type GetGlCodingPreviewApiResponse =
    /** status 200 Success */ BtCodingGridVm[];
export type GetGlCodingPreviewApiArg = {
    /** The ID of the customer to check for uncoded invoices */
    customerId: string;
    /** Oldest creation date to include invoices from */
    createDate: string;
};
export type GetGlOverwritePreviewApiResponse =
    /** status 200 Success */ BtCodingGridVm[];
export type GetGlOverwritePreviewApiArg = {
    /** The ID of the customer to check for invoices */
    customerId: string;
    /** Start of the date range to find invoices */
    fromDate: string;
    /** End of the date range to find invoices */
    toDate: string;
};
export type SaveGlRulesApiResponse = /** status 200 Success */ undefined;
export type SaveGlRulesApiArg = {
    /** A list of BtAccountRulesVm objects for the updated rules */
    body: BtAccountRulesVm[];
};
export type GlCodingBatchApiResponse =
    /** status 200 Success */ BtCodingGridVm[];
export type GlCodingBatchApiArg = {
    /** A list of invoice IDs (and maybe Line IDs) to run rules against */
    body: BtCodingRequestVm[];
};
export type GlCodingQueueApiResponse = /** status 200 Success */ undefined;
export type GlCodingQueueApiArg = {
    /** A BtCodingQueueVm object for the customer and date (range) to search for invoices to GL Code */
    btCodingQueueVm: BtCodingQueueVm;
};
export type GetBillToMapsByCarrierApiResponse =
    /** status 200 Success */ CarrBtMapVm[];
export type GetBillToMapsByCarrierApiArg = {
    /** ID of the carrier to load bill-to maps for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierBtMapApiResponse =
    /** status 200 Success */ CarrBtMapVm;
export type CreateCarrierBtMapApiArg = {
    /** CarrBtMapVm object for the mapping to add */
    carrBtMapVm: CarrBtMapVm;
};
export type DeleteCarrierBtMapApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierBtMapApiArg = {
    /** Carrier whose mapping to delete */
    carrId: string;
    /** Carrier account for mapping to delete */
    carrAcct: string;
    /** Bill-To ID for mapping to delete */
    btId: string;
};
export type GetVoidableChecksApiResponse =
    /** status 200 Success */ CheckInfoVm[];
export type GetVoidableChecksApiArg = {
    /** Parameters to direct the search */
    checkInfoSearchVm: CheckInfoSearchVm;
};
export type VoidChecksApiResponse = /** status 200 Success */ undefined;
export type VoidChecksApiArg = {
    /** Reason given to void these checks */
    reason?: string;
    /** List of check numbers to void */
    body: number[];
};
export type GetAllRemitsApiResponse =
    /** status 200 Success */ CarrierCheckRemitViewModel[];
export type GetAllRemitsApiArg = void;
export type MakeRemitsApiResponse =
    /** status 200 Success */ ProcessCheckProcessedArgs[];
export type MakeRemitsApiArg = {
    /** List of CarrierCheckRemitViewModel objects for checks to make remits for */
    body: CarrierCheckRemitViewModel[];
};
export type GetRemitsForChecksApiResponse =
    /** status 200 Success */ CarrierCheckRemitViewModel[];
export type GetRemitsForChecksApiArg = {
    /** Comma-delimited list of check numbers to find remit info for */
    checkNums: string;
};
export type GetRemitKeysApiResponse = /** status 200 Success */ string[];
export type GetRemitKeysApiArg = void;
export type GetRemitsForKeyApiResponse =
    /** status 200 Success */ CheckS3FileInfo[];
export type GetRemitsForKeyApiArg = {
    /** The S3 key to find remits for */
    remitKey: string;
};
export type GetCarrierEdiMasterByIdApiResponse =
    /** status 200 Success */ CarrEdiMasterVm[];
export type GetCarrierEdiMasterByIdApiArg = {
    /** ID of the carrier to load EDI info for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierEdiMasterApiResponse =
    /** status 200 Success */ CarrEdiMasterVm;
export type CreateCarrierEdiMasterApiArg = {
    /** CarrEdiMasterVm object for the EDI info to add */
    carrEdiMasterVm: CarrEdiMasterVm;
};
export type ModifyCarrierEdiMasterApiResponse =
    /** status 200 Success */ CarrEdiMasterVm;
export type ModifyCarrierEdiMasterApiArg = {
    /** Sender Qualifier for the EDI mapping to update */
    senderQual: string;
    /** Sender ID for the EDI mapping to update */
    senderId: string;
    /** Type of the EDI mapping to update */
    ediType: string;
    /** Receiver Qualifier for the EDI mapping to update */
    rcvQual: string;
    /** Receiver ID for the EDI mapping to update */
    rcvId: string;
    /** CarrEdiMasterVm object for the EDI Master Info to update */
    carrEdiMasterVm: CarrEdiMasterVm;
};
export type DeleteCarrierEdiMasterApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierEdiMasterApiArg = {
    /** Sender Qualifier for the EDI mapping to delete */
    senderQual: string;
    /** Sender ID for the EDI mapping to delete */
    senderId: string;
    /** Type of the EDI mapping to delete */
    ediType: string;
    /** Receiver Qualifier for the EDI mapping to delete */
    rcvQual: string;
    /** Receiver ID for the EDI mapping to delete */
    rcvId: string;
};
export type GetAllCarrierFamiliesApiResponse =
    /** status 200 Success */ CarrFamVm[];
export type GetAllCarrierFamiliesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetCarriersForDropdownApiResponse =
    /** status 200 Success */ CarrierMinimalVm[];
export type GetCarriersForDropdownApiArg = void;
export type GetActiveCarriersForDropdownApiResponse =
    /** status 200 Success */ CarrierMinimalVm[];
export type GetActiveCarriersForDropdownApiArg = void;
export type GetPermissionedCarriersForDropdownApiResponse =
    /** status 200 Success */ CarrierMinimalVm[];
export type GetPermissionedCarriersForDropdownApiArg = void;
export type GetByScacApiResponse = /** status 200 Success */ CarrierMinimalVm;
export type GetByScacApiArg = {
    scac: string;
};
export type GetCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type GetCarrierChargeCodeMappingApiArg = void;
export type GetCarrierChargeCodeMappingByIdApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type GetCarrierChargeCodeMappingByIdApiArg = {
    id: string;
};
export type AddNewCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type AddNewCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type UpdateCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type UpdateCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type DeletCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type DeletCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type GetCarrierChargeCodeMappingOverridesApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type GetCarrierChargeCodeMappingOverridesApiArg = void;
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg = {
    id: string;
};
export type AddNewCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type AddNewCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type UpdateCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm;
export type UpdateCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type DeleteCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type DeleteCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type GetCarrierByIdApiResponse = /** status 200 Success */ CarrierVm;
export type GetCarrierByIdApiArg = {
    /** ID of the carrier to load info on */
    carrierId: string;
};
export type GetAllCarriersApiResponse = /** status 200 Success */ CarrierVm[];
export type GetAllCarriersApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarriersApiResponse = /** status 200 Success */ CarrierVm;
export type CreateCarriersApiArg = {
    /** CarrierVm object for the carrier to add */
    carrierVm: CarrierVm;
};
export type ModifyCarriersApiResponse = /** status 200 Success */ CarrierVm;
export type ModifyCarriersApiArg = {
    /** ID of the carrier to update */
    carrierId: string;
    /** CarrierVm object for the carrier to update */
    carrierVm: CarrierVm;
};
export type DeleteCarriersApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarriersApiArg = {
    /** ID of the carrier to remove */
    carrierId: string;
};
export type ActivateCarriersApiResponse = /** status 200 Success */
    | CarrierVm
    | /** status 204 Deletion completed */ undefined;
export type ActivateCarriersApiArg = {
    /** ID of the carrier to remove */
    carrierId: string;
    /** CarrierActiveVm object for the carrier to update */
    carrierActiveVm: CarrierActiveVm;
};
export type GetModeOverridesApiResponse =
    /** status 200 Success */ BillToCarrierModeOverrideVm[];
export type GetModeOverridesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetSpecificModeOverrideApiResponse =
    /** status 200 Success */ BillToCarrierModeOverrideVm[];
export type GetSpecificModeOverrideApiArg = {
    btid: string;
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type DeleteModeOverrideApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteModeOverrideApiArg = {
    btid: string;
    /** ID of the carrier to remove */
    carrierId: string;
};
export type UpdateModeOverrideApiResponse =
    /** status 200 Success */ BillToCarrierModeOverrideVm;
export type UpdateModeOverrideApiArg = {
    billToCarrierModeOverrideVm: BillToCarrierModeOverrideVm;
};
export type AddModeOverrideApiResponse =
    /** status 200 Success */ BillToCarrierModeOverrideVm;
export type AddModeOverrideApiArg = {
    billToCarrierModeOverrideVm: BillToCarrierModeOverrideVm;
};
export type AddModeTypeApiResponse =
    /** status 200 Success */ CodeMasterVm;
export type AddModeTypeApiArg = {
    codeMasterVm: CodeMasterVm;
};
export type GetAllCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm[];
export type GetAllCarrierContactsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm;
export type CreateCarrierContactsApiArg = {
    /** CarrierContactVm object for the carrier to add */
    carrierContactVm: CarrierContactVm;
};
export type GetCarrierContactByIdApiResponse =
    /** status 200 Success */ CarrierContactVm[];
export type GetCarrierContactByIdApiArg = {
    /** ID of the carrier to load contacts for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type ModifyCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm;
export type ModifyCarrierContactsApiArg = {
    /** ID of the carrier contact to update */
    contactId: number;
    /** CarrierContactVm object for the contact to update */
    carrierContactVm: CarrierContactVm;
};
export type DeleteCarrierContactsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierContactsApiArg = {
    /** ID of the carrier contact to remove */
    contactId: number;
};
export type GetCarrierModeMapsByIdApiResponse =
    /** status 200 Success */ CarrierModeMapVm[];
export type GetCarrierModeMapsByIdApiArg = {
    /** ID of the carrier to load mode mappings for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierModeMapsApiResponse =
    /** status 200 Success */ CarrierModeMapVm;
export type CreateCarrierModeMapsApiArg = {
    /** CarrierModeMapVm object for the mapping to add */
    carrierModeMapVm: CarrierModeMapVm;
};
export type ModifyCarrierModeMapsApiResponse =
    /** status 200 Success */ CarrierModeMapVm;
export type ModifyCarrierModeMapsApiArg = {
    /** ID of the carrier mode mapping to update */
    mapId: number;
    /** CarrierModeMapVm object for the mapping to update */
    carrierModeMapVm: CarrierModeMapVm;
};
export type DeleteCarrierModeMapsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierModeMapsApiArg = {
    /** ID of the carrier mode map to remove */
    mapId: number;
};
export type GetPayMethodsForCarrierApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm[];
export type GetPayMethodsForCarrierApiArg = {
    /** ID of the carrier to pull payment info for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierPayRemitApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm;
export type CreateCarrierPayRemitApiArg = {
    /** CarrierPaymentRemitVm object for the payment/remit info to add */
    carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type ModifyCarrierPayRemitApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm;
export type ModifyCarrierPayRemitApiArg = {
    /** ID of the payment/remit info entry to update */
    remitInfoId: number;
    /** CarrierPaymentRemitVm object for the Payment/Remit Info to update */
    carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type DeleteCarrierPayRemitApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierPayRemitApiArg = {
    /** ID of the payment/remit info entry to delete */
    remitInfoId: number;
};
export type GetCarrierRemitMethodsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitMethodsApiArg = void;
export type GetCarrierRemitDeliveryMethodsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitDeliveryMethodsApiArg = void;
export type GetCarrierRemitFormatsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitFormatsApiArg = void;
export type GetAchSecCodesApiResponse = /** status 200 Success */ string[];
export type GetAchSecCodesApiArg = void;
export type GetCarrierInvoiceByIdApiResponse =
    /** status 200 Success */ CarrInvVm;
export type GetCarrierInvoiceByIdApiArg = {
    id: number;
};
export type DeleteInvoiceApiResponse = /** status 200 Success */ boolean;
export type DeleteInvoiceApiArg = {
    /** Internal ID of the invoice to delete */
    id: number;
};
export type GetCarrInvByInvNumApiResponse =
    /** status 200 Success */ CarrInvVm[];
export type GetCarrInvByInvNumApiArg = {
    /** Which kind of invoice (eg: CARRINV, MEMO) to load */
    recType: string;
    /** ID of the carrier whose invoices to search */
    carrId: string;
    /** Invoice # to load */
    invNum: string;
};
export type GetInvoiceSummaryApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetInvoiceSummaryApiArg = {
    id: number;
};
export type GetInvoiceLineSummaryApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetInvoiceLineSummaryApiArg = {
    id: number;
};
export type GetInvoiceChargeDetailsApiResponse =
    /** status 200 Success */ LineRcTariffQwMarksVm[];
export type GetInvoiceChargeDetailsApiArg = {
    id: number;
};
export type GetInvoiceLineChargeDetailsApiResponse =
    /** status 200 Success */ LineRcTariffQwMarksVm[];
export type GetInvoiceLineChargeDetailsApiArg = {
    id: number;
};
export type GetBundleInfoApiResponse =
    /** status 200 Success */ CarrInvLineBundleVm[];
export type GetBundleInfoApiArg = {
    /** ID of the bundle to load */
    bundleId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetAllInvoiceRevsApiResponse =
    /** status 200 Success */ CarrInvMinimalVm[];
export type GetAllInvoiceRevsApiArg = {
    /** The type of invoice record to load */
    recType: string;
    /** The ID of the carrier whose invoice to load */
    carrierId: string;
    /** The invoice number to load */
    invoiceNum: string;
};
export type CreateApiResponse = /** status 200 Success */ CarrInvMinimalVm;
export type CreateApiArg = {
    carrInvVm: CarrInvVm;
};
export type CreateWebInvoiceApiResponse = /** status 200 Success */ CarrInvVm;
export type CreateWebInvoiceApiArg = {
    /** CarrInvVm object to create the invoice with */
    carrInvVm: CarrInvVm;
};
export type UpdateWebInvoiceApiResponse = /** status 200 Success */ CarrInvVm;
export type UpdateWebInvoiceApiArg = {
    /** Comment to include in the update */
    comment?: string;
    /** CarrInvVm object to update the invoice to */
    carrInvVm: CarrInvVm;
};
export type InitiateMultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ InitiateMultiPartInvoiceCreationResponse;
export type InitiateMultiPartInvoiceCreationApiArg = {
    initiateMultiPartInvoiceCreationRequest: InitiateMultiPartInvoiceCreationRequest;
};
export type MultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ InvoicePartResponse;
export type MultiPartInvoiceCreationApiArg = {
    invoicePartRequest: InvoicePartRequest;
};
export type CompleteMultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ CompleteMultiPartInvoiceCreationResponse;
export type CompleteMultiPartInvoiceCreationApiArg = {
    completeMultiPartInvoiceCreationRequest: CompleteMultiPartInvoiceCreationRequest;
};
export type AbortMultiPartInvoiceCreationApiResponse = unknown;
export type AbortMultiPartInvoiceCreationApiArg = {
    abortMultiPartInvoiceCreationRequest: AbortMultiPartInvoiceCreationRequest;
};
export type CreateQueuedApiResponse =
    /** status 200 Success */ QueuedInvoiceCreationResponse;
export type CreateQueuedApiArg = {
    carrInvVm: CarrInvVm;
};
export type PostApiCarrinvCheckqueuedinvoicecreationstateApiResponse =
    /** status 200 Success */ InvoiceCreationStatusResponse;
export type PostApiCarrinvCheckqueuedinvoicecreationstateApiArg = {
    invoiceCreationStatusRequest: InvoiceCreationStatusRequest;
};
export type ReAuditApiResponse = /** status 200 Success */ CarrInvVm;
export type ReAuditApiArg = {
    /** Internal ID of the invoice to re-audit */
    id: number;
};
export type TestAuditApiResponse = /** status 200 Success */ CarrInvVm;
export type TestAuditApiArg = {
    /** CarrInvVm object of the invoice to re-audit */
    carrInvVm: CarrInvVm;
};
export type DeleteShipmentApiResponse = /** status 200 Success */ boolean;
export type DeleteShipmentApiArg = {
    /** Internal ID of the shipment to delete */
    id: number;
};
export type MakeInvoiceMemoApiResponse = /** status 200 Success */ boolean;
export type MakeInvoiceMemoApiArg = {
    /** Internal ID of the invoice to memo-ify */
    id?: number;
    /** Additional comment to add for this action */
    comment?: string;
};
export type MakeInvoiceRealApiResponse = /** status 200 Success */ boolean;
export type MakeInvoiceRealApiArg = {
    /** Internal ID of the invoice to restore */
    id?: number;
    /** Additional comment to add for this action */
    comment?: string;
};
export type ReassignInvoiceCustomerApiResponse =
    /** status 200 Success */ boolean;
export type ReassignInvoiceCustomerApiArg = {
    /** CarrInvCustChangeVm object for the requested change */
    carrInvCustChangeVm: CarrInvCustChangeVm;
};
export type ReassignInvoiceNumberApiResponse =
    /** status 200 Success */ boolean;
export type ReassignInvoiceNumberApiArg = {
    /** CarrInvNumberChangeVm object for the requested change */
    carrInvNumberChangeVm: CarrInvNumberChangeVm;
};
export type ValidateCodingApiResponse = /** status 200 Success */ string;
export type ValidateCodingApiArg = {
    id: number;
    isSave?: boolean;
    isFromApp?: boolean;
};
export type ValidateLineCodingApiResponse = /** status 200 Success */ string;
export type ValidateLineCodingApiArg = {
    id: number;
    lineIdx: number;
    isSave?: boolean;
    isFromApp?: boolean;
};
export type CreateBillingInvoiceApiResponse = /** status 200 Success */
    | CarrInvVm
    | /** status 204 Returns 204 if no billing invoice was created. */ undefined;
export type CreateBillingInvoiceApiArg = {
    id: number;
    handledInvoiceException?: boolean;
    createPdf?: boolean;
    createDupeIfExists?: boolean;
};
export type CreateBillingInvoiceQueuedApiResponse = /** status 200 Success */
    | CarrInvVm
    | /** status 202  */ undefined;
export type CreateBillingInvoiceQueuedApiArg = {
    id: number;
    handledInvoiceException?: boolean;
    createPdf?: boolean;
};
export type CreatePdfInvoiceApiResponse = unknown;
export type CreatePdfInvoiceApiArg = {
    id: number;
};
export type CreatePdfInvoiceQueuedApiResponse = unknown;
export type CreatePdfInvoiceQueuedApiArg = {
    id: number;
};
export type RegeneratePdfInvoiceApiResponse = unknown;
export type RegeneratePdfInvoiceApiArg = {
    id: number;
};
export type GetImagesForInvoiceApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm[];
export type GetImagesForInvoiceApiArg = {
    id: number;
};
export type AddImageApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type AddImageApiArg = {
    id: number;
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type ClearCachedImagesForInvoiceApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm[];
export type ClearCachedImagesForInvoiceApiArg = {
    id: number;
};
export type GetImageWithDataApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageWithDataApiArg = {
    id: number;
    imageId: number;
};
export type GetImageWithDataFromObjectApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageWithDataFromObjectApiArg = {
    id: number;
    imageId: string;
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type GetInvoiceEdiApiResponse = /** status 200 Success */ CarrInvEdiVm;
export type GetInvoiceEdiApiArg = {
    /** Internal invoice ID to look up against */
    id: number;
};
export type CarrInvDisconnectImageApiResponse = unknown;
export type CarrInvDisconnectImageApiArg = {
    id: number;
    imageId: number;
};
export type WhatIfChargeCodesForNewBilltoApiResponse =
    /** status 200 Success */ WhatIfChargeCodeMapVm[];
export type WhatIfChargeCodesForNewBilltoApiArg = {
    id: number;
    newBillToId: string;
};
export type GetInvoicesForBatchingApiResponse =
    /** status 200 Success */ GetBatchableInvoicesCustomerVm[];
export type GetInvoicesForBatchingApiArg = {
    /** The date to search until for invoices */
    searchDate: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetAllCarrServicesApiResponse =
    /** status 200 Success */ CarrServicesVm[];
export type GetAllCarrServicesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierServicesApiResponse =
    /** status 200 Success */ CarrServicesVm;
export type CreateCarrierServicesApiArg = {
    /** CarrServicesVm object for the service to add */
    carrServicesVm: CarrServicesVm;
};
export type GetCarrierServicesByIdApiResponse =
    /** status 200 Success */ CarrServicesVm[];
export type GetCarrierServicesByIdApiArg = {
    /** ID of the carrier to load services for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type ModifyCarrierServiceApiResponse =
    /** status 200 Success */ CarrServicesVm;
export type ModifyCarrierServiceApiArg = {
    /** Which carrier to update a code for */
    carrierId: string;
    /** Which code for the carrier to update */
    svcCode: string;
    /** CarrServicesVm object for the service to update */
    carrServicesVm: CarrServicesVm;
};
export type DeleteCarrierServicesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierServicesApiArg = {
    /** Which carrier to delete a code for */
    carrierId: string;
    /** Which code for the carrier to delete */
    svcCode: string;
};
export type GetAllowedCarrSvcAuditFnsApiResponse =
    /** status 200 Success */ string[];
export type GetAllowedCarrSvcAuditFnsApiArg = void;
export type GetTicketApiResponse = /** status 200 Success */ CentralSaltMatchVm;
export type GetTicketApiArg = {
    /** ID of the customer (a Central Salt customer) */
    customerId: string;
    /** ID of the carrier to check for a ticket */
    carrierId: string;
    /** The ticket number we're looking up */
    ticketNum: string;
};
export type MakeCSaltInvoiceApiResponse = unknown;
export type MakeCSaltInvoiceApiArg = {
    /** CentralSaltVm object for the ticket data */
    centralSaltVm: CentralSaltVm;
};
export type GetRegisterFbOsApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetRegisterFbOsApiArg = void;
export type GetRegisterInfoApiResponse =
    /** status 200 Success */ CheckRegisterVm[];
export type GetRegisterInfoApiArg = {
    /** CheckRegisterRequestVm object for the register search terms */
    checkRegisterRequestVm: CheckRegisterRequestVm;
};
export type GetAllCmContractsApiResponse =
    /** status 200 Success */ CmContractVm[];
export type GetAllCmContractsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCmContractsApiResponse =
    /** status 200 Success */ CmContractVm;
export type CreateCmContractsApiArg = {
    /** CmContractVm object for the contract to add */
    cmContractVm: CmContractVm;
};
export type ModifyCmContractsApiResponse =
    /** status 200 Success */ CmContractVm;
export type ModifyCmContractsApiArg = {
    /** ID of the carrier used in the contract to update */
    carrier: string;
    /** ID of the customer used in the contract to update */
    customer: string;
    /** Service used in the contract to update */
    service: string;
    /** CmContractVm object for the contract to update */
    cmContractVm: CmContractVm;
};
export type DeleteCmContractsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCmContractsApiArg = {
    /** ID of the carrier used in the contract to remove */
    carrier: string;
    /** ID of the customer used in the contract to remove */
    customer: string;
    /** Service used in the contract to remove */
    service: string;
};
export type GetAllMasterCodesApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetAllMasterCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetMasterCodesForElementApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetMasterCodesForElementApiArg = {
    /** Master Code element to search on */
    element: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type ModifyMasterCodesApiResponse =
    /** status 200 Success */ CodeMasterVm;
export type ModifyMasterCodesApiArg = {
    /** element of the Master Code to update */
    element: string;
    /** code of the Master Code to update */
    code: string;
    /** CodeMasterVm object for the state to update */
    codeMasterVm: CodeMasterVm;
};
export type GetMasterCodeFiltersApiResponse =
    /** status 200 Success */ CodeMasterElements;
export type GetMasterCodeFiltersApiArg = void;
export type GetActiveCurrencyCodesApiResponse =
    /** status 200 Success */ CurrencyVm[];
export type GetActiveCurrencyCodesApiArg = void;
export type GetAuditFailCodesApiResponse =
    /** status 200 Success */ StatusMasterVm[];
export type GetAuditFailCodesApiArg = void;
export type GetPreReqStatusesApiResponse =
    /** status 200 Success */ StatusCodeVm[];
export type GetPreReqStatusesApiArg = void;
export type GetCustomerContactsByIdApiResponse =
    /** status 200 Success */ ContactsVm[];
export type GetCustomerContactsByIdApiArg = {
    /** ID of the customer to load contacts for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCustomerContactsApiResponse =
    /** status 200 Success */ ContactsVm;
export type CreateCustomerContactsApiArg = {
    /** ContactsVm object for the contact to add */
    contactsVm: ContactsVm;
};
export type ModifyCustomerContactsApiResponse =
    /** status 200 Success */ ContactsVm;
export type ModifyCustomerContactsApiArg = {
    /** ID of the customer contact to update */
    contactId: number;
    /** ContactsVm object for the contact to update */
    contactsVm: ContactsVm;
};
export type DeleteCustomerContactsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustomerContactsApiArg = {
    /** ID of the customer contact to remove */
    contactId: number;
};
export type GetAllCurrenciesApiResponse =
    /** status 200 Success */ CurrenciesVm[];
export type GetAllCurrenciesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetRefDefsApiResponse =
    /** status 200 Success */ CustomerDataEntryGridVm[];
export type GetRefDefsApiArg = {
    /** ID of the customer to load reference definitions for */
    customerId: string;
    /** ID of the carrier to load reference definitions for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetCustomerRefDefsApiResponse =
    /** status 200 Success */ CustomerDataEntryCodeListVm[];
export type GetCustomerRefDefsApiArg = {
    /** ID of the customer to load reference definitions for */
    customerId: string;
};
export type GetRefDefsForInvoiceApiResponse =
    /** status 200 Success */ CustomerDataEntryVm[];
export type GetRefDefsForInvoiceApiArg = {
    /** ID of the customer to load reference definitions for */
    customerId: string;
    /** ID of the carrier to load reference definitions for */
    carrierId: string;
};
export type CreateRefDefApiResponse =
    /** status 200 Success */ CustomerDataEntryVm;
export type CreateRefDefApiArg = {
    /** CustomerDataEntryVm object for the reference definition to add */
    customerDataEntryVm: CustomerDataEntryVm;
};
export type ModifyRefDefApiResponse =
    /** status 200 Success */ CustomerDataEntryVm;
export type ModifyRefDefApiArg = {
    /** ID of the reference definition to update */
    defId: number;
    /** CustomerDataEntryVm object for the reference definition to update */
    customerDataEntryVm: CustomerDataEntryVm;
};
export type DeleteRefDefApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteRefDefApiArg = {
    /** ID of the definition to remove */
    defId: number;
};
export type CreateAndPrepBatchesApiResponse = unknown;
export type CreateAndPrepBatchesApiArg = {
    /** CreateReceivableBatchesForCustomersVm object for the invoices to batch */
    createReceivableBatchesForCustomersVm: CreateReceivableBatchesForCustomersVm;
};
export type GetChildBatchesApiResponse =
    /** status 200 Success */ ChildBatchResultVm[];
export type GetChildBatchesApiArg = {
    /** Customer to look up child batch info for */
    customer: string;
    /** The date to search for batches until */
    reqDate: string;
};
export type CreateAndPrepBatchesFromInvoicesApiResponse = unknown;
export type CreateAndPrepBatchesFromInvoicesApiArg = {
    /** List of invoice IDXs to include in the batch */
    body: number[];
};
export type GetAgedReceivablesApiResponse =
    /** status 200 Success */ AgedReceivablesVm[];
export type GetAgedReceivablesApiArg = void;
export type GetListApiResponse = /** status 200 Success */ CustPaySetupVm[];
export type GetListApiArg = void;
export type UpsertApiResponse = /** status 200 Success */ CustPaySetupVm;
export type UpsertApiArg = {
    custPaySetupVm: CustPaySetupVm;
};
export type GetCustPayByBillToIdByIdApiResponse =
    /** status 200 Success */ CustPaySetupVm[];
export type GetCustPayByBillToIdByIdApiArg = {
    id: string;
};
export type GetCustPaySetupByIdApiResponse =
    /** status 200 Success */ CustPaySetupVm[];
export type GetCustPaySetupByIdApiArg = {
    /** ID of the customer to load pay setup for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCustPaySetupApiResponse =
    /** status 200 Success */ CustPaySetupVm;
export type CreateCustPaySetupApiArg = {
    /** ID of the customer to add pay setup to */
    customerId: string;
    /** CustPaySetupVm object for the setup to add */
    custPaySetupVm: CustPaySetupVm;
};
export type ModifyCustPaySetupApiResponse =
    /** status 200 Success */ CustPaySetupVm;
export type ModifyCustPaySetupApiArg = {
    /** ID of the customer pay setup to update */
    setupId: number;
    /** CustPaySetupVm object for the setup to update */
    custPaySetupVm: CustPaySetupVm;
};
export type DeleteCustPaySetupApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustPaySetupApiArg = {
    /** ID of the customer pay setup to remove */
    setupId: number;
};
export type GetShipmentCountByStatusApiResponse =
    /** status 200 Success */ ShipmentCountByStatusVm[];
export type GetShipmentCountByStatusApiArg = void;
export type GetAgedInvoiceSummaryApiResponse =
    /** status 200 Success */ AgedInvoiceSummaryVm[];
export type GetAgedInvoiceSummaryApiArg = void;
export type GetDataEntryAdminInfoByCustomerApiResponse =
    /** status 200 Success */ DeAdminVm[];
export type GetDataEntryAdminInfoByCustomerApiArg = {
    /** ID of the customer to load data entry admin info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetDataEntryAdminInfoForInvoiceApiResponse =
    /** status 200 Success */ DeAdminVm;
export type GetDataEntryAdminInfoForInvoiceApiArg = {
    /** ID of the customer to load data entry admin info for */
    customerId: string;
    /** ID of the carrier to load data entry admin info for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type ModifyDataEntryAdminInfoApiResponse =
    /** status 200 Success */ DeAdminVm;
export type ModifyDataEntryAdminInfoApiArg = {
    /** ID of the customer whose DE Admin info to update */
    customerId: string;
    /** ID of the carrier whose DE Admin info to update */
    carrierId: string;
    /** DEAdminVm object for the admin info to update */
    deAdminVm: DeAdminVm;
};
export type DeleteDataEntryAdminInfoApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteDataEntryAdminInfoApiArg = {
    /** ID of the customer whose DE Admin info to delete */
    customerId: string;
    /** ID of the carrier whose DE Admin info to delete */
    carrierId: string;
};
export type CreateDataEntryAdminInfoApiResponse =
    /** status 200 Success */ DeAdminVm;
export type CreateDataEntryAdminInfoApiArg = {
    /** DEAdminVm object for the admin info to add */
    deAdminVm: DeAdminVm;
};
export type InvoiceResearchExportApiResponse =
    /** status 200 Success */ DataExportsVm[];
export type InvoiceResearchExportApiArg = {
    userJobName?: string;
    fileFormat?: ExportFileFormat;
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetDataExportsApiResponse =
    /** status 200 Success */ DataExportsVm[];
export type GetDataExportsApiArg = void;
export type DeleteExportApiResponse = /** status 200 Success */ DataExportsVm[];
export type DeleteExportApiArg = {
    id: number;
};
export type SendMailWithOutAttachmentsApiResponse = unknown;
export type SendMailWithOutAttachmentsApiArg = {
    emailVm: EmailVm;
};
export type GetActiveEquipsForDropdownApiResponse =
    /** status 200 Success */ EquipmentVm[];
export type GetActiveEquipsForDropdownApiArg = void;
export type GetInvoiceHistoryApiResponse =
    /** status 200 Success */ CustFeesHdrVm[];
export type GetInvoiceHistoryApiArg = {
    /** ID of the customer to find invoices for */
    customerId: string;
    /** Start of the search range */
    startDate: string;
    /** End of the search range */
    endDate: string;
};
export type GetInvoiceRangeApiResponse =
    /** status 200 Success */ CustFeesRangeHdrVm[];
export type GetInvoiceRangeApiArg = {
    /** CustFeesRangeRequestVm object for search parameters */
    custFeesRangeRequestVm: CustFeesRangeRequestVm;
};
export type GetInvoiceHistoryDetailsApiResponse =
    /** status 200 Success */ CustFeesDetailVm[];
export type GetInvoiceHistoryDetailsApiArg = {
    /** ID of the customer to find invoice details for */
    customerId: string;
    /** ID of the invoice to find details for */
    invoiceId: string;
};
export type GetInvoiceRangeDetailsApiResponse =
    /** status 200 Success */ CustFeesDetailVm[];
export type GetInvoiceRangeDetailsApiArg = {
    /** ID of the customer to find invoice details for */
    customerId: string;
    /** ID of the invoice to find details for */
    invoiceId: string;
};
export type GenerateInvoiceDetailReportApiResponse =
    /** status 200 Success */ CustFeesDetailReportVm;
export type GenerateInvoiceDetailReportApiArg = {
    /** ID of the customer to make report for */
    customerId: string;
    /** ID of the invoice to make report for */
    invoiceId: string;
};
export type DeleteFeesInvoiceApiResponse = /** status 200 Success */ undefined;
export type DeleteFeesInvoiceApiArg = {
    /** ID of the invoice to delete */
    invoiceId: string;
};
export type RenameFeesInvoiceApiResponse = /** status 200 Success */ undefined;
export type RenameFeesInvoiceApiArg = {
    /** CustFeesChangeInvNumVm objcet for the invoice number change */
    custFeesChangeInvNumVm: CustFeesChangeInvNumVm;
};
export type ImportInvoicesApiResponse = /** status 200 Success */ undefined;
export type ImportInvoicesApiArg = {
    /** CustFeesImportRequestVm object for import information */
    custFeesImportRequestVm: CustFeesImportRequestVm;
};
export type GetImportDatesApiResponse = /** status 200 Success */ string[];
export type GetImportDatesApiArg = void;
export type GetImportReportsForDateApiResponse =
    /** status 200 Success */ CheckS3FileInfo[];
export type GetImportReportsForDateApiArg = {
    /** The date to search for import reports */
    importDate: string;
};
export type GetTermsCustomersApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetTermsCustomersApiArg = {
    /** Do we want pay-to-terms customers, or non-pay-to-terms ones? */
    isPayToTerms: boolean;
};
export type TestNonPayInvoicesApiResponse =
    /** status 200 Success */ CustFeesInvoiceTestResultsVm;
export type TestNonPayInvoicesApiArg = {
    /** CustFeesMakeInvoiceRequestVm object for the invoice creation test parameters */
    custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type MakeNonPayInvoicesApiResponse = /** status 200 Success */ undefined;
export type MakeNonPayInvoicesApiArg = {
    /** CustFeesMakeInvoiceRequestVm object for the invoice creation parameters */
    custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type TestPayInvoicesApiResponse =
    /** status 200 Success */ CustFeesInvoiceTestResultsVm;
export type TestPayInvoicesApiArg = {
    /** CustFeesMakeInvoiceRequestVm object for the invoice creation test parameters */
    custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type MakePayInvoicesApiResponse = /** status 200 Success */ undefined;
export type MakePayInvoicesApiArg = {
    /** CustFeesMakeInvoiceRequestVm object for the invoice creation parameters */
    custFeesMakeInvoiceRequestVm: CustFeesMakeInvoiceRequestVm;
};
export type GetCompareRulesApiResponse =
    /** status 200 Success */ CustFeesRuleComparisonVm;
export type GetCompareRulesApiArg = {
    /** ID of the customer to find rules for */
    customerId: string;
};
export type ConvertFeesAppRuleApiResponse = unknown;
export type ConvertFeesAppRuleApiArg = void;
export type GetCustomerRulesApiResponse =
    /** status 200 Success */ CustFeesRulesAndDetailsVm;
export type GetCustomerRulesApiArg = {
    /** ID of the customer to find rule data for */
    customerId: string;
};
export type GetRuleDataApiResponse =
    /** status 200 Success */ CustFeesRuleInfoVm;
export type GetRuleDataApiArg = {
    /** ID of the rule to load */
    ruleId: number;
};
export type DeleteFeesRuleApiResponse = /** status 200 Success */ undefined;
export type DeleteFeesRuleApiArg = {
    /** ID of the rule to delete */
    ruleId: number;
};
export type CreateFeesRuleApiResponse =
    /** status 200 Success */ CustFeesRuleInfoVm;
export type CreateFeesRuleApiArg = {
    /** CustFeesRuleInfoVm object for the rule to create */
    custFeesRuleInfoVm: CustFeesRuleInfoVm;
};
export type UpdateFeesRuleApiResponse =
    /** status 200 Success */ CustFeesRuleInfoVm;
export type UpdateFeesRuleApiArg = {
    /** CustFeesRuleInfoVm object for the updated rule info */
    custFeesRuleInfoVm: CustFeesRuleInfoVm;
};
export type SetFeesRuleDetailApiResponse =
    /** status 200 Success */ CustFeesRuleTypeDetailsVm;
export type SetFeesRuleDetailApiArg = {
    /** CustFeesRuleTypeDetailsVm object for the rule type detail to create/update */
    custFeesRuleTypeDetailsVm: CustFeesRuleTypeDetailsVm;
};
export type GetRuleTypesApiResponse =
    /** status 200 Success */ CustFeesCategoryVm[];
export type GetRuleTypesApiArg = void;
export type GetBillPerTypesApiResponse =
    /** status 200 Success */ CustFeesCategoryVm[];
export type GetBillPerTypesApiArg = {
    /** Search for periodic types? */
    periodic: boolean;
};
export type GetIntDomTypesApiResponse =
    /** status 200 Success */ CustFeesCategoryVm[];
export type GetIntDomTypesApiArg = void;
export type BulkCodingApiResponse = unknown;
export type BulkCodingApiArg = {
    glBulkCodingRequest: GlBulkCodingRequest;
};
export type GetGlCodeForInvoiceApiResponse = unknown;
export type GetGlCodeForInvoiceApiArg = {
    glCodingRequest: GlCodingRequest;
};
export type PostHopkinsDepartmentApiResponse = unknown;
export type PostHopkinsDepartmentApiArg = {
    hopkinsDepartmentVm: HopkinsDepartmentVm;
};
export type GetHealthCheckApiResponse = unknown;
export type GetHealthCheckApiArg = void;
export type GetApiResponse = unknown;
export type GetApiArg = void;
export type GetImageApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageApiArg = {
    imageId: number;
};
export type DeleteImageApiResponse = unknown;
export type DeleteImageApiArg = {
    imageId: number;
};
export type DeleteMultipleImagesApiResponse = unknown;
export type DeleteMultipleImagesApiArg = {
    /** List of image IDs to delete */
    body: number[];
};
export type DisconnectImageApiResponse = unknown;
export type DisconnectImageApiArg = {
    imageId: number;
};
export type DisconnectMultipleImagesApiResponse = unknown;
export type DisconnectMultipleImagesApiArg = {
    /** List of image IDs to delete */
    body: number[];
};
export type GetDisconnectedImagesApiResponse =
    /** status 200 Success */ DisconnectedCarrInvImagesVm[];
export type GetDisconnectedImagesApiArg = void;
export type UploadDisconnectedImageApiResponse = unknown;
export type UploadDisconnectedImageApiArg = {
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type GetDisconnectedImagesQueryableApiResponse =
    /** status 200 Success */ DisconnectedCarrInvImagesVm[];
export type GetDisconnectedImagesQueryableApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetQueuesApiResponse = /** status 200 Success */ string[];
export type GetQueuesApiArg = void;
export type GetQueueImagesApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm[];
export type GetQueueImagesApiArg = {
    /** The queue to load images for */
    queue: string;
};
export type IndexImageApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type IndexImageApiArg = {
    /** The queue the target image is in */
    queue: string;
    /** The target image's CarrInvImages data */
    carrInvImages: CarrInvImages;
};
export type AddImageToQueueApiResponse = unknown;
export type AddImageToQueueApiArg = {
    /** The queue the target image should go into */
    queue: string;
    /** Image data to upload */
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type AddScannedImageApiResponse = /** status 200 Success */ undefined;
export type AddScannedImageApiArg = {
    /** Image data to upload */
    carrInvImageScanVm: CarrInvImageScanVm;
};
export type GetScannedImagesApiResponse =
    /** status 200 Success */ CarrInvImageScanVm[];
export type GetScannedImagesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type DeleteScannedImagesApiResponse =
    /** status 200 Success */ undefined;
export type DeleteScannedImagesApiArg = {
    /** List of scan IDs to delete */
    body: number[];
};
export type GetScannedImageCustomersApiResponse =
    /** status 200 Success */ string[];
export type GetScannedImageCustomersApiArg = void;
export type UpdateScannedImagesApiResponse =
    /** status 200 Success */ undefined;
export type UpdateScannedImagesApiArg = {
    /** List of image data to update */
    body: CarrInvImageScanVm[];
};
export type GetAllowedImageTypesApiResponse = /** status 200 Success */ {
    [key: string]: string;
};
export type GetAllowedImageTypesApiArg = void;
export type DeleteUnindexedImageApiResponse = unknown;
export type DeleteUnindexedImageApiArg = {
    /** The name of the queue to delete from */
    queue: string;
    /** The name of theimage to delete */
    image: string;
};
export type CustomerImageExtractApiResponse =
    /** status 200 Success */ ImageExtractResults;
export type CustomerImageExtractApiArg = {
    /** CustImageExtractVm object for extract parameters */
    custImageExtractVm: CustImageExtractVm;
};
export type ReleaseInvoiceApiResponse = unknown;
export type ReleaseInvoiceApiArg = {
    type: string;
    id: number;
};
export type GetBasicInvInfoApiResponse =
    /** status 200 Success */ BasicInfoVmGetResponse;
export type GetBasicInvInfoApiArg = {
    type: string;
    id: number;
};
export type GetDetailedChargesApiResponse =
    /** status 200 Success */ DetailedChargeListVm;
export type GetDetailedChargesApiArg = {
    type: InvType;
    id: number;
};
export type GetReferencesApiResponse =
    /** status 200 Success */ ReferenceListVm;
export type GetReferencesApiArg = {
    type: string;
    id: number;
};
export type UpdateReferencesApiResponse =
    /** status 200 Success */ ReferenceListVm;
export type UpdateReferencesApiArg = {
    type: string;
    id: number;
    referenceListVm: ReferenceListVm;
};
export type GetImagesApiResponse = /** status 200 Success */ ImageListVm;
export type GetImagesApiArg = {
    type: string;
    id: number;
};
export type UpdateCommentApiResponse = /** status 200 Success */ InvoiceComment;
export type UpdateCommentApiArg = {
    type: string;
    id: number;
    invoiceComment: InvoiceComment;
};
export type GetPurgableInvoiceListApiResponse =
    /** status 200 Success */ PurgableInvoiceVm[];
export type GetPurgableInvoiceListApiArg = void;
export type UnbatchReceivableBatchesApiResponse =
    /** status 200 Success */ undefined;
export type UnbatchReceivableBatchesApiArg = {
    /** The ID of the receivable batch to unbatch */
    batchId: number;
};
export type UnapproveApprovedBatchesApiResponse =
    /** status 200 Success */ undefined;
export type UnapproveApprovedBatchesApiArg = {
    /** The ID of the approved batch to unapprove */
    batchId: number;
    /** Whether or not to unapprove all linked invoices, even in-review ones */
    unapproveAll: boolean;
};
export type PurgeInvoiceApiResponse = /** status 200 Success */ undefined;
export type PurgeInvoiceApiArg = {
    /** InvoicePurgeRequestVm object for the invoice to remove */
    invoicePurgeRequestVm: InvoicePurgeRequestVm;
};
export type PurgeInvoicesFromFileApiResponse =
    /** status 200 Success */ undefined;
export type PurgeInvoicesFromFileApiArg = {
    /** Name of the import file responsible for invoices to purge */
    fileName: string;
};
export type GetInvoiceResearchPopulationDataApiResponse =
    /** status 200 Success */ InvoiceResearchOptionsVm;
export type GetInvoiceResearchPopulationDataApiArg = void;
export type SearchInvoicesApiResponse =
    /** status 200 Success */ CarrInvMinimalVm[];
export type SearchInvoicesApiArg = {
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type ReactDataTableServerSideProcessingApiResponse =
    /** status 200 Success */ InvoiceResearchListVmPagingResponse;
export type ReactDataTableServerSideProcessingApiArg = {
    /** Search Options selected in the Invoice Research UI */
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetMakeRealWorkaroundInvoicesApiResponse =
    /** status 200 Success */ MakeRealVm[];
export type GetMakeRealWorkaroundInvoicesApiArg = void;
export type PostMakeRealWorkaroundInvoicesApiResponse =
    /** status 200 Success */ MakeRealVm[];
export type PostMakeRealWorkaroundInvoicesApiArg = void;
export type GetStatusesForExceptionsApiResponse =
    /** status 200 Success */ string[];
export type GetStatusesForExceptionsApiArg = void;
export type GetExceptionsForGridApiResponse =
    /** status 200 Success */ ExceptionManagerListVm[];
export type GetExceptionsForGridApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type SaveCurrentRemarksApiResponse = /** status 200 Success */ boolean;
export type SaveCurrentRemarksApiArg = {
    /** Invoices to add an audit comment and the comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsEnteredApiResponse = /** status 200 Success */ boolean;
export type AcceptAsEnteredApiArg = {
    /** Invoices to accept and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAuditedApiResponse = /** status 200 Success */ boolean;
export type AcceptAsAuditedApiArg = {
    /** Invoices to accept and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAdjustedApiResponse = /** status 200 Success */ boolean;
export type AcceptAsAdjustedApiArg = {
    /** Invoices to adjust/accept and an audit comment */
    exceptionManagerAcceptAsAdjustedVm: ExceptionManagerAcceptAsAdjustedVm;
};
export type RefuseInvoiceApiResponse = /** status 200 Success */ boolean;
export type RefuseInvoiceApiArg = {
    /** Invoices to refuse and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type ExceptionManagerDeleteApiResponse =
    /** status 200 Success */ boolean;
export type ExceptionManagerDeleteApiArg = {
    /** Invoices to delete and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type DeclineServiceFailApiResponse = /** status 200 Success */ boolean;
export type DeclineServiceFailApiArg = {
    /** Service-failed invoices to decline and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type ApproveServiceFailApiResponse = /** status 200 Success */ boolean;
export type ApproveServiceFailApiArg = {
    /** Service-failed invoices to accept and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type MassRefSearchApiResponse = /** status 200 Success */ MassUpdateVm[];
export type MassRefSearchApiArg = {
    /** Search parameters object */
    updateSearchParams: UpdateSearchParams;
};
export type MassRefUpdateApiResponse = /** status 200 Success */ MassUpdateVm[];
export type MassRefUpdateApiArg = {
    /** List of Mass Reference Update requests */
    body: MassUpdateVm[];
};
export type GetCentralSaltTicketsApiResponse =
    /** status 200 Success */ CentralSaltMatchVm[];
export type GetCentralSaltTicketsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type UpdateCentralSaltTicketApiResponse =
    /** status 200 Success */ undefined;
export type UpdateCentralSaltTicketApiArg = {
    /** CentralSaltMatchVm for the ticket update */
    centralSaltMatchVm: CentralSaltMatchVm;
};
export type GetHarcrosTicketsApiResponse =
    /** status 200 Success */ HarcrosMatchVm[];
export type GetHarcrosTicketsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetAvailableAuditFailStatusesApiResponse =
    /** status 200 Success */ StatusMasterVm[];
export type GetAvailableAuditFailStatusesApiArg = void;
export type GetCarrierChargeCodeSourcesApiResponse =
    /** status 200 Success */ CarrierChargeCodeSourceGenericDropDownStruct[];
export type GetCarrierChargeCodeSourcesApiArg = void;
export type GetCustomerDataEntryCodesForUserApiResponse =
    /** status 200 Success */ CustomerReferenceCodeVm[];
export type GetCustomerDataEntryCodesForUserApiArg = void;
export type GetCustomerDataEntryCodesApiResponse =
    /** status 200 Success */ CustomerReferenceCodeVm[];
export type GetCustomerDataEntryCodesApiArg = {
    billToId: string;
};
export type GetIa360ReportingLinkApiResponse = /** status 200 Success */ string;
export type GetIa360ReportingLinkApiArg = {
    carrierId?: string;
    invoiceNum?: string;
};
export type GetInvoiceStatusCodesApiResponse =
    /** status 200 Success */ StatusCodeVm[];
export type GetInvoiceStatusCodesApiArg = void;
export type GetEntryMethodsApiResponse =
    /** status 200 Success */ EntryMethodVm[];
export type GetEntryMethodsApiArg = void;
export type GetActivityCodesApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetActivityCodesApiArg = void;
export type GetInvoiceTypeListApiResponse = /** status 200 Success */ string[];
export type GetInvoiceTypeListApiArg = void;
export type GetIbobsListApiResponse = /** status 200 Success */ string[];
export type GetIbobsListApiArg = void;
export type GetReportNameListApiResponse =
    /** status 200 Success */ CustFeesReportNamesVm[];
export type GetReportNameListApiArg = void;
export type GetQueueIsActiveApiResponse = /** status 200 Success */ boolean;
export type GetQueueIsActiveApiArg = {
    queue: string;
};
export type GetAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm[];
export type GetAscRefCodesApiArg = void;
export type GetAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm[];
export type GetAscChargeCodesApiArg = {
    sorted?: boolean;
};
export type GetTransportModesApiResponse = /** status 200 Success */ ModeVm[];
export type GetTransportModesApiArg = void;
export type GetPartiesApiResponse = /** status 200 Success */ PartyVm[];
export type GetPartiesApiArg = {
    /** Which customer's parties we're searching through */
    customerId: string;
    /** What kind of party to search for (SH or CN) */
    partyType: string;
    /** Partial or Complete postal code to filter parties by */
    zipSearch: string;
};
export type GetUnMadeAchPaymentsApiResponse =
    /** status 200 Success */ AchPaymentVm[];
export type GetUnMadeAchPaymentsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GenerateAcHesApiResponse = unknown;
export type GenerateAcHesApiArg = {
    /** Date to stamp on the generated ACHes */
    procDate?: string;
    /** List of batch IDs to process ACH payments for */
    body: number[];
};
export type GetAchDatesApiResponse = /** status 200 Success */ string[];
export type GetAchDatesApiArg = void;
export type GetAchFilesForDateApiResponse =
    /** status 200 Success */ CheckS3FileInfo[];
export type GetAchFilesForDateApiArg = {
    /** The date to search for ACH files */
    procDate: string;
};
export type GetCarrierPayableExceptionsByIdApiResponse =
    /** status 200 Success */ PayablesExceptionsVm[];
export type GetCarrierPayableExceptionsByIdApiArg = {
    /** ID of the carrier to load exceptions for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateCarrierPayExceptionApiResponse =
    /** status 200 Success */ PayablesExceptionsVm;
export type CreateCarrierPayExceptionApiArg = {
    /** PayablesExceptionsVm object for the exception to add */
    payablesExceptionsVm: PayablesExceptionsVm;
};
export type ModifyCarrierPayExceptionApiResponse =
    /** status 200 Success */ PayablesExceptionsVm;
export type ModifyCarrierPayExceptionApiArg = {
    /** ID of the carrier contact to update */
    exceptionId: number;
    /** PayablesExceptionsVm object for the exception to update */
    payablesExceptionsVm: PayablesExceptionsVm;
};
export type DeleteCarrierPayExceptionApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierPayExceptionApiArg = {
    /** ID of the carrier payable exception to remove */
    exceptionId: number;
};
export type GetAllPayDayStartsApiResponse =
    /** status 200 Success */ PayDaysStartVm[];
export type GetAllPayDayStartsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetPermittedValsByCustomerApiResponse =
    /** status 200 Success */ PermittedValuesVm[];
export type GetPermittedValsByCustomerApiArg = {
    /** ID of the customer to load permitted value info for */
    customerId: string;
    /** ID of the carrier to load permitted value info for */
    carrierId: string;
    /** ASC Ref Code to load permitted value info for */
    code: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type GetInvoicePermittedValuesApiResponse =
    /** status 200 Success */ PermittedValuesVm[];
export type GetInvoicePermittedValuesApiArg = {
    /** ID of the customer to load permitted value info for */
    customerId: string;
    /** ID of the carrier to load permitted value info for */
    carrierId: string;
};
export type CreatePermittedValueApiResponse =
    /** status 200 Success */ PermittedValuesVm;
export type CreatePermittedValueApiArg = {
    /** PermittedValuesVm object for the permitted value to add */
    permittedValuesVm: PermittedValuesVm;
};
export type ModifyPermittedValueApiResponse =
    /** status 200 Success */ PermittedValuesVm;
export type ModifyPermittedValueApiArg = {
    /** ID of the permitted value to update */
    valId: number;
    /** PermittedValuesVm object for the permitted value to update */
    permittedValuesVm: PermittedValuesVm;
};
export type DeletePermittedValueApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeletePermittedValueApiArg = {
    /** ID of the value to remove */
    valId: number;
};
export type GetPostalCodesApiResponse =
    /** status 200 Success */ PostalCodeVm[];
export type GetPostalCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreatePostalCodeApiResponse = unknown;
export type CreatePostalCodeApiArg = {
    /** PostalCodeVm object for the postal code to add */
    postalCodeVm: PostalCodeVm;
};
export type ModifyPostalCodeApiResponse =
    /** status 200 Success */ PostalCodeVm;
export type ModifyPostalCodeApiArg = {
    /** ID of the postal code to update */
    codeId: number;
    /** PostalCodeVm object for the postal code to update */
    postalCodeVm: PostalCodeVm;
};
export type DeletePostalCodeApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeletePostalCodeApiArg = {
    /** ID of the postal code to remove */
    codeId: number;
};
export type GetAllChecksApiResponse = /** status 200 Success */ PrintCheckVm[];
export type GetAllChecksApiArg = {
    /** Which account to search for checks */
    acctNum: string;
};
export type GetChecksForDateApiResponse =
    /** status 200 Success */ PrintCheckVm[];
export type GetChecksForDateApiArg = {
    /** Which account to search for checks */
    acctNum: string;
    /** The date to search for checks */
    searchDate: string;
};
export type GetReprintChecksForDateApiResponse =
    /** status 200 Success */ PrintCheckVm[];
export type GetReprintChecksForDateApiArg = {
    /** Which account to search for checks */
    acctNum: string;
    /** The pay date to search for checks */
    payDate: string;
};
export type MakeNewBatchesApiResponse = /** status 200 Success */ undefined;
export type MakeNewBatchesApiArg = void;
export type PrintChecksApiResponse = unknown;
export type PrintChecksApiArg = {
    /** PrintCheckRequestVm object for check printing info */
    printCheckRequestVm: PrintCheckRequestVm;
};
export type ReprintChecksApiResponse = unknown;
export type ReprintChecksApiArg = {
    /** ReprintCheckRequestVm object for check printing info */
    reprintCheckRequestVm: ReprintCheckRequestVm;
};
export type GetCheckDatesApiResponse = /** status 200 Success */ string[];
export type GetCheckDatesApiArg = void;
export type GetPrintedChecksForDateApiResponse =
    /** status 200 Success */ CheckS3FileInfo[];
export type GetPrintedChecksForDateApiArg = {
    /** The date to search for checks */
    checkDate: string;
};
export type GetReceiptsApiResponse = /** status 200 Success */ CashReceiptsVm[];
export type GetReceiptsApiArg = {
    /** ID of the customer (or * for "all") to find receipts for */
    customerId: string;
    /** Starting date for the receipt range */
    startDate: string;
    /** End date for the receipt range */
    endDate: string;
};
export type MergeReceiptsApiResponse = /** status 200 Success */ undefined;
export type MergeReceiptsApiArg = {
    /** List of receipt IDs to merge */
    body: number[];
};
export type GetApprovedInvoicesApiResponse =
    /** status 200 Success */ ReceiveFundsInvoiceVm[];
export type GetApprovedInvoicesApiArg = {
    customerId: string;
};
export type GetUnappliedCashApiResponse =
    /** status 200 Success */ CashReceiptsVm[];
export type GetUnappliedCashApiArg = {
    customerId: string;
};
export type ReceiveFundsApiResponse = /** status 200 Success */ undefined;
export type ReceiveFundsApiArg = {
    receiveFundsVm: ReceiveFundsVm;
};
export type UseUnappliedCashApiResponse = /** status 200 Success */ undefined;
export type UseUnappliedCashApiArg = {
    useUnappliedCashVm: UseUnappliedCashVm;
};
export type DepositFundsApiResponse = /** status 200 Success */ undefined;
export type DepositFundsApiArg = {
    depositFundsVm: DepositFundsVm;
};
export type CreateCreditApiResponse = /** status 200 Success */ undefined;
export type CreateCreditApiArg = {
    receiveCreditVm: ReceiveCreditVm;
};
export type GetApiReportingApiResponse = /** status 200 Success */ EmbedParams;
export type GetApiReportingApiArg = void;
export type GetBookmarksForUserApiResponse =
    /** status 200 Success */ ReportBookmarkVm[];
export type GetBookmarksForUserApiArg = void;
export type CreateBookmarkApiResponse =
    /** status 200 Success */ ReportBookmarkVm[];
export type CreateBookmarkApiArg = {
    createReportBookmarkVm: CreateReportBookmarkVm;
};
export type DeleteBookmarkApiResponse =
    /** status 200 Success */ ReportBookmarkVm[];
export type DeleteBookmarkApiArg = {
    id: number;
};
export type GetStatesApiResponse = /** status 200 Success */ StatesVm[];
export type GetStatesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateStatesApiResponse = /** status 200 Success */ StatesVm;
export type CreateStatesApiArg = {
    /** StatesVm object for the state to add */
    statesVm: StatesVm;
};
export type ModifyStatesApiResponse = /** status 200 Success */ StatesVm;
export type ModifyStatesApiArg = {
    /** ID of the state to update */
    stateId: number;
    /** StatesVm object for the state to update */
    statesVm: StatesVm;
};
export type DeleteStatesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteStatesApiArg = {
    /** ID of the state to remove */
    stateId: number;
};
export type GetTimecardForUserIdApiResponse =
    /** status 200 Success */ UserTimeCardVm;
export type GetTimecardForUserIdApiArg = {
    userId?: string;
    date?: string;
};
export type AddTimeCardApiResponse = unknown;
export type AddTimeCardApiArg = {
    userTimeCardVm: UserTimeCardVm;
};
export type DeleteTimeCardApiResponse = unknown;
export type DeleteTimeCardApiArg = {
    id: string;
};
export type GetUserBillToInfoByCustomerApiResponse =
    /** status 200 Success */ UserVm[];
export type GetUserBillToInfoByCustomerApiArg = {
    /** ID of the customer to load linked user info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
    /** Determines if a count of total records is returned along with data. */
    $count?: any;
};
export type CreateUserBillToInfoApiResponse =
    /** status 200 Success */ UserBillToVm;
export type CreateUserBillToInfoApiArg = {
    /** UserBillToVm object for the customer/user link to add */
    userBillToVm: UserBillToVm;
};
export type DeleteUserBillToInfoApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteUserBillToInfoApiArg = {
    /** ID of the customer to remove the user from */
    customerId: string;
    /** ID of the user to unlink from the customer */
    userId: string;
};
export type GetMyConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type GetMyConfigApiArg = void;
export type SaveMyConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type SaveMyConfigApiArg = {
    userConfigurationVm: UserConfigurationVm;
};
export type GetUserConfigurationApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type GetUserConfigurationApiArg = {
    userId: string;
};
export type SaveUserConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type SaveUserConfigApiArg = {
    userId: string;
    userConfigurationVm: UserConfigurationVm;
};
export type GetRoleAuthsApiResponse =
    /** status 200 Success */ FunctionalAuthVm[];
export type GetRoleAuthsApiArg = {
    /** The role to look up data for */
    role: string;
};
export type CreateNewRoleApiResponse = /** status 200 Success */ undefined;
export type CreateNewRoleApiArg = {
    /** UserRoleDefinitionVm for the new role */
    userRoleDefinitionVm: UserRoleDefinitionVm;
};
export type UpdateRoleApiResponse = /** status 200 Success */ undefined;
export type UpdateRoleApiArg = {
    /** FunctionalAuthVm for the updated role definition */
    functionalAuthVm: FunctionalAuthVm;
};
export type CopyRoleApiResponse = /** status 200 Success */ undefined;
export type CopyRoleApiArg = {
    /** Name of the role we're copying from */
    copyRole?: string;
    /** UserRoleDefinitionVm of the new target role */
    userRoleDefinitionVm: UserRoleDefinitionVm;
};
export type GetAllUsersApiResponse = /** status 200 Success */ UserVm[];
export type GetAllUsersApiArg = void;
export type UpdateUserApiResponse = /** status 200 Success */ UserAdminVm;
export type UpdateUserApiArg = {
    /** UserAdminVm for the updated user admin info */
    userAdminVm: UserAdminVm;
};
export type GetFullUserListApiResponse = /** status 200 Success */ UserVm[];
export type GetFullUserListApiArg = void;
export type GetUserAdminInfoApiResponse = /** status 200 Success */ UserAdminVm;
export type GetUserAdminInfoApiArg = {
    /** ID of the user to load */
    userId: string;
};
export type GetKnownCompaniesApiResponse = /** status 200 Success */ string[];
export type GetKnownCompaniesApiArg = void;
export type AddUserApiResponse = /** status 200 Success */ undefined;
export type AddUserApiArg = {
    /** ID of the user to add */
    userId: string;
};
export type ChangePasswordApiResponse = /** status 200 Success */ undefined;
export type ChangePasswordApiArg = {
    /** UserAdminPasswordVm for the necessary password info */
    userAdminPasswordVm: UserAdminPasswordVm;
};
export type SuspendUserApiResponse = /** status 200 Success */ UserAdminVm;
export type SuspendUserApiArg = {
    /** UserAdminSuspendVm for suspension info */
    userAdminSuspendVm: UserAdminSuspendVm;
};
export type GetTimeCardUsersApiResponse = /** status 200 Success */ UserVm[];
export type GetTimeCardUsersApiArg = void;
export type GetUserSessionsForUserApiResponse =
    /** status 200 Success */ UserSessionsVm[];
export type GetUserSessionsForUserApiArg = {
    userId: string;
    lastWorkDay?: string;
};
export type GetMyUserSessionsApiResponse =
    /** status 200 Success */ UserSessionsVm[];
export type GetMyUserSessionsApiArg = {
    lastWorkDay?: string;
};
export type GetCarrInvStatsForUserApiResponse =
    /** status 200 Success */ CarrInvUserStatsVm[];
export type GetCarrInvStatsForUserApiArg = {
    userId: string;
    lastWorkDay?: string;
};
export type GetMyCarrInvStatsApiResponse =
    /** status 200 Success */ CarrInvUserStatsVm[];
export type GetMyCarrInvStatsApiArg = {
    lastWorkDay?: string;
};
export type AppDefaultVm = {
    parmID: string;
    parmGroup: string;
    parmDescrip?: string | null;
    parmValue?: string | null;
    longValue?: string | null;
};
export type SecureDefaultVm = {
    parmID?: string | null;
    parmGroup?: string | null;
    parmDescrip?: string | null;
    parmValue?: string | null;
};
export type BillToMinimalVm = {
    btId: string;
    name?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    sfremail?: string | null;
    isParent?: boolean;
    address1?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Num?: string | null;
    phones?: string | null;
};
export type CurrencyVm = {
    code?: string | null;
    display?: string | null;
};
export type DateTimeDropdown = {
    value?: string | null;
    display?: string | null;
};
export type InvoiceApprovalOptionsVm = {
    billTos?: BillToMinimalVm[] | null;
    currencies?: CurrencyVm[] | null;
    batchDate?: DateTimeDropdown[] | null;
    selectedBillTo?: BillToMinimalVm;
    selectedCurrency?: CurrencyVm;
    selectedBatchDate?: DateTimeDropdown;
    onlyPendingFundsRequests?: boolean | null;
};
export type ApproveInvoicesCarrInvLineVm = {
    airBillApprNetDue?: number;
    airBillAuditNetDue?: number;
    airBillSavings?: number | null;
    airBillComment?: string | null;
    airBillMode?: string | null;
    airBillNetDue?: number;
    airBillNum?: string | null;
    airBillRev?: number;
    airBillSelected?: boolean;
    airBillStatus?: string | null;
    currency?: string | null;
    lineIdx?: number;
    lineSeq?: number;
    service?: string | null;
    modified?: boolean;
};
export type ApproveInvoicesInvoiceVm = {
    invIdx?: number;
    invMode?: string | null;
    invoiceApprNetDue?: number | null;
    invoiceAuditNetDue?: number | null;
    invoiceSavings?: number | null;
    invoiceComment?: string | null;
    currency?: string | null;
    invoiceDate?: string | null;
    invoiceNetDue?: number | null;
    invoiceNum?: string | null;
    selected?: boolean;
    invRev?: number;
    invStatus?: string | null;
    invType?: string | null;
    isaSenderId?: string | null;
    airBills?: ApproveInvoicesCarrInvLineVm[] | null;
    modified?: boolean;
};
export type ApproveInvoicesCarrierVm = {
    carrierApprNetDue?: number | null;
    carrierAuditNetDue?: number | null;
    carrierSavings?: number | null;
    carrierId?: string | null;
    selected?: boolean;
    carrierName?: string | null;
    carrierNetDue?: number | null;
    currency?: string | null;
    comment?: string | null;
    invoiceCount?: number;
    invoices?: ApproveInvoicesInvoiceVm[] | null;
};
export type ApproveInvoicesCustomerVm = {
    btId?: string | null;
    masterBtId?: string | null;
    btName?: string | null;
    rcvBatchId?: number;
    rcvBatchDate?: string;
    customerInvoiceNetDue?: number | null;
    customerSavings?: number | null;
    customerInvoiceAuditNetDue?: number | null;
    customerInvoiceApprNetDue?: number | null;
    comment?: string | null;
    currency?: string | null;
    selected?: boolean;
    carrInvoices?: ApproveInvoicesCarrierVm[] | null;
    invoiceCount?: number;
    processingApprovedBatch?: boolean;
};
export type ApproveInvoicesSearchResponse = {
    invoices?: ApproveInvoicesCustomerVm[] | null;
    showApprove?: boolean;
};
export type CarrierMinimalVm = {
    carrId: string;
    name?: string | null;
    scac?: string | null;
    tracingUrl?: string | null;
    defaultInvType?: string | null;
    address1?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phones?: string | null;
    faxnums?: string | null;
};
export type PartyVm = {
    id?: number;
    btId?: string | null;
    carrierId?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postalCode?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    fpsCustId?: string | null;
    partyGuid?: string;
};
export type CarrInvLineRcVm = {
    advances?: number | null;
    approvedAmt?: number | null;
    auditedAmt?: number | null;
    auditMsg?: string | null;
    billedQty?: number | null;
    billedQtyQual?: string | null;
    bolamt?: number | null;
    bolauditedAmt?: number | null;
    carrierId?: string | null;
    charge?: number | null;
    chgMethPay?: string | null;
    currencyCode?: string | null;
    declaredValue?: number | null;
    declValQual?: string | null;
    entitleCode?: string | null;
    freightRate?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    ladingVal?: number | null;
    ladLiabCode?: string | null;
    lineIdx?: number | null;
    lineSeq?: number;
    originalChargeCode?: string | null;
    originalChargeDescr?: string | null;
    originAmt?: number | null;
    paidAmt?: number | null;
    pct?: number | null;
    prepaidAmt?: number | null;
    rateClassCode?: string | null;
    rateCombPointCode?: string | null;
    rateQual?: string | null;
    rcSeq?: number;
    recType?: string | null;
    specChargeCode?: string | null;
    specChgDescr?: string | null;
    tariffAppCode?: string | null;
    totalsColumn?: string | null;
};
export type CarrInvLineTariffVm = {
    agencyCode?: string | null;
    carrierId?: string | null;
    carrSvcLevCode?: string | null;
    cityName?: string | null;
    commodCode?: string | null;
    custSvcLevCode?: string | null;
    distQual?: string | null;
    dscode?: string | null;
    effectiveDate?: string | null;
    exParte?: string | null;
    exParteDate?: string | null;
    freightClass?: string | null;
    intDomCode?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    rateBasisNum?: string | null;
    recType?: string | null;
    scale?: string | null;
    shipMop?: string | null;
    stateProv?: string | null;
    tariffCol?: string | null;
    tariffDist?: number | null;
    tariffItem?: string | null;
    tariffNum?: string | null;
    tariffPart?: number | null;
    tariffSection?: string | null;
    tariffSeq?: number;
    tariffSuppId?: string | null;
};
export type CarrInvLineQwVm = {
    billAsQty?: number | null;
    billAsQual?: string | null;
    carrierId?: string | null;
    dunnageDescr?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    ladingQuant?: number | null;
    lineIdx?: number | null;
    lineSeq?: number;
    pkgFormCode?: string | null;
    pkgFormCode2?: string | null;
    quantity?: number | null;
    qwSeq?: number;
    recType?: string | null;
    svcTypeCode?: string | null;
    volQual?: string | null;
    volume?: number | null;
    weight?: number | null;
    wgtQual?: string | null;
    wgtUnitCode?: string | null;
    wtKilos?: number | null;
    wtPounds?: number | null;
    wtTons?: number | null;
    yesNoCode?: string | null;
};
export type CarrInvLineMarksVm = {
    carrierId?: string | null;
    commCode?: string | null;
    commCode2?: string | null;
    commCodeQual?: string | null;
    commCodeQual2?: string | null;
    compartIdcode?: string | null;
    descrip?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    marks?: string | null;
    marksQual?: string | null;
    marksSeq?: number;
    pkgCode?: string | null;
    recType?: string | null;
};
export type LineRcTariffQwMarksVm = {
    lineIndex?: number;
    empty?: boolean;
    rcVm?: CarrInvLineRcVm;
    tariffVm?: CarrInvLineTariffVm;
    qwVm?: CarrInvLineQwVm;
    marksVm?: CarrInvLineMarksVm;
};
export type InvoiceSummaryVm = {
    invoiceNum?: string | null;
    airBillNum?: string | null;
    invType?: string | null;
    carrier?: CarrierMinimalVm;
    shippedDate?: string | null;
    deliveredDate?: string | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type ApproveInvoicesRequestVm = {
    searchOptions?: InvoiceApprovalOptionsVm;
    invoices?: ApproveInvoicesCustomerVm[] | null;
};
export type AscChargeCodeVm = {
    code: string;
    description: string;
    inUse: string;
    cmCode?: string | null;
    dbSign: number;
    totalsColumn: string;
    shortDescription: string;
    backRef?: boolean | null;
};
export type ProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
};
export type InvoiceChargeTypeVm = {
    id?: number;
    name?: string | null;
    description?: string | null;
};
export type AscReferenceCodeVm = {
    code?: string | null;
    description?: string | null;
    inUse?: string | null;
};
export type AuditMilesRequestVm = {
    originZip?: string | null;
    originCountryCode?: string | null;
    destinationZip?: string | null;
    destinationCountryCode?: string | null;
};
export type LoginVm = {
    userName?: string | null;
    password?: string | null;
};
export type ScreenSize = 'sm' | 'md' | 'lg' | 'xl';
export type CustomerReferenceCodeVm = {
    sortable?: boolean;
    id?: number;
    customerDescription?: string | null;
    displayOrder?: number;
    inUse?: string | null;
    name?: string | null;
    hide?: ScreenSize;
    code?: string | null;
    description?: string | null;
};
export type ColumnStateVm = {
    aggFunction?: string | null;
    colId?: string | null;
    flex?: number | null;
    hide?: boolean | null;
    pinned?: string | null;
    pivot?: boolean | null;
    pivotIndex?: number | null;
    rowGroup?: boolean | null;
    rowGroupIndex?: number | null;
    sort?: string | null;
    sortIndex?: number | null;
    width?: number | null;
};
export type FilterStateVm = {
    filterId?: string | null;
    filterType?: string | null;
    filterValue?: string | null;
};
export type GridStateVm = {
    gridId?: string | null;
    columnState?: ColumnStateVm[] | null;
    filterState?: FilterStateVm[] | null;
};
export type UserConfigurationVm = {
    invoiceResearchCustomColumns?: CustomerReferenceCodeVm[] | null;
    gridStates?: GridStateVm[] | null;
};
export type UserPermissionVm = {
    functionId?: string | null;
    viewOk?: boolean;
    addOk?: boolean;
    editOk?: boolean;
    deleteOk?: boolean;
    exportOk?: boolean;
    logging?: boolean;
};
export type UserVm = {
    userID?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    displayName?: string | null;
    company?: string | null;
    email?: string | null;
    userConfiguration?: UserConfigurationVm;
    allowedBillToIds?: string[] | null;
    allowedCarrierIds?: string[] | null;
    permissions?: UserPermissionVm[] | null;
};
export type LoginResponseVm = {
    jwt?: string | null;
    user?: UserVm;
};
export type BankAccountVm = {
    id: number;
    bankName?: string | null;
    acctNum?: string | null;
    nickName?: string | null;
    gpCheckbook?: string | null;
    cashAcctGL?: string | null;
    disbAcctGL?: string | null;
    isDeposAcct?: number;
    isDisbursAcct?: number;
    purpose?: string | null;
    currency?: string | null;
    lastCheckNum?: number;
    checkTemplate?: string | null;
    dateFormat?: string | null;
    checkNumFmt?: string | null;
    displayName?: string | null;
};
export type BankAccountChangeVm = {
    id: number;
    lastCheckNum: number;
    changeReason: string;
};
export type BillToVm = {
    active?: string | null;
    actualBtid?: string | null;
    address1?: string | null;
    address2?: string | null;
    auditChargeStatus?: string | null;
    auditClassStatus?: string | null;
    auditMaxCharge?: number;
    auditMaxClass?: string | null;
    auditVarAllow?: number | null;
    auditVarStatus?: string | null;
    autoWithdraw?: string | null;
    btId: string;
    city?: string | null;
    cmCustId?: number | null;
    comDataCustId?: string | null;
    comments?: string | null;
    contactEmail?: string | null;
    contactName?: string | null;
    countryCode?: string | null;
    createdBy?: string | null;
    createdDate?: string | null;
    customerId?: string | null;
    parentName?: string | null;
    defaultPayDays?: number | null;
    defaultPayDaysStart?: number | null;
    defCarrSvc?: string | null;
    emailFeeInvoice?: boolean | null;
    enableIaCustReview?: boolean;
    enableMatchPayAccessorial?: boolean;
    enableMatchPayLiability?: boolean;
    enableMatchPayWeight?: boolean;
    fbogl?: string | null;
    feesRptBtid?: string | null;
    fundsOffsetDays?: number | null;
    glcodingFunction?: string | null;
    importFeeInvoice?: boolean | null;
    isParent?: boolean;
    lastUsed?: string | null;
    makeRecFri?: boolean;
    makeRecMon?: boolean;
    makeRecSat?: boolean;
    makeRecSun?: boolean;
    makeRecThu?: boolean;
    makeRecTue?: boolean;
    makeRecWed?: boolean;
    matchPayProgram?: string | null;
    matchPayWeightFreightClassVariance?: number;
    matchPayWeightTotalVariance?: number;
    matchTable?: string | null;
    milesRequired?: boolean | null;
    name: string;
    phone1Num?: string | null;
    postal?: string | null;
    printFeeInvoice?: boolean | null;
    ratingCode?: string | null;
    sfremail?: string | null;
    stateProv?: string | null;
    synchCibi?: boolean | null;
    tandCdate?: string | null;
    updatedBy?: string | null;
    updatedDate?: string | null;
    useBenchmarking?: boolean | null;
    useCm?: string | null;
    usePayToTerms?: boolean | null;
    useInvoice?: string | null;
    useSfr?: string | null;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason?: string | null;
};
export type CustomerDataEntryVm = {
    id: number;
    btid: string;
    carrierId: string;
    ascrefCode: string;
    dispOrder?: number;
    customerDescription?: string | null;
    allowMulti?: string | null;
    requiredFieldIndicator?: string | null;
    detailLocation?: string | null;
    fieldFormat?: string | null;
    validationTechnique?: string | null;
    tipText?: string | null;
};
export type BillToMatchTableVm = {
    btId: string;
    matchTable?: string | null;
    name: string;
};
export type BillToActiveVm = {
    btId: string;
    active: number;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason: string;
};
export type BillToFeeInvoiceVm = {
    btid: string;
    parentLevelInvoice?: boolean | null;
    primaryBillTo?: string | null;
    internalComment?: string | null;
    reportName?: string | null;
    stopDate?: string | null;
    parentRules?: boolean | null;
};
export type BillToModeDefaultVm = {
    id?: string | null;
    btid: string;
    carrierId?: string | null;
    carrierName?: string | null;
    mode: string;
    netDueDays: number;
    netDueStart: number;
};
export type BtAccountRulesVm = {
    idx?: number;
    btId: string;
    carrierId?: string | null;
    originPostal?: string | null;
    originCountry?: string | null;
    destPostal?: string | null;
    destCountry?: string | null;
    shipName?: string | null;
    cnsname?: string | null;
    effectiveDate?: string;
    accountNumber: string;
    refCol?: string | null;
    refVal?: string | null;
    rank?: number;
    purpose?: string | null;
    service?: string | null;
};
export type BtCodingGridVm = {
    invIdx?: number;
    lineIdx?: number | null;
    batchDate?: string | null;
    carrierName?: string | null;
    invNum?: string | null;
    shipNum?: string | null;
    purpose?: string | null;
    service?: string | null;
    ruleInfo?: string | null;
    glCodeRef?: string | null;
    glCode?: string | null;
};
export type BtCodingRequestVm = {
    invIdx: number;
    lineIdx?: number | null;
};
export type BtCodingQueueVm = {
    customerId: string;
    startDate: string;
    endDate?: string | null;
};
export type CarrBtMapVm = {
    carrierId: string;
    carrAcct: string;
    btId: string;
    btName?: string | null;
    fpsCustId?: string | null;
    isProduction?: boolean | null;
};
export type CheckInfoVm = {
    checkNum?: number;
    acctNum?: string | null;
    checkAmt?: number;
    checkDate?: string;
    billToId?: string | null;
    billToName?: string | null;
    paidToCarrierId?: string | null;
    carrierName?: string | null;
    fbogl?: string | null;
    voidBy?: string | null;
    voidDate?: string;
    selected?: boolean;
};
export type CheckInfoSearchVm = {
    paidFromAccount: string;
    startCheckNumber?: number | null;
    endCheckNumber?: number | null;
    startDate?: string | null;
    endDate?: string | null;
};
export type CarrierCheckRemitViewModel = {
    carrier?: string | null;
    checkAmt?: number;
    checkCurrency?: string | null;
    checkDate?: string;
    checkNum?: number;
    isaCtrlNum820?: number;
    paidToCarrierId?: string | null;
    rcvID820?: string | null;
    rcvIDQual820?: string | null;
    remitDeliverHow?: string | null;
    remitDirectory?: string | null;
    remitS3Key?: string | null;
    remitEffective?: string;
    remitEmail?: string | null;
    remitFormat?: string | null;
    shipperAccount?: string | null;
    customerName?: string | null;
    fileNameMask?: string | null;
};
export type ProcessCheckProcessedArgs = {
    carrierName?: string | null;
    remitDirectory?: string | null;
    remitFormat?: string | null;
    checkAmount?: number;
    checkNumber?: number;
};
export type CheckS3FileInfo = {
    fileName?: string | null;
    lastModified?: string;
    fileSize?: number;
};
export type CarrEdiMasterVm = {
    ediSenderQual: string;
    ediSenderId: string;
    ediXactType: string;
    ediRcvQual: string;
    ediRcvId: string;
    carrierId: string;
    fpsCarrId?: string | null;
    useC2?: string | null;
    send820?: string | null;
    procFps?: string | null;
};
export type CarrFamVm = {
    carrierFam: string;
    description?: string | null;
};
export type CarrierChargeCodeSource = 'L108' | 'L112' | 'Ia';
export type CarrierChargeCodeMappingVm = {
    carrierId: string;
    description?: string | null;
    id?: number;
    carrier?: CarrierMinimalVm;
    carrierName?: string | null;
    originalChargeCode: string;
    source: CarrierChargeCodeSource;
    mappedChargeCode: string;
    mappedCode?: AscChargeCodeVm;
    codeDescription?: string | null;
    totalsColumn?: string | null;
    dbSign?: number | null;
    cmCode?: string | null;
};
export type CarrierChargeCodesCustomerModeOverrideVm = {
    billToId: string;
    mode?: string | null;
    reason?: string | null;
    carrierId: string;
    description?: string | null;
    id?: number;
    carrier?: CarrierMinimalVm;
    carrierName?: string | null;
    originalChargeCode: string;
    source: CarrierChargeCodeSource;
    mappedChargeCode: string;
    mappedCode?: AscChargeCodeVm;
    codeDescription?: string | null;
    totalsColumn?: string | null;
    dbSign?: number | null;
    cmCode?: string | null;
};
export type CarrierVm = {
    carrId: string;
    active?: string | null;
    name: string;
    scac?: string | null;
    address1?: string | null;
    address2?: string | null;
    address3?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    countryCode?: string | null;
    phones?: string | null;
    emails?: string | null;
    faxnums?: string | null;
    defaultMode?: string | null;
    fpscarrId?: string | null;
    defaultInvType?: string | null;
    useFor?: string | null;
    lastUsed?: string | null;
    createdDate?: string | null;
    createdBy?: string | null;
    updatedDate?: string | null;
    updatedBy?: string | null;
    family?: string | null;
    payableGl?: string | null;
    inftpsite?: string | null;
    inftpcontacts?: string | null;
    inftpUserId?: string | null;
    inFtppassword?: string | null;
    outFtpsite?: string | null;
    outFtpcontacts?: string | null;
    outFtpuserId?: string | null;
    outFtppassword?: string | null;
    tracingUrl?: string | null;
    allowDupAb?: boolean;
    checkService?: boolean;
    defSvcFn?: string | null;
    disputeEmail?: string | null;
    imagingId?: string | null;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason?: string | null;
};
export type CarrierActiveVm = {
    carrId: string;
    active: number;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason: string;
};
export type BillToCarrierModeOverrideVm = {
    btid?: string | null;
    customerName?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    mode?: string | null;
};
export type CarrierContactVm = {
    id: number;
    carrierId: string;
    type?: string | null;
    ctitle?: string | null;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Type?: string | null;
    phone1Num?: string | null;
    phone2Type?: string | null;
    phone2Num?: string | null;
    email1?: string | null;
    email2?: string | null;
    createdBy?: string | null;
    createdDate?: string | null;
    updatedBy?: string | null;
    updatedDate?: string | null;
    lastUsed?: string | null;
};
export type CarrierModeMapVm = {
    id: number;
    carrierId: string;
    carrierMode: string;
    plMode: string;
};
export type CarrierPaymentRemitVm = {
    id: number;
    carrierId: string;
    payCurrency: string;
    payHow: string;
    isDefaultPayMethod?: boolean | null;
    payFromAcct: string;
    nickName?: string | null;
    payTermDays?: number | null;
    achrouting?: string | null;
    achaccount?: string | null;
    remitName?: string | null;
    remitAddr1?: string | null;
    remitAddr2?: string | null;
    remitCity?: string | null;
    remitStateProv?: string | null;
    remitPostal?: string | null;
    remitEmail?: string | null;
    remitEffective?: string;
    remitExpire?: string | null;
    remitDeliverHow: string;
    remitFormat?: string | null;
    remitDirectory?: string | null;
    isactrlNum820?: number | null;
    rcvIdqual820?: string | null;
    rcvId820?: string | null;
    seccode?: string | null;
    fileNameMask?: string | null;
    edi820SenderIdQual?: string | null;
    edi820SenderId?: string | null;
    remitConfigName?: string | null;
    remitS3Key?: string | null;
};
export type ApprovedBatchMinimalVm = {
    batchId?: number;
    approvedDate?: string;
};
export type CarrInvRemarkVm = {
    invIdx?: number | null;
    remarkSeq?: number;
    longComment?: string | null;
};
export type CarrInvRefVm = {
    id?: number;
    carrierId?: string | null;
    grpNum?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    recType?: string | null;
    refDate?: string | null;
    refDescrip?: string | null;
    refId?: string | null;
    refIdQual?: string | null;
    refSeq?: number;
    refTimecode?: string | null;
    ruleUsed?: number;
    fpsCustId?: string | null;
    ascCodeDescription?: string | null;
};
export type CarrInvCwtVm = {
    actualClass?: number;
    carrierId?: string | null;
    cube?: number;
    id?: string;
    invIdx?: number;
    invoiceNum?: string | null;
    invRev?: number;
    lineItemSeq?: number;
    pcs?: number;
    rate?: number;
    ratedAmt?: number | null;
    ratedClass?: number;
    recType?: string | null;
    weight?: number;
};
export type CarrInvDatesVm = {
    recType?: string | null;
    carrierId?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    invIdx?: number | null;
    dateSeq?: number;
    dateQual?: string | null;
    stopDate?: string | null;
    timeCode?: string | null;
    stopTime?: string | null;
    timeQual?: string | null;
};
export type CarrInvLineMeasVm = {
    carrierId?: string | null;
    height?: number | null;
    industry?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    length?: number | null;
    lineIdx?: number | null;
    lineSeq?: number;
    measSeq?: number;
    measUom?: string | null;
    quantity?: number | null;
    recType?: string | null;
    width?: number | null;
};
export type CarrInvLinePartyVm = {
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    btid?: string | null;
    carrierId?: string | null;
    city?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    entityIdcode?: string | null;
    entRelCode?: string | null;
    entRelIdcode?: string | null;
    idcode?: string | null;
    idcodeQual?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    locId?: string | null;
    locQual?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    postalCode?: string | null;
    recType?: string | null;
    stateProv?: string | null;
    sysLocId?: string | null;
    fpsCustId?: string | null;
};
export type CarrInvLineRefVm = {
    carrierId?: string | null;
    grpNum?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    recType?: string | null;
    refDate?: string | null;
    refDescrip?: string | null;
    refId?: string | null;
    refIdQual?: string | null;
    refSeq?: number;
    refTimecode?: string | null;
    ruleUsed?: number;
    ascCodeDescription?: string | null;
    fpsCustId?: string | null;
};
export type ChargeTotalsVm = {
    totalType?: string | null;
    freight?: number;
    deficit?: number;
    fuel?: number;
    accessorial?: number;
    discount?: number;
    net?: number;
    date?: string;
};
export type CarrInvLineVm = {
    airbillNum?: string | null;
    airbillRev?: number;
    apprAccessorial?: number | null;
    apprAccess?: number | null;
    apprBatchId?: number;
    apprDeficit?: number | null;
    apprDiscount?: number | null;
    apprFuel?: number | null;
    apprGross?: number | null;
    apprNetDue?: number | null;
    apprNet?: number | null;
    auditAccess?: number | null;
    auditContract?: number | null;
    auditDate?: string;
    auditDeficit?: number | null;
    auditDiscount?: number | null;
    auditFlag?: boolean;
    auditFuel?: number | null;
    auditGross?: number | null;
    auditMiles?: number;
    auditNet?: number | null;
    auditRateIs?: string | null;
    auditResult?: string | null;
    auditVariance?: number;
    autoAuditResult?: string | null;
    bmAccessorial?: number;
    bmDeficit?: number;
    bmDiscount?: number;
    bmFuel?: number;
    bmGross?: number;
    bmNetDue?: number;
    bundleNum?: string | null;
    carrierId?: string | null;
    carrInvLineMarks?: CarrInvLineMarksVm[] | null;
    carrInvLineMeas?: CarrInvLineMeasVm[] | null;
    carrInvLineParty?: CarrInvLinePartyVm[] | null;
    carrInvLineQw?: CarrInvLineQwVm[] | null;
    carrInvLineRc?: CarrInvLineRcVm[] | null;
    carrInvLineRef?: CarrInvLineRefVm[] | null;
    carrInvLineTariff?: CarrInvLineTariffVm[] | null;
    cashReceiptId?: number | null;
    checkNumber?: number | null;
    createDate?: string | null;
    currAccessorial?: number;
    currAmtDue?: number;
    currDeficit?: number;
    currDiscount?: number;
    currFuel?: number;
    currGross?: number;
    custComment?: string | null;
    custSvcDescr?: string | null;
    decomment?: string | null;
    dupeFlag?: boolean;
    entryTime?: number;
    equipment?: string | null;
    estDelivDate?: string | null;
    estDelivDays?: number;
    evcity?: string | null;
    evcode?: string | null;
    evcountry?: string | null;
    evdate?: string;
    evdelayHrs?: number;
    event?: string | null;
    evfuelGal?: number;
    evmessage?: string | null;
    evnumCars?: number;
    evnumEmpty?: number;
    evnumLoaded?: number;
    evsecSplc?: string | null;
    evsplc?: string | null;
    evstateProv?: string | null;
    evstatReasCode?: string | null;
    evtime?: string | null;
    evtimeZone?: string | null;
    evtotGross?: number;
    evtotLen?: number;
    evtrainDelayReasCode?: string | null;
    fundedAmt?: number;
    ibob?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lane?: string | null;
    lastUpdateDate?: string | null;
    lastUpdateUser?: string | null;
    lineSeq?: number;
    mode?: string | null;
    netDue?: number | null;
    paidAccessorial?: number | null;
    paidAccess?: number | null;
    paidDeficit?: number | null;
    paidDiscount?: number | null;
    paidFuel?: number | null;
    paidGross?: number | null;
    paidNetDue?: number | null;
    paidNet?: number | null;
    payBatchId?: number;
    payStatus?: string | null;
    poddate?: string;
    podname?: string | null;
    podtime?: string | null;
    podzone?: string | null;
    pudate?: string;
    pudateQual?: string | null;
    pudelCode?: string | null;
    puequipInit?: string | null;
    puequipNum?: string | null;
    punumShip?: number;
    purpose?: string | null;
    putime?: string | null;
    rcvBatchId?: number;
    recType?: string | null;
    reviewStatus?: string | null;
    serviceLevel?: string | null;
    shipDate?: string;
    svcFail?: boolean;
    termsDescrip?: string | null;
    totalAccessorial?: number | null;
    totalAccum1?: number;
    totalAccum2?: number;
    totalAccum3?: number;
    totalAccum4?: number;
    totalAccum5?: number;
    totalAccum6?: number;
    totalAccum7?: number;
    totalAccum8?: number;
    totalAccum9?: number;
    totalDeficit?: number | null;
    totalDiscount?: number | null;
    totalFuel?: number | null;
    totalGross?: number | null;
    totWgt?: number | null;
    totWgtKilos?: number | null;
    totwgtPounds?: number | null;
    totWgtQual?: string | null;
    totWgtTons?: number | null;
    verifyNetDue?: number | null;
    btId?: string | null;
    customerId?: string | null;
    fpsCustId?: string | null;
    carrier?: CarrierMinimalVm;
    shipper?: PartyVm;
    consignee?: PartyVm;
    parties?: CarrInvLinePartyVm[] | null;
    references?: CarrInvLineRefVm[] | null;
    chargeTotals?: ChargeTotalsVm[] | null;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type CarrInvPartyVm = {
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    btId?: string | null;
    carrierId?: string | null;
    city?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    entIdCode?: string | null;
    entRelCode?: string | null;
    entRelIdCode?: string | null;
    idCode?: string | null;
    idCodeQual?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    locId?: string | null;
    locQual?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    postalCode?: string | null;
    recType?: string | null;
    stateProv?: string | null;
    sysLocId?: string | null;
    fpsCustId?: string | null;
};
export type CarrierInvoiceImagesVm = {
    id?: number;
    carrInvIdx?: number;
    invoiceNum?: string | null;
    carrInvLineIdx?: number | null;
    carrierId?: string | null;
    imageType?: string | null;
    originalFileName?: string | null;
    imageName?: string | null;
    source?: string | null;
    s3Path?: string | null;
    subKey?: string | null;
    fileDate?: string;
    dateLinked?: string;
    image?: string | null;
    contentType?: string | null;
};
export type CarrInvVm = {
    apprAccess?: number | null;
    apprBatchId?: number | null;
    apprDeficit?: number | null;
    apprDiscount?: number | null;
    apprFuel?: number | null;
    apprGross?: number | null;
    apprNetDue?: number | null;
    auditAccess?: number | null;
    auditContract?: number | null;
    auditDate?: string;
    auditDeficit?: number | null;
    auditDiscount?: number | null;
    auditFlag?: boolean;
    auditFuel?: number | null;
    auditGross?: number | null;
    auditMiles?: number | null;
    auditNet?: number | null;
    auditRateIs?: string | null;
    auditResult?: string | null;
    auditVariance?: number;
    autoAuditResult?: string | null;
    bankAccountNum?: string | null;
    bankClientCode?: string | null;
    billingContract?: number;
    billingCurrency?: string | null;
    billingDate?: string | null;
    biNum?: number | null;
    bmAccessorial?: number | null;
    bmDeficit?: number | null;
    bmDiscount?: number | null;
    bmFuel?: number | null;
    bmGross?: number | null;
    bmNetDue?: number | null;
    calcDueDate?: string | null;
    calcReqDate?: string | null;
    carrierId?: string | null;
    cashReceiptId?: number | null;
    checkNumber?: number | null;
    ciNum?: number | null;
    clientBankNum?: string | null;
    contactFcode?: string | null;
    contactInqRef?: string | null;
    contactName?: string | null;
    contactNum1?: string | null;
    contactNum2?: string | null;
    contactNum3?: string | null;
    contactNum4?: string | null;
    correction?: string | null;
    createDate?: string | null;
    createUser?: string | null;
    currAccessorial?: number | null;
    currAmtDue?: number | null;
    currDeficit?: number | null;
    currDiscount?: number | null;
    currFuel?: number | null;
    currGross?: number | null;
    custChange?: boolean | null;
    custComment?: string | null;
    custSvcDescr?: string | null;
    dateQual?: string | null;
    delDate?: string | null;
    deleteDate?: string | null;
    deleteUser?: string | null;
    dupeFlag?: boolean;
    ediCustId?: string | null;
    effectivePayDate?: string | null;
    entryTime?: number;
    equipment?: string | null;
    estDelivDate?: string | null;
    estDelivDays?: number | null;
    exchRate?: number | null;
    firstBtId?: string | null;
    fpsCarrId?: string | null;
    fpsCustId?: string | null;
    fpsFileName?: string | null;
    fundedAmt?: number | null;
    fundedDate?: string | null;
    gsCtlNum?: number | null;
    gsRecvId?: string | null;
    gsSendId?: string | null;
    gsTrans?: string | null;
    ibob?: string | null;
    idCode?: string | null;
    idCodeQual?: string | null;
    idx?: number;
    ieaGrpIncl?: number | null;
    inFileName?: string | null;
    invDate2?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    invType?: string | null;
    isaAckReq?: string | null;
    isaAuthInfo?: string | null;
    isaAuthQual?: string | null;
    isaControlNum?: number | null;
    isaDate?: string | null;
    isaRecvId?: string | null;
    isaRecvQual?: string | null;
    isaRepSep?: string | null;
    isaSecInfo?: string | null;
    isaSecInfoQual?: string | null;
    isaSenderId?: string | null;
    isaSenderIdQual?: string | null;
    isaTestInd?: string | null;
    isaTime?: string | null;
    isaVersionId?: string | null;
    lane?: string | null;
    lastUpdateDate?: string | null;
    lastUpdateUser?: string | null;
    mode?: string | null;
    netDue?: number | null;
    numQual1?: string | null;
    numQual2?: string | null;
    numQual3?: string | null;
    numQual4?: string | null;
    numShipments?: number | null;
    paidAccessorial?: number | null;
    paidDeficit?: number | null;
    paidDiscount?: number | null;
    paidFuel?: number | null;
    paidGross?: number | null;
    paidNetDue?: number | null;
    payBatchId?: number | null;
    payCurrency?: string | null;
    payMeth?: string | null;
    payStatus?: string | null;
    projReqDate?: string | null;
    purpose?: string | null;
    ratedCurrency?: string | null;
    rcvBatchDate?: string | null;
    rcvBatchId?: number | null;
    recType?: string | null;
    reviewStatus?: string | null;
    scac?: string | null;
    serviceLevel?: string | null;
    seSegIncl?: number | null;
    shipDate?: string | null;
    shipIdNum?: string | null;
    shipmentCount?: number | null;
    shipMethPay?: string | null;
    shipperAccount?: string | null;
    shipQual?: string | null;
    source?: string | null;
    stControlNum?: number | null;
    stTransType?: string | null;
    svcFail?: boolean;
    tariffSvcCode?: string | null;
    termsBasisDateCode?: string | null;
    termsDayOfMon?: number | null;
    termsDefAmtDue?: number | null;
    termsDefDueDate?: string | null;
    termsDescrip?: string | null;
    termsDiscAmt?: number | null;
    termsDiscDaysDue?: number | null;
    termsDiscDueDate?: string | null;
    termsDiscountPct?: number | null;
    termsNetDays?: number | null;
    termsNetDueDate?: string | null;
    termsPayMethCode?: string | null;
    termsPct?: number | null;
    termsPctpayable?: number | null;
    termsTypeCode?: string | null;
    test?: string | null;
    totAdv?: number | null;
    totalAccessorial?: number | null;
    totalAccum1?: number | null;
    totalAccum2?: number | null;
    totalAccum3?: number | null;
    totalAccum4?: number | null;
    totalAccum5?: number | null;
    totalAccum6?: number | null;
    totalAccum7?: number | null;
    totalAccum8?: number | null;
    totalAccum9?: number | null;
    totalDeficit?: number | null;
    totalDiscount?: number | null;
    totalFuel?: number | null;
    totalGross?: number | null;
    totChg?: number | null;
    totDeclVal?: number | null;
    totDeclValQual?: string | null;
    totFrtRate?: number | null;
    totFrtRateQual?: string | null;
    totLadQty?: number | null;
    totPrepaid?: number | null;
    totSpecChgCode?: string | null;
    totTariffNum?: string | null;
    totVol?: number | null;
    totVolUom?: string | null;
    totWgt?: number | null;
    totWgtKilos?: number | null;
    totWgtPounds?: number | null;
    totWgtQual?: string | null;
    totWgtTons?: number | null;
    totWgtUom?: string | null;
    transpTermsCode?: string | null;
    transTypeCode?: string | null;
    underCarr?: string | null;
    vdabCarrId?: string | null;
    verifyNetDue?: number | null;
    wgtUnitCode?: string | null;
    approvedBatch?: ApprovedBatchMinimalVm;
    carrier?: CarrierMinimalVm;
    billTo?: BillToMinimalVm;
    carrInvRemark?: CarrInvRemarkVm[] | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    needsEdiInvoice?: boolean;
    carrInvRef?: CarrInvRefVm[] | null;
    references?: CarrInvRefVm[] | null;
    carrInvCwt?: CarrInvCwtVm[] | null;
    carrInvDates?: CarrInvDatesVm[] | null;
    carrInvLine?: CarrInvLineVm[] | null;
    carrInvParty?: CarrInvPartyVm[] | null;
    carrInvImages?: CarrierInvoiceImagesVm[] | null;
    parties?: CarrInvPartyVm[] | null;
    chargeTotals?: ChargeTotalsVm[] | null;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type CarrInvLineBundleVm = {
    airbillNum?: string | null;
    pkgCode?: string | null;
    descrip?: string | null;
    serviceLevel?: string | null;
    serviceDescription?: string | null;
    weight?: number | null;
    totalFuel?: number | null;
    currAmtDue?: number;
    shipDate?: string;
    poddate?: string;
    podtime?: string | null;
};
export type CarrInvLineMinimalVm = {
    airbillNum?: string | null;
    apprNetDue?: number;
    auditNet?: number;
    custComment?: string | null;
    invIdx?: number;
    invRev?: number;
    lineIdx?: number;
    lineSeq?: number;
    mode?: string | null;
    netDue?: number;
    selected?: boolean;
    serviceLevel?: string | null;
    status?: string | null;
    carrInvLineRc?: CarrInvLineRcVm[] | null;
    carrInvLineQw?: CarrInvLineQwVm[] | null;
    carrInvLineTariff?: CarrInvLineTariffVm[] | null;
    carrInvLineMarks?: CarrInvLineMarksVm[] | null;
};
export type CarrInvMinimalVm = {
    apprNetDue?: number;
    auditNetDue?: number;
    billingCurrency?: string | null;
    billTo?: BillToMinimalVm;
    carrierId?: string | null;
    carrier?: CarrierMinimalVm;
    comment?: string | null;
    fpsCustId?: string | null;
    idx?: number;
    billingDate?: string;
    createDate?: string;
    createUser?: string | null;
    shipDate?: string;
    invoiceNum?: string | null;
    source?: string | null;
    purpose?: string | null;
    invRev?: number;
    invType?: string | null;
    isaSenderID?: string | null;
    mode?: string | null;
    netDue?: number;
    selected?: boolean;
    status?: string | null;
    recType?: string | null;
    ibob?: string | null;
    reviewStatus?: string | null;
    carrInvLine?: CarrInvLineMinimalVm[] | null;
};
export type InitiateMultiPartInvoiceCreationResponse = {
    invoiceId?: number;
    creationId?: string | null;
};
export type InitiateMultiPartInvoiceCreationRequest = {
    invoice?: CarrInvVm;
};
export type InvoicePartResponse = {
    tag?: string | null;
    partNumber?: number;
};
export type InvoicePartRequest = {
    invoiceId?: number;
    creationId?: string | null;
    partNumber?: number;
    lineItems?: CarrInvLineVm[] | null;
};
export type CompleteMultiPartInvoiceCreationResponse = {
    invoiceId?: number;
    errorMessage?: string | null;
    serverTrackedCompletedParts?: InvoicePartResponse[] | null;
};
export type CompleteMultiPartInvoiceCreationRequest = {
    invoiceId?: number;
    creationId?: string | null;
    completedParts?: InvoicePartResponse[] | null;
};
export type AbortMultiPartInvoiceCreationRequest = {
    invoiceId?: number;
    creationId?: string | null;
};
export type QueuedInvoiceCreationResponse = {
    queueId?: string | null;
};
export type InvoiceCreationStatusResponse = {
    queueId?: string | null;
    status?: string | null;
};
export type InvoiceCreationStatusRequest = {
    invoiceId?: number;
    queueId?: string | null;
    multiPart?: boolean;
    creationId?: string | null;
};
export type CarrInvCustChangeVm = {
    carrierId: string;
    newCustomerId: string;
    invoiceNum: string;
};
export type CarrInvNumberChangeVm = {
    carrierId: string;
    newInvoiceNum: string;
    invoiceNum: string;
};
export type CarrInvEdiVm = {
    ediText?: string | null;
};
export type WhatIfChargeCodeMapVm = {
    originalChargeDescr?: string | null;
    originalChargeCode?: string | null;
    specChargeCode?: string | null;
    specChgDescr?: string | null;
    totalsColumn?: string | null;
    rcSeq?: number;
    lineIdx?: number | null;
    invIdx?: number | null;
};
export type GetBatchableInvoicesCustomerVm = {
    customer?: string | null;
    invoices?: number;
    netDue?: number;
    payCurrency?: string | null;
    shipments?: number;
};
export type CarrServicesVm = {
    carrierId: string;
    serviceCode: string;
    serviceDescription?: string | null;
    svcAuditFunction?: string | null;
    isDefault?: boolean | null;
    checkForDuplicate?: boolean;
    displayForInvoiceEntry?: boolean;
};
export type CentralSaltMatchVm = {
    idx?: string;
    itemCode?: string | null;
    transferLoad?: string | null;
    contractNumber?: string | null;
    statedQty?: number;
    um?: string | null;
    vendorCode?: string | null;
    pickupNumber?: string | null;
    ticketNumber?: string | null;
    depotCode?: string | null;
    company?: string | null;
    depotCity?: string | null;
    depotState?: string | null;
    depotZip?: string | null;
    freightType?: string | null;
    freightRate?: number;
    freightTypeTotal?: number;
    fscitem?: string | null;
    fsctotal?: number;
    invoiceAmountShouldBe?: number;
    ticketDate?: string;
    customerName?: string | null;
    shipToName?: string | null;
    shipToZip?: string | null;
    shipToCity?: string | null;
    shipToState?: string | null;
    miles?: number;
    matched?: boolean;
    importDate?: string;
};
export type CentralSaltTicketVm = {
    ticketNum?: string | null;
    depotCode?: string | null;
    qty?: number;
    uom?: string | null;
    freightAmt?: number;
    fuelAmt?: number;
};
export type CentralSaltVm = {
    customerId?: string | null;
    carrierId?: string | null;
    invoiceDate?: string;
    invoiceNum?: string | null;
    invoiceAmt?: number;
    fuelAmt?: number;
    freightTotal?: number;
    fuelTotal?: number;
    tickets?: CentralSaltTicketVm[] | null;
};
export type CheckRegisterVm = {
    transactDate?: string;
    transactInfo?: string | null;
    fboInfo?: string | null;
    carrierInfo?: string | null;
    payAmt?: number;
    voidBy?: string | null;
    checkNum?: number;
};
export type CheckRegisterRequestVm = {
    fboid?: string | null;
    acctId?: string | null;
    startingCheckNumber?: number | null;
    endingCheckNumber?: number | null;
    startDate: string;
    endDate: string;
};
export type CmContractVm = {
    carrierId: string;
    carrierName?: string | null;
    billToId: string;
    billToName?: string | null;
    service: string;
    rateAudit: boolean;
    svcAudit: boolean;
    cmBillContractId: number;
    cmCostContractId: number;
    bcClassReq: boolean;
    bcWeightReq: boolean;
    ccClassReq: boolean;
    ccWeightReq: boolean;
    netDueDays: number;
    netDiscountDays: number;
    netDiscountPct: number;
};
export type CodeMasterVm = {
    element: string;
    code: string;
    description: string;
    preferredOrder?: string | null;
};
export type CodeMasterElements = {
    elementList?: string[] | null;
    defaultElement?: string | null;
};
export type StatusMasterVm = {
    status?: string | null;
    sequence?: number | null;
    statGroup?: string | null;
    showInWeb?: boolean | null;
    showInDashboard?: boolean;
    id?: number;
    isAuditFailStatus?: boolean;
};
export type StatusCodeVm = {
    code: string;
    description?: string | null;
};
export type ContactsVm = {
    id: number;
    btid: string;
    type?: string | null;
    ctitle?: string | null;
    code?: string | null;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Type?: string | null;
    phone1Num?: string | null;
    phone2Type?: string | null;
    phone2Num?: string | null;
    email1?: string | null;
    email2?: string | null;
    comments?: string | null;
    createdBy?: string | null;
    createdDate?: string;
    updatedBy?: string | null;
    updatedDate?: string;
    lastUsed?: string;
    useOnFeeInvoice?: boolean | null;
};
export type CurrenciesVm = {
    countryCode: string;
    id: string;
    countryName?: string | null;
    description?: string | null;
    symbol?: string | null;
    inUse?: boolean;
};
export type CustomerDataEntryGridVm = {
    id?: number;
    btid?: string | null;
    carrierId?: string | null;
    ascrefCode?: string | null;
    dispOrder?: number;
    customerDescription?: string | null;
    allowMulti?: string | null;
    requiredFieldIndicator?: string | null;
    detailLocation?: string | null;
    fieldFormat?: string | null;
    validationTechnique?: string | null;
    tipText?: string | null;
    selected?: string | null;
    longDescription?: string | null;
    inUse?: string | null;
};
export type CustomerDataEntryCodeListVm = {
    ascrefCode: string;
    customerDescription?: string | null;
};
export type CreateReceivableBatchesForCustomersVm = {
    batchDate?: string;
    projectedRequestDatesToInclude?: string | null;
    customers?: string[] | null;
};
export type ChildBatchResultVm = {
    parentId?: string | null;
    billTo?: string | null;
    invoices?: number;
    shipments?: number | null;
    netDue?: number | null;
    currency?: string | null;
};
export type AgedReceivablesVm = {
    batchID?: number;
    name?: string | null;
    sfrEmail?: string | null;
    description?: string | null;
    totalAmt?: number;
    approvedAmt?: number;
    fundedAmt?: number;
    openAmt?: number;
    status?: string | null;
    invoiceCount?: number;
    createDate?: string;
    batchDate?: string;
};
export type CustPaySetupVm = {
    active?: boolean;
    btId: string;
    carrId: string;
    createDate?: string;
    createUser?: string | null;
    id: number;
    lastUpdateDate?: string;
    lastUpdateUser?: string | null;
    mode?: string | null;
};
export type ShipmentCountByStatusVm = {
    status?: string | null;
    invoiceCount?: number;
    invoiceAmount?: number;
    currency?: string | null;
};
export type AgedInvoiceSummaryVm = {
    requestDate?: string | null;
    invoices?: number;
    shipments?: number | null;
    amountDue?: number | null;
    currency?: string | null;
};
export type DeAdminVm = {
    btid: string;
    btName?: string | null;
    carrierId: string;
    carrierName?: string | null;
    invDetCurrSelShow?: number | null;
    invDetCurrSelReq?: number | null;
    invDetCurrExchShow?: number | null;
    invDetCurrExchReq?: number | null;
    invDetDelDateShow?: number | null;
    invDetDelDateReq?: number | null;
    invDetTermsShow?: number | null;
    invDetTermsReq?: number | null;
    invDetIbobshow?: number | null;
    invDetIbobreq?: number | null;
    grpTotalsShow?: number | null;
    totalsGrossShow?: number | null;
    totalsGrossReq?: number | null;
    totalsDeficitShow?: number | null;
    totalsDeficitReq?: number | null;
    totalsFuelShow?: number | null;
    totalsFuelReq?: number | null;
    totalsAccessShow?: number | null;
    totalsAccessReq?: number | null;
    totalsDiscShow?: number | null;
    totalsDiscReq?: number | null;
    grpShipperShow?: number | null;
    shipperAutoFill?: number | null;
    shipperPostalShow?: number | null;
    shipperPostalReq?: number | null;
    shipperNameShow?: number | null;
    shipperNameReq?: number | null;
    shipperAddr1Show?: number | null;
    shipperAddr1Req?: number | null;
    shipperAddr2Show?: number | null;
    shipperAddr2Req?: number | null;
    shipperAddr3Show?: number | null;
    shipperAddr3Req?: number | null;
    shipperAddr4Show?: number | null;
    shipperAddr4Req?: number | null;
    shipperCityShow?: number | null;
    shipperCityReq?: number | null;
    shipperStateShow?: number | null;
    shipperStateReq?: number | null;
    grpCnsShow?: number | null;
    cnsAutoFill?: number | null;
    cnsPostalShow?: number | null;
    cnsPostalReq?: number | null;
    cnsNameShow?: number | null;
    cnsNameReq?: number | null;
    cnsAddr1Show?: number | null;
    cnsAddr1Req?: number | null;
    cnsAddr2Show?: number | null;
    cnsAddr2Req?: number | null;
    cnsAddr3Show?: number | null;
    cnsAddr3Req?: number | null;
    cnsAddr4Show?: number | null;
    cnsAddr4Req?: number | null;
    cnsCityShow?: number | null;
    cnsCityReq?: number | null;
    cnsStateShow?: number | null;
    cnsStateReq?: number | null;
    grpLidshow?: number | null;
    lidpiecesShow?: number | null;
    lidpiecesReq?: number | null;
    lidpackShow?: number | null;
    lidpackReq?: number | null;
    lidunitsShow?: number | null;
    lidunitsReq?: number | null;
    lidqtyShow?: number | null;
    lidqtyReq?: number | null;
    lidweightShow?: number | null;
    lidweightReq?: number | null;
    lidclassShow?: number | null;
    lidclassReq?: number | null;
    lidhazShow?: number | null;
    lidhazReq?: number | null;
    lidchgCodeShow?: number | null;
    lidchgCodeReq?: number | null;
    lidchgAmtShow?: number | null;
    lidchgAmtReq?: number | null;
    liddescrShow?: number | null;
    liddescrReq?: number | null;
    lidcommodityShow?: number | null;
    lidcommodityReq?: number | null;
    grpRefDataShow?: number | null;
    custAcctShow?: number | null;
    custAcctReq?: number | null;
    invEquipShow?: number | null;
    invEquipReq?: number | null;
    invModeShow?: number | null;
    invModeReq?: number | null;
    invServiceShow?: number | null;
    invServiceReq?: number | null;
    shipModeReq?: number | null;
    shipModeShow?: number | null;
    shipEquipReq?: number | null;
    shipEquipShow?: number | null;
    shipServiceShow?: number | null;
    shipServiceReq?: number | null;
    shipTermsShow?: number | null;
    shipTermsReq?: number | null;
    shipIbobshow?: number | null;
    shipIbobreq?: number | null;
    shipDelDateShow?: number | null;
    shipDelDateReq?: number | null;
};
export type DateExportStatus = 'Pending' | 'Processing' | 'Done';
export type DataExportsVm = {
    id?: number;
    statusId?: DateExportStatus;
    statusIdDisplay?: string | null;
    userJobName?: string | null;
    s3Bucket?: string | null;
    s3Key?: string | null;
    jobCreatedDate?: string;
    jobCompletedDate?: string | null;
};
export type ExportFileFormat = 'csv' | 'xlsx';
export type ModeVm = {
    code: string;
    value?: string | null;
    description?: string | null;
    label?: string | null;
};
export type EntryMethodVm = {
    code: string;
    description?: string | null;
    selected?: boolean;
};
export type DateTimeRangeVm = {
    start?: string | null;
    end?: string | null;
};
export type InvoiceResearchOptionsVm = {
    carriers?: CarrierMinimalVm[] | null;
    billTos?: BillToMinimalVm[] | null;
    mode?: ModeVm[] | null;
    statusCodes?: StatusCodeVm[] | null;
    referenceCodes?: AscReferenceCodeVm[] | null;
    entryMethods?: EntryMethodVm[] | null;
    invoiceTypes?: EntryMethodVm[] | null;
    entered?: DateTimeRangeVm;
    processed?: DateTimeRangeVm;
    checkDate?: DateTimeRangeVm;
    shipped?: DateTimeRangeVm;
    invoices?: string | null;
    airBillNums?: string | null;
    checks?: string | null;
    findReference?: string | null;
    referenceSearchType?: string | null;
    referenceSearchTypes?: string[] | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    sortBy?: string | null;
    page?: number | null;
    recordCountRequested?: number | null;
    requestedRecordCount?: number;
    declaredCount?: number | null;
    sortAscending?: boolean;
};
export type EmailVm = {
    to?: string | null;
    cc?: string | null;
    subject?: string | null;
    body?: string | null;
};
export type EquipmentVm = {
    code?: string | null;
    description?: string | null;
    cmcode?: string | null;
    inUse?: boolean | null;
};
export type CustFeesHdrVm = {
    feeInvoiceId?: string;
    btid?: string | null;
    invDate?: string | null;
    totalDue?: number | null;
    status?: string | null;
    createDate?: string | null;
    totalTransactionCharge?: number | null;
    totalPeriodicCharge?: number | null;
    totalBenchmarkShareCharge?: number | null;
    totalGainSharingCharge?: number | null;
    invoiceNo?: string | null;
    fromDate?: string | null;
    throughDate?: string | null;
};
export type CustFeesRangeHdrVm = {
    custName?: string | null;
    importInvoice?: boolean | null;
    emailInvoice?: boolean | null;
    printInvoice?: boolean | null;
    feeInvoiceId?: string;
    btid?: string | null;
    invDate?: string | null;
    totalDue?: number | null;
    status?: string | null;
    createDate?: string | null;
    totalTransactionCharge?: number | null;
    totalPeriodicCharge?: number | null;
    totalBenchmarkShareCharge?: number | null;
    totalGainSharingCharge?: number | null;
    invoiceNo?: string | null;
    fromDate?: string | null;
    throughDate?: string | null;
};
export type CustFeesRangeRequestVm = {
    startDate: string;
    endDate: string;
    mostRecent?: boolean | null;
    onlyNewOrRerun?: boolean | null;
    includeHarcros?: boolean | null;
    onlyHarcros?: boolean | null;
};
export type CustFeesDetailVm = {
    feeInvoiceId?: string;
    custInvoiceRuleId?: string;
    ruleDescription?: string | null;
    internalDescription?: string | null;
    custName?: string | null;
    qty?: number | null;
    unitCharge?: number | null;
    extendedCharge?: number | null;
};
export type CustFeesDetailReportVm = {
    url?: string | null;
};
export type CustFeesChangeInvNumVm = {
    feeInvoiceId: string;
    invoiceNum: string;
};
export type CustFeesImportRequestLine = {
    custId?: string | null;
    feeInvoiceId?: string;
};
export type CustFeesImportRequestVm = {
    startDate: string;
    endDate: string;
    imports: CustFeesImportRequestLine[];
};
export type CustFeesInvoiceTestCustomerVm = {
    customerId?: string | null;
    lineData?: CustFeesHdrVm;
    lineDetails?: CustFeesDetailVm[] | null;
    lineDescrips?: {
        [key: string]: string | null;
    } | null;
};
export type CustFeesInvoiceTestResultsVm = {
    errors?: string | null;
    results?: CustFeesInvoiceTestCustomerVm[] | null;
};
export type CustFeesMakeInvoiceRequestVm = {
    isSingle: boolean;
    customerId?: string | null;
    isRerun: boolean;
    fromDate?: string | null;
    throughDate: string;
    periodicChargeDate: string;
    invoiceDate: string;
};
export type CustFeesRuleVm = {
    id?: number;
    ruleType?: string | null;
    charge?: number | null;
    billPer?: string | null;
    description?: string | null;
    internalDescrip?: string | null;
    source?: string | null;
    invType?: string | null;
    intDom?: string | null;
    minCharge?: number | null;
    maxCharge?: number | null;
    startDate?: string | null;
    stopDate?: string | null;
    applyToChildren?: boolean | null;
    carrIdList?: string[] | null;
    excludeCarriers?: boolean | null;
    modeList?: string[] | null;
    excludeModes?: boolean | null;
    lastAppliedDate?: string | null;
};
export type CustInvoiceRuleVm = {
    custInvoiceRuleId?: string;
    applyToChildren?: boolean | null;
    ruleType?: string | null;
    charge?: number | null;
    per?: string | null;
    description?: string | null;
    internalDescription?: string | null;
    source?: string | null;
    mode?: string | null;
    type?: string | null;
    intDom?: string | null;
    min?: number | null;
    max?: number | null;
    startDate?: string | null;
    stopDate?: string | null;
    excludeMode?: boolean | null;
    lastAppliedDate?: string | null;
    carrIdList?: string[] | null;
    excludeCarriers?: boolean | null;
};
export type CustFeesRuleComparisonVm = {
    newRules?: CustFeesRuleVm[] | null;
    oldRules?: CustInvoiceRuleVm[] | null;
};
export type CustFeesRuleTypeDetailsVm = {
    id?: number | null;
    btId: string;
    ruleTypeId: number;
    minCharge?: number | null;
    maxCharge?: number | null;
};
export type CustFeesRulesAndDetailsVm = {
    rules?: CustFeesRuleVm[] | null;
    details?: CustFeesRuleTypeDetailsVm[] | null;
};
export type CustFeesRuleInfoVm = {
    id?: number;
    btId: string;
    ruleTypeId: number;
    charge?: number | null;
    billPerId: number;
    description?: string | null;
    internalDescrip?: string | null;
    source?: string | null;
    invType?: string | null;
    intDomId?: number | null;
    minCharge?: number | null;
    maxCharge?: number | null;
    startDate?: string | null;
    stopDate?: string | null;
    applyToChildren?: boolean | null;
    carrIdList?: string[] | null;
    excludeCarriers?: boolean | null;
    modeList?: string[] | null;
    excludeModes?: boolean | null;
};
export type CustFeesCategoryVm = {
    id?: number;
    name?: string | null;
};
export type TargetLevel = 'All' | 'CarrierInvoice' | 'CarrierInvoiceLine';
export type GlBulkCodingRequest = {
    btid?: string | null;
    endDate?: string | null;
    level?: TargetLevel;
    overwriteExistingGlCodes?: boolean;
    startDate?: string | null;
    socketId?: string | null;
};
export type GlCodingRequest = {
    addGlRefRecords?: boolean;
    invoiceId?: number;
    level?: TargetLevel;
};
export type HopkinsDepartmentData = {
    accountNum?: string | null;
    outboundCountry?: string | null;
};
export type HopkinsDepartmentVm = {
    billToId?: string | null;
    departments?: string | null;
    comments?: string | null;
    additionalData?: HopkinsDepartmentData;
};
export type ImageType =
    | 'None'
    | 'AddPage'
    | 'BL_1'
    | 'BL_2'
    | 'BL_3'
    | 'BL_4'
    | 'BL_5'
    | 'BL_6'
    | 'BL_7'
    | 'BOL'
    | 'CINV'
    | 'DR_1'
    | 'DR_2'
    | 'DR_3'
    | 'EDIInvoice'
    | 'Images'
    | 'INV'
    | 'Invoice'
    | 'LOA'
    | 'Misc'
    | 'OTHER'
    | 'POD';
export type DisconnectedCarrInvImagesVm = {
    id?: number;
    carrierId?: string | null;
    carrierName?: string | null;
    invoiceNum?: string | null;
    revNum?: number;
    invIdx?: number;
    shipmentNum?: string | null;
    imageType?: ImageType;
    possibly?: string | null;
    subFolder?: string | null;
    imagePath?: string | null;
    imageFileName?: string | null;
    creationTime?: string;
    dateLinked?: string;
};
export type CarrInvImages = {
    id?: number;
    recType?: string | null;
    carrierId?: string | null;
    invoicenum?: string | null;
    revNum?: number;
    shipmentNum?: string | null;
    imageType?: string | null;
    imagePath?: string | null;
    imageName?: string | null;
    invIdx?: number;
    dateLinked?: string;
    fileDate?: string | null;
    invoiceTotal?: number;
    subFolder?: string | null;
    awsSubKey?: string | null;
    originalFileName?: string | null;
    source?: string | null;
    s3Path?: string | null;
};
export type CarrInvImageScanVm = {
    scanId?: number;
    custId: string;
    custName?: string | null;
    carrierName?: string | null;
    userId?: string | null;
    id?: number;
    carrInvIdx?: number;
    invoiceNum?: string | null;
    carrInvLineIdx?: number | null;
    carrierId?: string | null;
    imageType?: string | null;
    originalFileName?: string | null;
    imageName?: string | null;
    source?: string | null;
    s3Path?: string | null;
    subKey?: string | null;
    fileDate?: string;
    dateLinked?: string;
    image?: string | null;
    contentType?: string | null;
};
export type ImageExtractResults = {
    allSuccessful?: boolean;
    errors?: string[] | null;
};
export type CustImageExtractVm = {
    custId: string;
    dateType: string;
    startDate: string;
    endDate: string;
    groupType: string;
    emails?: string | null;
};
export type DataPairVm = {
    name?: string | null;
    display?: string | null;
    value?: string | null;
};
export type ChargeLineVm = {
    displayOrder?: number;
    type?: string | null;
    freight?: number;
    deficit?: number;
    fuel?: number;
    accessorial?: number;
    discount?: number;
    net?: number;
};
export type BasicInfoVm = {
    invoiceInfo?: DataPairVm[] | null;
    chargeLines?: ChargeLineVm[] | null;
    invoiceNum?: string | null;
    airBillNum?: string | null;
    custComment?: string | null;
    auditComment?: string | null;
    carrier?: CarrierMinimalVm;
    shipper?: PartyVm;
    consignee?: PartyVm;
};
export type BasicInfoVmGetResponse = {
    invoice?: BasicInfoVm;
    requireEditPreAudit?: boolean;
    isWebLocked?: boolean;
    showReleaseBtn?: boolean;
};
export type DetailedChargeVm = {
    invIdx?: number;
    lineIdx?: number;
    rcSeq?: number;
    displayOrder?: number;
    pieces?: number | null;
    units?: string | null;
    weight?: number | null;
    class?: string | null;
    itemDescription?: string | null;
    chargeDescription?: string | null;
    chargeAmount?: number | null;
    currency?: string | null;
    auditAmount?: number | null;
};
export type DetailedChargeListVm = {
    detailedCharges?: DetailedChargeVm[] | null;
    totalWeight?: number;
    totalCharge?: number;
    currency?: string | null;
};
export type InvType = 'Single' | 'Statement';
export type UnifiedInvRefVm = {
    id?: number;
    invIdx?: number | null;
    lineIdx?: number | null;
    recType?: string | null;
    carrierId?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineSeq?: number;
    refSeq?: number;
    refIdQual?: string | null;
    refId?: string | null;
    refDescrip?: string | null;
    refDate?: string | null;
    refTimecode?: string | null;
    ruleUsed?: number;
    grpNum?: number | null;
    ascCodeDescription?: string | null;
    fpsCustId?: string | null;
    modified?: boolean;
};
export type ReferenceListVm = {
    references?: UnifiedInvRefVm[] | null;
    accountCodingData?: UnifiedInvRefVm[][] | null;
    deletedAccountCodingData?: UnifiedInvRefVm[][] | null;
    accountCodingHeaders?: UnifiedInvRefVm[] | null;
    showAccountCoding?: boolean;
    showReleaseInvoiceButton?: boolean;
    revReason?: string | null;
};
export type ImageListVm = {
    images?: CarrierInvoiceImagesVm[] | null;
    needsEdiInvoice?: boolean;
};
export type InvoiceComment = {
    comment?: string | null;
};
export type PurgableInvoiceVm = {
    fileName?: string | null;
    invoiceCount?: number;
    createDate?: string;
};
export type InvoicePurgeRequestVm = {
    recType?: string | null;
    carrierId?: string | null;
    invoiceNumber?: string | null;
    invRev?: number;
};
export type InvoiceResearchListVm = {
    invIdx?: number | null;
    lineIdx?: number;
    billToName?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    carrierNameLink?: string | null;
    invoiceNum?: string | null;
    invoiceNumLink?: string | null;
    invoiceReviewStatus?: string | null;
    invRecType?: string | null;
    shipmentNum?: string | null;
    shipmentNumLink?: string | null;
    shipmentReviewStatus?: string | null;
    lineRecType?: string | null;
    enteredDate?: string | null;
    createDate?: string | null;
    shipDateFormatted?: string | null;
    shipDate?: string | null;
    source?: string | null;
    purpose?: string | null;
    mode?: string | null;
    ibob?: string | null;
    invType?: string | null;
    invDate?: string | null;
    billingDate?: string | null;
    currAmtDue?: number | null;
    auditFlag?: boolean | null;
    shipperName?: string | null;
    shipperCity?: string | null;
    shipperState?: string | null;
    shipperPostal?: string | null;
    consigneeName?: string | null;
    consigneeCity?: string | null;
    consigneeState?: string | null;
    consigneePostal?: string | null;
    totWgtPounds?: number | null;
    rcvBatchId?: number | null;
    procDate?: string | null;
    rcvBatchDate?: string | null;
    paidNetDue?: number | null;
    checkNumber?: number | null;
    checkAmt?: number | null;
    checkDateFormatted?: string | null;
    checkDate?: string | null;
    payMethod?: string | null;
    custComment?: string | null;
    isaSenderId?: string | null;
    userSpecificReferences?: string[] | null;
};
export type InvoiceResearchListVmPagingResponse = {
    data?: InvoiceResearchListVm[] | null;
    total?: number | null;
    isError?: boolean;
    error?: string | null;
};
export type MakeRealVm = {
    customer?: string | null;
    invDate?: string;
    status?: string | null;
};
export type ExceptionManagerListVm = {
    invIdx?: number;
    lineIdx?: number;
    lineSeq?: number;
    invType?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    invoiceNum?: string | null;
    airbillNum?: string | null;
    reviewStatus?: string | null;
    airbillStatus?: string | null;
    shipDate?: string | null;
    netDue?: number | null;
    auditNet?: number | null;
    auditResult?: string | null;
    shipperPartyId?: number | null;
    shipperName?: string | null;
    shipperPostal?: string | null;
    consigneePartyId?: number | null;
    consigneeName?: string | null;
    consigneePostal?: string | null;
    billingDate?: string | null;
    createDate?: string | null;
    totLadQty?: number | null;
    totWgt?: number | null;
    createUser?: string | null;
    invRev?: number;
    comment?: string | null;
    custComment?: string | null;
};
export type ExceptionManagerActionVm = {
    invoicesToActOn: ExceptionManagerListVm[];
    comments: string;
};
export type ExceptionManagerListAcceptAsAdjustedVm = {
    adjustedCharges?: LineRcTariffQwMarksVm[] | null;
    invoiceLevelAdjustment?: number | null;
    invIdx?: number;
    lineIdx?: number;
    lineSeq?: number;
    invType?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    invoiceNum?: string | null;
    airbillNum?: string | null;
    reviewStatus?: string | null;
    airbillStatus?: string | null;
    shipDate?: string | null;
    netDue?: number | null;
    auditNet?: number | null;
    auditResult?: string | null;
    shipperPartyId?: number | null;
    shipperName?: string | null;
    shipperPostal?: string | null;
    consigneePartyId?: number | null;
    consigneeName?: string | null;
    consigneePostal?: string | null;
    billingDate?: string | null;
    createDate?: string | null;
    totLadQty?: number | null;
    totWgt?: number | null;
    createUser?: string | null;
    invRev?: number;
    comment?: string | null;
    custComment?: string | null;
};
export type ExceptionManagerAcceptAsAdjustedVm = {
    invoicesToActOn: ExceptionManagerListAcceptAsAdjustedVm[];
    comments: string;
};
export type MassUpdateVm = {
    customerId: string;
    customer?: string | null;
    carrierId?: string | null;
    carrier?: string | null;
    invoice?: string | null;
    invRev?: number;
    lineSeq?: number | null;
    shipment?: string | null;
    purpose?: string | null;
    field: string;
    oldValue?: string | null;
    newValue?: string | null;
    result?: string | null;
    batchDate?: string | null;
};
export type UpdateSearchParams = {
    customerId: string;
    carrierId?: string | null;
    inclPreaudit?: boolean | null;
    dateFrom?: string | null;
    dateTo?: string | null;
    field: string;
    oldValue?: string | null;
    newValue?: string | null;
};
export type HarcrosMatchVm = {
    id?: string;
    refId?: string | null;
    orderLoc?: string | null;
    shipBy?: string | null;
    dateSent?: string;
    ticketDate?: string;
    ordType?: string | null;
    poso?: string | null;
    accountCode?: string | null;
    matched?: boolean | null;
    importDate?: string;
    amount?: number | null;
};
export type CarrierChargeCodeSourceGenericDropDownStruct = {
    value?: CarrierChargeCodeSource;
    display?: string | null;
};
export type CustFeesReportNamesVm = {
    reportName?: string | null;
    reportNameDescription?: string | null;
};
export type AchPaymentVm = {
    selected?: boolean;
    billToId?: string | null;
    billToName?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    batchId?: number;
    payDate?: string;
    checkNumber?: number;
    totalDue?: number;
    secCode?: string | null;
    paymentMethod?: string | null;
};
export type PayablesExceptionsVm = {
    id: number;
    customerID: string;
    customerName?: string | null;
    carrierID: string;
    payMethodID: number;
};
export type PayDaysStartVm = {
    indicator: number;
    description: string;
};
export type PermittedValuesVm = {
    id: number;
    carrierId: string;
    btid: string;
    fieldName: string;
    permittedValue: string;
};
export type PostalCodeVm = {
    id: number;
    zip51: string;
    city: string;
    state: string;
    country: string;
};
export type PayMethodEntry = {
    methodId?: number;
    methodName?: string | null;
};
export type PrintCheckVm = {
    custId?: string | null;
    custName?: string | null;
    carrierID?: string | null;
    carrierName?: string | null;
    batchID?: number;
    invoiceCount?: number | null;
    payDate?: string | null;
    totalDue?: number | null;
    payMethods?: PayMethodEntry[] | null;
    defaultPayMethodId?: number;
    fbogl?: string | null;
    checkNumber?: number | null;
};
export type PrintCheckRequestEntryVm = {
    batchId?: number;
    payMethodName?: string | null;
};
export type PrintCheckRequestVm = {
    batchInfo: PrintCheckRequestEntryVm[];
    checkDate: string;
    acctNum: string;
};
export type ReprintCheckRequestVm = {
    reprintChecks: boolean;
    reprintSummary: boolean;
    reprintStubs: boolean;
    batchInfo: PrintCheckRequestEntryVm[];
    checkDate: string;
    acctNum: string;
};
export type CashReceiptsVm = {
    batchID?: number;
    cashReceiptsID?: number;
    depositDate?: string;
    fundsAvailDate?: string;
    fundsRecd?: number;
    bankAccountNum?: string | null;
    bankAccountName?: string | null;
    deposMeth?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    amtNotYetApplied?: number;
    overfundAmt?: number;
    comments?: string | null;
};
export type ReceiveFundsInvoiceVm = {
    invIdx?: number;
    lineIdx?: number;
    invRecType?: string | null;
    carrierId?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineSeq?: number;
    btId?: string | null;
    customerName?: string | null;
    carrierName?: string | null;
    invType?: string | null;
    billingDate?: string | null;
    apprBatchId?: number | null;
    airbillNum?: string | null;
    currAmtDue?: number;
    rcvBatchId?: number | null;
    reviewStatus?: string | null;
    rcvBatchDate?: string | null;
};
export type ReceiveFundsRequestVm = {
    invIdx?: number;
    lineIdx?: number;
};
export type ReceiveFundsVm = {
    invoices: ReceiveFundsRequestVm[];
    customerId: string;
    bankAcctId: string;
    depositDate: string;
    availDate: string;
    amount: number;
    depositMethod: string;
    memo?: string | null;
};
export type UseUnappliedCashVm = {
    invoices: ReceiveFundsRequestVm[];
    customerId: string;
    cashReceiptIds: number[];
};
export type DepositFundsVm = {
    customerId: string;
    bankAcctId: string;
    depositDate: string;
    availDate: string;
    amount: number;
    depositMethod: string;
    memo?: string | null;
};
export type ReceiveCreditVm = {
    carrierId?: string | null;
    customerId: string;
    bankAcctId: string;
    amount: number;
    memo?: string | null;
};
export type EmbedReport = {
    reportId?: string;
    reportName?: string | null;
    embedUrl?: string | null;
};
export type EmbedToken = {
    token?: string | null;
    tokenId?: string;
    expiration?: string;
};
export type EmbedParams = {
    type?: string | null;
    embedReport?: EmbedReport[] | null;
    embedToken?: EmbedToken;
};
export type ReportBookmarkVm = {
    id?: number;
    userId?: string | null;
    reportId?: string | null;
    displayName?: string | null;
    bookmarkBase64?: string | null;
    isPublic?: boolean;
};
export type CreateReportBookmarkVm = {
    bookmark?: ReportBookmarkVm;
    isPublic?: boolean;
    billTos?: BillToMinimalVm[] | null;
};
export type StatesVm = {
    id: number;
    country: string;
    abbrev: string;
    stateName: string;
};
export type UserTcactivityVm = {
    id?: string;
    tcid?: string;
    activity?: string | null;
    startTime?: string | null;
    stopTime?: string | null;
    notes?: string | null;
    userTimeCard?: UserTimeCardVm;
};
export type UserTimeCardVm = {
    id?: string;
    userId?: string | null;
    cardDate?: string;
    totalHrs?: number;
    locked?: boolean;
    activities?: UserTcactivityVm[] | null;
};
export type UserBillToVm = {
    id?: number;
    userId: string;
    btid: string;
};
export type FunctionalAuthLineVm = {
    functionId: string;
    description?: string | null;
    viewOk: boolean;
    editOk: boolean;
};
export type FunctionalAuthVm = {
    userRole: string;
    auths: FunctionalAuthLineVm[];
};
export type UserRoleDefinitionVm = {
    roleName: string;
    description: string;
};
export type UserAdminListEntryVm = {
    linkId?: string | null;
    linkName?: string | null;
    isLinked?: boolean;
};
export type UserAdminVm = {
    userId: string;
    lastName?: string | null;
    firstName?: string | null;
    displayName?: string | null;
    company?: string | null;
    createdBy?: string | null;
    createdOn?: string | null;
    editBy?: string | null;
    editOn?: string | null;
    suspendBy?: string | null;
    suspendOn?: string | null;
    allowAllBt: boolean;
    allowAllCarr: boolean;
    defaultMaxRec: number;
    maxMaxRec: number;
    allowAllAppr: boolean;
    linkedCustomers?: UserAdminListEntryVm[] | null;
    linkedApprovals?: UserAdminListEntryVm[] | null;
    linkedCarriers?: UserAdminListEntryVm[] | null;
    linkedRoles?: UserAdminListEntryVm[] | null;
};
export type UserAdminPasswordVm = {
    userId: string;
    password: string;
};
export type UserAdminSuspendVm = {
    userId: string;
    suspend: boolean;
};
export type UserSessionsVm = {
    session?: string;
    userId?: string | null;
    sessionStart?: string;
    sessionEnd?: string;
    sessionTime?: number | null;
    sessionEndStatus?: string | null;
    hostName?: string | null;
};
export type CarrInvUserStatsVm = {
    entrySeconds?: number;
    invoiceCount?: number;
    lastSave?: string;
    shipmentCount?: number;
};
export const {
    useRequeueJobQuery,
    useLazyRequeueJobQuery,
    useGetAppDefaultsQuery,
    useLazyGetAppDefaultsQuery,
    useGetAppDefaultsQueryQuery,
    useLazyGetAppDefaultsQueryQuery,
    usePutAppDefaultsMutation,
    usePutSecureDefaultsMutation,
    useGetSecureDefaultsQueryQuery,
    useLazyGetSecureDefaultsQueryQuery,
    useGetWebDefaultsQuery,
    useLazyGetWebDefaultsQuery,
    useGetInvoicesApprovalPopulationDataQuery,
    useLazyGetInvoicesApprovalPopulationDataQuery,
    useGetInvoicesNeedingApprovalMutation,
    useGetMinimalInvoiceDetailQuery,
    useLazyGetMinimalInvoiceDetailQuery,
    useApproveInvoicesMutation,
    useSaveCurrentInvoiceStateMutation,
    usePostApiApproveinvoicesFrominvoiceidxsMutation,
    useGetAllAscChargeCodesQuery,
    useLazyGetAllAscChargeCodesQuery,
    useCreateAscChargeCodesMutation,
    useModifyAscChargeCodesMutation,
    useDeleteAscChargeCodesMutation,
    useGetInvoiceChargeTypesQuery,
    useLazyGetInvoiceChargeTypesQuery,
    useGetAllAscRefCodesQuery,
    useLazyGetAllAscRefCodesQuery,
    useCreateAscRefCodesMutation,
    useModifyAscRefCodesMutation,
    useDeleteAscRefCodesMutation,
    useGetGenMilesMutation,
    useLoginMutation,
    useRefreshTokenQuery,
    useLazyRefreshTokenQuery,
    useLoginWithPermissionsMutation,
    useRefreshWithPermissionsQuery,
    useLazyRefreshWithPermissionsQuery,
    useLogOutQuery,
    useLazyLogOutQuery,
    useGetMyUserQuery,
    useLazyGetMyUserQuery,
    useGetAllBankAccountsQuery,
    useLazyGetAllBankAccountsQuery,
    useUpdateBankAccountMutation,
    useGetBillToByIdQuery,
    useLazyGetBillToByIdQuery,
    useGetDataEntryAscRefCodesQuery,
    useLazyGetDataEntryAscRefCodesQuery,
    useGetAllBillToQuery,
    useLazyGetAllBillToQuery,
    useGetBillToForDisplayQuery,
    useLazyGetBillToForDisplayQuery,
    useGetUserCustomersQuery,
    useLazyGetUserCustomersQuery,
    useGetCentralSaltBillTosQuery,
    useLazyGetCentralSaltBillTosQuery,
    useGetAllBillTosForDisplayQuery,
    useLazyGetAllBillTosForDisplayQuery,
    useGetActiveBillTosForDisplayQuery,
    useLazyGetActiveBillTosForDisplayQuery,
    useGetCustomerByIdQuery,
    useLazyGetCustomerByIdQuery,
    useModifyCustomersMutation,
    useDeleteCustomersMutation,
    useGetAllCustomersQuery,
    useLazyGetAllCustomersQuery,
    useCreateCustomersMutation,
    useGetParentCustomersQuery,
    useLazyGetParentCustomersQuery,
    useActivateCustomersMutation,
    useGetFeeInvoiceDataQuery,
    useLazyGetFeeInvoiceDataQuery,
    useSetFeeInvoiceDataMutation,
    useGetModeDefaultsByCustomerQuery,
    useLazyGetModeDefaultsByCustomerQuery,
    useCreateBillToModeDefaultMutation,
    useModifyBillToModeDefaultMutation,
    useDeleteBillToModeDefaultMutation,
    useGetGlRulesQuery,
    useLazyGetGlRulesQuery,
    useGetGlCodingPreviewQuery,
    useLazyGetGlCodingPreviewQuery,
    useGetGlOverwritePreviewQuery,
    useLazyGetGlOverwritePreviewQuery,
    useSaveGlRulesMutation,
    useGlCodingBatchMutation,
    useGlCodingQueueMutation,
    useGetBillToMapsByCarrierQuery,
    useLazyGetBillToMapsByCarrierQuery,
    useCreateCarrierBtMapMutation,
    useDeleteCarrierBtMapMutation,
    useGetVoidableChecksMutation,
    useVoidChecksMutation,
    useGetAllRemitsQuery,
    useLazyGetAllRemitsQuery,
    useMakeRemitsMutation,
    useGetRemitsForChecksQuery,
    useLazyGetRemitsForChecksQuery,
    useGetRemitKeysQuery,
    useLazyGetRemitKeysQuery,
    useGetRemitsForKeyQuery,
    useLazyGetRemitsForKeyQuery,
    useGetCarrierEdiMasterByIdQuery,
    useLazyGetCarrierEdiMasterByIdQuery,
    useCreateCarrierEdiMasterMutation,
    useModifyCarrierEdiMasterMutation,
    useDeleteCarrierEdiMasterMutation,
    useGetAllCarrierFamiliesQuery,
    useLazyGetAllCarrierFamiliesQuery,
    useGetCarriersForDropdownQuery,
    useLazyGetCarriersForDropdownQuery,
    useGetActiveCarriersForDropdownQuery,
    useLazyGetActiveCarriersForDropdownQuery,
    useGetPermissionedCarriersForDropdownQuery,
    useLazyGetPermissionedCarriersForDropdownQuery,
    useGetByScacQuery,
    useLazyGetByScacQuery,
    useGetCarrierChargeCodeMappingQuery,
    useLazyGetCarrierChargeCodeMappingQuery,
    useGetCarrierChargeCodeMappingByIdQuery,
    useLazyGetCarrierChargeCodeMappingByIdQuery,
    useAddNewCarrierChargeCodeMappingMutation,
    useUpdateCarrierChargeCodeMappingMutation,
    useDeletCarrierChargeCodeMappingMutation,
    useGetCarrierChargeCodeMappingOverridesQuery,
    useLazyGetCarrierChargeCodeMappingOverridesQuery,
    useGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
    useLazyGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
    useAddNewCarrierChargeCodeMappingOverrideMutation,
    useUpdateCarrierChargeCodeMappingOverrideMutation,
    useDeleteCarrierChargeCodeMappingOverrideMutation,
    useGetCarrierByIdQuery,
    useLazyGetCarrierByIdQuery,
    useGetAllCarriersQuery,
    useLazyGetAllCarriersQuery,
    useCreateCarriersMutation,
    useModifyCarriersMutation,
    useDeleteCarriersMutation,
    useActivateCarriersMutation,
    useGetModeOverridesQuery,
    useLazyGetModeOverridesQuery,
    useGetSpecificModeOverrideQuery,
    useLazyGetSpecificModeOverrideQuery,
    useDeleteModeOverrideMutation,
    useUpdateModeOverrideMutation,
    useAddModeOverrideMutation,
    useAddModeTypeMutation,
    useGetAllCarrierContactsQuery,
    useLazyGetAllCarrierContactsQuery,
    useCreateCarrierContactsMutation,
    useGetCarrierContactByIdQuery,
    useLazyGetCarrierContactByIdQuery,
    useModifyCarrierContactsMutation,
    useDeleteCarrierContactsMutation,
    useGetCarrierModeMapsByIdQuery,
    useLazyGetCarrierModeMapsByIdQuery,
    useCreateCarrierModeMapsMutation,
    useModifyCarrierModeMapsMutation,
    useDeleteCarrierModeMapsMutation,
    useGetPayMethodsForCarrierQuery,
    useLazyGetPayMethodsForCarrierQuery,
    useCreateCarrierPayRemitMutation,
    useModifyCarrierPayRemitMutation,
    useDeleteCarrierPayRemitMutation,
    useGetCarrierRemitMethodsQuery,
    useLazyGetCarrierRemitMethodsQuery,
    useGetCarrierRemitDeliveryMethodsQuery,
    useLazyGetCarrierRemitDeliveryMethodsQuery,
    useGetCarrierRemitFormatsQuery,
    useLazyGetCarrierRemitFormatsQuery,
    useGetAchSecCodesQuery,
    useLazyGetAchSecCodesQuery,
    useGetCarrierInvoiceByIdQuery,
    useLazyGetCarrierInvoiceByIdQuery,
    useDeleteInvoiceMutation,
    useGetCarrInvByInvNumQuery,
    useLazyGetCarrInvByInvNumQuery,
    useGetInvoiceSummaryQuery,
    useLazyGetInvoiceSummaryQuery,
    useGetInvoiceLineSummaryQuery,
    useLazyGetInvoiceLineSummaryQuery,
    useGetInvoiceChargeDetailsQuery,
    useLazyGetInvoiceChargeDetailsQuery,
    useGetInvoiceLineChargeDetailsQuery,
    useLazyGetInvoiceLineChargeDetailsQuery,
    useGetBundleInfoQuery,
    useLazyGetBundleInfoQuery,
    useGetAllInvoiceRevsQuery,
    useLazyGetAllInvoiceRevsQuery,
    useCreateMutation,
    useCreateWebInvoiceMutation,
    useUpdateWebInvoiceMutation,
    useInitiateMultiPartInvoiceCreationMutation,
    useMultiPartInvoiceCreationMutation,
    useCompleteMultiPartInvoiceCreationMutation,
    useAbortMultiPartInvoiceCreationMutation,
    useCreateQueuedMutation,
    usePostApiCarrinvCheckqueuedinvoicecreationstateMutation,
    useReAuditMutation,
    useTestAuditMutation,
    useDeleteShipmentMutation,
    useMakeInvoiceMemoMutation,
    useMakeInvoiceRealMutation,
    useReassignInvoiceCustomerMutation,
    useReassignInvoiceNumberMutation,
    useValidateCodingMutation,
    useValidateLineCodingMutation,
    useCreateBillingInvoiceMutation,
    useCreateBillingInvoiceQueuedMutation,
    useCreatePdfInvoiceMutation,
    useCreatePdfInvoiceQueuedMutation,
    useRegeneratePdfInvoiceMutation,
    useGetImagesForInvoiceQuery,
    useLazyGetImagesForInvoiceQuery,
    useAddImageMutation,
    useClearCachedImagesForInvoiceMutation,
    useGetImageWithDataQuery,
    useLazyGetImageWithDataQuery,
    useGetImageWithDataFromObjectMutation,
    useGetInvoiceEdiQuery,
    useLazyGetInvoiceEdiQuery,
    useCarrInvDisconnectImageMutation,
    useWhatIfChargeCodesForNewBilltoQuery,
    useLazyWhatIfChargeCodesForNewBilltoQuery,
    useGetInvoicesForBatchingQuery,
    useLazyGetInvoicesForBatchingQuery,
    useGetAllCarrServicesQuery,
    useLazyGetAllCarrServicesQuery,
    useCreateCarrierServicesMutation,
    useGetCarrierServicesByIdQuery,
    useLazyGetCarrierServicesByIdQuery,
    useModifyCarrierServiceMutation,
    useDeleteCarrierServicesMutation,
    useGetAllowedCarrSvcAuditFnsQuery,
    useLazyGetAllowedCarrSvcAuditFnsQuery,
    useGetTicketQuery,
    useLazyGetTicketQuery,
    useMakeCSaltInvoiceMutation,
    useGetRegisterFbOsQuery,
    useLazyGetRegisterFbOsQuery,
    useGetRegisterInfoMutation,
    useGetAllCmContractsQuery,
    useLazyGetAllCmContractsQuery,
    useCreateCmContractsMutation,
    useModifyCmContractsMutation,
    useDeleteCmContractsMutation,
    useGetAllMasterCodesQuery,
    useLazyGetAllMasterCodesQuery,
    useGetMasterCodesForElementQuery,
    useLazyGetMasterCodesForElementQuery,
    useModifyMasterCodesMutation,
    useGetMasterCodeFiltersQuery,
    useLazyGetMasterCodeFiltersQuery,
    useGetActiveCurrencyCodesQuery,
    useLazyGetActiveCurrencyCodesQuery,
    useGetAuditFailCodesQuery,
    useLazyGetAuditFailCodesQuery,
    useGetPreReqStatusesQuery,
    useLazyGetPreReqStatusesQuery,
    useGetCustomerContactsByIdQuery,
    useLazyGetCustomerContactsByIdQuery,
    useCreateCustomerContactsMutation,
    useModifyCustomerContactsMutation,
    useDeleteCustomerContactsMutation,
    useGetAllCurrenciesQuery,
    useLazyGetAllCurrenciesQuery,
    useGetRefDefsQuery,
    useLazyGetRefDefsQuery,
    useGetCustomerRefDefsQuery,
    useLazyGetCustomerRefDefsQuery,
    useGetRefDefsForInvoiceQuery,
    useLazyGetRefDefsForInvoiceQuery,
    useCreateRefDefMutation,
    useModifyRefDefMutation,
    useDeleteRefDefMutation,
    useCreateAndPrepBatchesMutation,
    useGetChildBatchesQuery,
    useLazyGetChildBatchesQuery,
    useCreateAndPrepBatchesFromInvoicesMutation,
    useGetAgedReceivablesQuery,
    useLazyGetAgedReceivablesQuery,
    useGetListQuery,
    useLazyGetListQuery,
    useUpsertMutation,
    useGetCustPayByBillToIdByIdQuery,
    useLazyGetCustPayByBillToIdByIdQuery,
    useGetCustPaySetupByIdQuery,
    useLazyGetCustPaySetupByIdQuery,
    useCreateCustPaySetupMutation,
    useModifyCustPaySetupMutation,
    useDeleteCustPaySetupMutation,
    useGetShipmentCountByStatusQuery,
    useLazyGetShipmentCountByStatusQuery,
    useGetAgedInvoiceSummaryQuery,
    useLazyGetAgedInvoiceSummaryQuery,
    useGetDataEntryAdminInfoByCustomerQuery,
    useLazyGetDataEntryAdminInfoByCustomerQuery,
    useGetDataEntryAdminInfoForInvoiceQuery,
    useLazyGetDataEntryAdminInfoForInvoiceQuery,
    useModifyDataEntryAdminInfoMutation,
    useDeleteDataEntryAdminInfoMutation,
    useCreateDataEntryAdminInfoMutation,
    useInvoiceResearchExportMutation,
    useGetDataExportsQuery,
    useLazyGetDataExportsQuery,
    useDeleteExportMutation,
    useSendMailWithOutAttachmentsMutation,
    useGetActiveEquipsForDropdownQuery,
    useLazyGetActiveEquipsForDropdownQuery,
    useGetInvoiceHistoryQuery,
    useLazyGetInvoiceHistoryQuery,
    useGetInvoiceRangeMutation,
    useGetInvoiceHistoryDetailsQuery,
    useLazyGetInvoiceHistoryDetailsQuery,
    useGetInvoiceRangeDetailsQuery,
    useLazyGetInvoiceRangeDetailsQuery,
    useGenerateInvoiceDetailReportQuery,
    useLazyGenerateInvoiceDetailReportQuery,
    useDeleteFeesInvoiceMutation,
    useRenameFeesInvoiceMutation,
    useImportInvoicesMutation,
    useGetImportDatesQuery,
    useLazyGetImportDatesQuery,
    useGetImportReportsForDateQuery,
    useLazyGetImportReportsForDateQuery,
    useGetTermsCustomersQuery,
    useLazyGetTermsCustomersQuery,
    useTestNonPayInvoicesMutation,
    useMakeNonPayInvoicesMutation,
    useTestPayInvoicesMutation,
    useMakePayInvoicesMutation,
    useGetCompareRulesQuery,
    useLazyGetCompareRulesQuery,
    useConvertFeesAppRuleMutation,
    useGetCustomerRulesQuery,
    useLazyGetCustomerRulesQuery,
    useGetRuleDataQuery,
    useLazyGetRuleDataQuery,
    useDeleteFeesRuleMutation,
    useCreateFeesRuleMutation,
    useUpdateFeesRuleMutation,
    useSetFeesRuleDetailMutation,
    useGetRuleTypesQuery,
    useLazyGetRuleTypesQuery,
    useGetBillPerTypesQuery,
    useLazyGetBillPerTypesQuery,
    useGetIntDomTypesQuery,
    useLazyGetIntDomTypesQuery,
    useBulkCodingMutation,
    useGetGlCodeForInvoiceMutation,
    usePostHopkinsDepartmentMutation,
    useGetHealthCheckQuery,
    useLazyGetHealthCheckQuery,
    useGetQuery,
    useLazyGetQuery,
    useGetImageQuery,
    useLazyGetImageQuery,
    useDeleteImageMutation,
    useDeleteMultipleImagesMutation,
    useDisconnectImageMutation,
    useDisconnectMultipleImagesMutation,
    useGetDisconnectedImagesQuery,
    useLazyGetDisconnectedImagesQuery,
    useUploadDisconnectedImageMutation,
    useGetDisconnectedImagesQueryableQuery,
    useLazyGetDisconnectedImagesQueryableQuery,
    useGetQueuesQuery,
    useLazyGetQueuesQuery,
    useGetQueueImagesQuery,
    useLazyGetQueueImagesQuery,
    useIndexImageMutation,
    useAddImageToQueueMutation,
    useAddScannedImageMutation,
    useGetScannedImagesQuery,
    useLazyGetScannedImagesQuery,
    useDeleteScannedImagesMutation,
    useGetScannedImageCustomersQuery,
    useLazyGetScannedImageCustomersQuery,
    useUpdateScannedImagesMutation,
    useGetAllowedImageTypesQuery,
    useLazyGetAllowedImageTypesQuery,
    useDeleteUnindexedImageMutation,
    useCustomerImageExtractMutation,
    useReleaseInvoiceMutation,
    useGetBasicInvInfoQuery,
    useLazyGetBasicInvInfoQuery,
    useGetDetailedChargesQuery,
    useLazyGetDetailedChargesQuery,
    useGetReferencesQuery,
    useLazyGetReferencesQuery,
    useUpdateReferencesMutation,
    useGetImagesQuery,
    useLazyGetImagesQuery,
    useUpdateCommentMutation,
    useGetPurgableInvoiceListQuery,
    useLazyGetPurgableInvoiceListQuery,
    useUnbatchReceivableBatchesMutation,
    useUnapproveApprovedBatchesMutation,
    usePurgeInvoiceMutation,
    usePurgeInvoicesFromFileMutation,
    useGetInvoiceResearchPopulationDataQuery,
    useLazyGetInvoiceResearchPopulationDataQuery,
    useSearchInvoicesMutation,
    useReactDataTableServerSideProcessingMutation,
    useGetMakeRealWorkaroundInvoicesQuery,
    useLazyGetMakeRealWorkaroundInvoicesQuery,
    usePostMakeRealWorkaroundInvoicesMutation,
    useGetStatusesForExceptionsQuery,
    useLazyGetStatusesForExceptionsQuery,
    useGetExceptionsForGridQuery,
    useLazyGetExceptionsForGridQuery,
    useSaveCurrentRemarksMutation,
    useAcceptAsEnteredMutation,
    useAcceptAsAuditedMutation,
    useAcceptAsAdjustedMutation,
    useRefuseInvoiceMutation,
    useExceptionManagerDeleteMutation,
    useDeclineServiceFailMutation,
    useApproveServiceFailMutation,
    useMassRefSearchMutation,
    useMassRefUpdateMutation,
    useGetCentralSaltTicketsQuery,
    useLazyGetCentralSaltTicketsQuery,
    useUpdateCentralSaltTicketMutation,
    useGetHarcrosTicketsQuery,
    useLazyGetHarcrosTicketsQuery,
    useGetAvailableAuditFailStatusesQuery,
    useLazyGetAvailableAuditFailStatusesQuery,
    useGetCarrierChargeCodeSourcesQuery,
    useLazyGetCarrierChargeCodeSourcesQuery,
    useGetCustomerDataEntryCodesForUserQuery,
    useLazyGetCustomerDataEntryCodesForUserQuery,
    useGetCustomerDataEntryCodesQuery,
    useLazyGetCustomerDataEntryCodesQuery,
    useGetIa360ReportingLinkQuery,
    useLazyGetIa360ReportingLinkQuery,
    useGetInvoiceStatusCodesQuery,
    useLazyGetInvoiceStatusCodesQuery,
    useGetEntryMethodsQuery,
    useLazyGetEntryMethodsQuery,
    useGetActivityCodesQuery,
    useLazyGetActivityCodesQuery,
    useGetInvoiceTypeListQuery,
    useLazyGetInvoiceTypeListQuery,
    useGetIbobsListQuery,
    useLazyGetIbobsListQuery,
    useGetReportNameListQuery,
    useLazyGetReportNameListQuery,
    useGetQueueIsActiveQuery,
    useLazyGetQueueIsActiveQuery,
    useGetAscRefCodesQuery,
    useLazyGetAscRefCodesQuery,
    useGetAscChargeCodesQuery,
    useLazyGetAscChargeCodesQuery,
    useGetTransportModesQuery,
    useLazyGetTransportModesQuery,
    useGetPartiesQuery,
    useLazyGetPartiesQuery,
    useGetUnMadeAchPaymentsQuery,
    useLazyGetUnMadeAchPaymentsQuery,
    useGenerateAcHesMutation,
    useGetAchDatesQuery,
    useLazyGetAchDatesQuery,
    useGetAchFilesForDateQuery,
    useLazyGetAchFilesForDateQuery,
    useGetCarrierPayableExceptionsByIdQuery,
    useLazyGetCarrierPayableExceptionsByIdQuery,
    useCreateCarrierPayExceptionMutation,
    useModifyCarrierPayExceptionMutation,
    useDeleteCarrierPayExceptionMutation,
    useGetAllPayDayStartsQuery,
    useLazyGetAllPayDayStartsQuery,
    useGetPermittedValsByCustomerQuery,
    useLazyGetPermittedValsByCustomerQuery,
    useGetInvoicePermittedValuesQuery,
    useLazyGetInvoicePermittedValuesQuery,
    useCreatePermittedValueMutation,
    useModifyPermittedValueMutation,
    useDeletePermittedValueMutation,
    useGetPostalCodesQuery,
    useLazyGetPostalCodesQuery,
    useCreatePostalCodeMutation,
    useModifyPostalCodeMutation,
    useDeletePostalCodeMutation,
    useGetAllChecksQuery,
    useLazyGetAllChecksQuery,
    useGetChecksForDateQuery,
    useLazyGetChecksForDateQuery,
    useGetReprintChecksForDateQuery,
    useLazyGetReprintChecksForDateQuery,
    useMakeNewBatchesMutation,
    usePrintChecksMutation,
    useReprintChecksMutation,
    useGetCheckDatesQuery,
    useLazyGetCheckDatesQuery,
    useGetPrintedChecksForDateQuery,
    useLazyGetPrintedChecksForDateQuery,
    useGetReceiptsQuery,
    useLazyGetReceiptsQuery,
    useMergeReceiptsMutation,
    useGetApprovedInvoicesQuery,
    useLazyGetApprovedInvoicesQuery,
    useGetUnappliedCashQuery,
    useLazyGetUnappliedCashQuery,
    useReceiveFundsMutation,
    useUseUnappliedCashMutation,
    useDepositFundsMutation,
    useCreateCreditMutation,
    useGetApiReportingQuery,
    useLazyGetApiReportingQuery,
    useGetBookmarksForUserQuery,
    useLazyGetBookmarksForUserQuery,
    useCreateBookmarkMutation,
    useDeleteBookmarkMutation,
    useGetStatesQuery,
    useLazyGetStatesQuery,
    useCreateStatesMutation,
    useModifyStatesMutation,
    useDeleteStatesMutation,
    useGetTimecardForUserIdQuery,
    useLazyGetTimecardForUserIdQuery,
    useAddTimeCardMutation,
    useDeleteTimeCardMutation,
    useGetUserBillToInfoByCustomerQuery,
    useLazyGetUserBillToInfoByCustomerQuery,
    useCreateUserBillToInfoMutation,
    useDeleteUserBillToInfoMutation,
    useGetMyConfigQuery,
    useLazyGetMyConfigQuery,
    useSaveMyConfigMutation,
    useGetUserConfigurationQuery,
    useLazyGetUserConfigurationQuery,
    useSaveUserConfigMutation,
    useGetRoleAuthsQuery,
    useLazyGetRoleAuthsQuery,
    useCreateNewRoleMutation,
    useUpdateRoleMutation,
    useCopyRoleMutation,
    useGetAllUsersQuery,
    useLazyGetAllUsersQuery,
    useUpdateUserMutation,
    useGetFullUserListQuery,
    useLazyGetFullUserListQuery,
    useGetUserAdminInfoQuery,
    useLazyGetUserAdminInfoQuery,
    useGetKnownCompaniesQuery,
    useLazyGetKnownCompaniesQuery,
    useAddUserMutation,
    useChangePasswordMutation,
    useSuspendUserMutation,
    useGetTimeCardUsersQuery,
    useLazyGetTimeCardUsersQuery,
    useGetUserSessionsForUserQuery,
    useLazyGetUserSessionsForUserQuery,
    useGetMyUserSessionsQuery,
    useLazyGetMyUserSessionsQuery,
    useGetCarrInvStatsForUserQuery,
    useLazyGetCarrInvStatsForUserQuery,
    useGetMyCarrInvStatsQuery,
    useLazyGetMyCarrInvStatsQuery,
} = injectedRtkApi;
